{
  "level": "in01",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:in01",
    "objects": "AREAS.E3:in01.e3",
    "mesh": "TREES.E3:in01.e3"
  },
  "spawn_point": {
    "position": [
      -3865.037294114013,
      -3169.1759345061587,
      1007.4528198242188
    ],
    "facing_rad": 0.0,
    "look_point": [
      -3865.037294114013,
      -3069.1759345061587,
      1007.4528198242188
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -4340.5546875,
      -3479.203125,
      983.4528198242188
    ],
    "bbox_max": [
      -3657.0,
      -3047.300048828125,
      1119.786865234375
    ],
    "vertex_count": 1233,
    "vertices": [
      [
        -3752.5,
        -3136.696533203125,
        1019.7999877929688
      ],
      [
        -3755.0009765625,
        -3136.696533203125,
        1019.7999877929688
      ],
      [
        -3755.699951171875,
        -3128.208740234375,
        1017.75830078125
      ],
      [
        -3752.5,
        -3120.0673828125,
        1019.7999877929688
      ],
      [
        -3752.5,
        -3136.696533203125,
        1019.7999877929688
      ],
      [
        -3752.5,
        -3047.300048828125,
        1012.5
      ],
      [
        -3752.5,
        -3049.800048828125,
        1005.2000122070312
      ],
      [
        -3752.5,
        -3049.800048828125,
        1019.7999877929688
      ],
      [
        -3752.5,
        -3047.300048828125,
        1012.5
      ],
      [
        -3720.173095703125,
        -3088.800048828125,
        1019.7999877929688
      ],
      [
        -3743.08349609375,
        -3088.800048828125,
        1019.7999877929688
      ],
      [
        -3720.173095703125,
        -3088.800048828125,
        1019.7999877929688
      ],
      [
        -3720.718505859375,
        -3088.800048828125,
        1015.4744262695312
      ],
      [
        -3752.5,
        -3072.300048828125,
        1012.5
      ],
      [
        -3752.5,
        -3072.300048828125,
        1012.5
      ],
      [
        -3746.734130859375,
        -3069.800048828125,
        1019.7999877929688
      ],
      [
        -3752.5,
        -3069.800048828125,
        1019.7999877929688
      ],
      [
        -3743.57958984375,
        -3088.780517578125,
        1018.1676635742188
      ],
      [
        -3743.57958984375,
        -3088.780517578125,
        1018.1676635742188
      ],
      [
        -3743.57958984375,
        -3088.800048828125,
        1018.1743774414062
      ],
      [
        -3746.727294921875,
        -3069.800048828125,
        1019.7999877929688
      ],
      [
        -3743.08349609375,
        -3088.800048828125,
        1019.7999877929688
      ],
      [
        -3755.699951171875,
        -3128.208740234375,
        1017.75830078125
      ],
      [
        -3755.699951171875,
        -3111.579833984375,
        1017.7583618164062
      ],
      [
        -3757.50048828125,
        -3047.300048828125,
        1012.5
      ],
      [
        -3755.699951171875,
        -3047.300048828125,
        1012.5
      ],
      [
        -3755.699951171875,
        -3049.800048828125,
        1005.2000122070312
      ],
      [
        -3760.0,
        -3049.800048828125,
        1005.2000122070312
      ],
      [
        -3755.699951171875,
        -3072.300048828125,
        1012.5
      ],
      [
        -3755.699951171875,
        -3047.300048828125,
        1012.5
      ],
      [
        -3757.50048828125,
        -3047.300048828125,
        1012.5
      ],
      [
        -3755.699951171875,
        -3049.100830078125,
        1017.7586059570312
      ],
      [
        -3755.699951171875,
        -3072.300048828125,
        1012.5
      ],
      [
        -3755.699951171875,
        -3070.499267578125,
        1017.7581787109375
      ],
      [
        -3755.699951171875,
        -3111.579833984375,
        1017.7583618164062
      ],
      [
        -3755.0009765625,
        -3120.0673828125,
        1019.7999877929688
      ],
      [
        -3752.5,
        -3120.0673828125,
        1019.7999877929688
      ],
      [
        -3755.0009765625,
        -3049.800048828125,
        1019.7999877929688
      ],
      [
        -3755.0009765625,
        -3069.800048828125,
        1019.7999877929688
      ],
      [
        -3755.699951171875,
        -3136.696533203125,
        1019.7999877929688
      ],
      [
        -3755.699951171875,
        -3120.0673828125,
        1019.7999877929688
      ],
      [
        -3755.699951171875,
        -3070.499267578125,
        1017.7581787109375
      ],
      [
        -3755.699951171875,
        -3069.800048828125,
        1019.7999877929688
      ],
      [
        -3759.999755859375,
        -3049.800048828125,
        1019.7999877929688
      ],
      [
        -3755.699951171875,
        -3049.800048828125,
        1019.7999877929688
      ],
      [
        -3755.699951171875,
        -3049.100830078125,
        1017.7586059570312
      ],
      [
        -3755.699951171875,
        -3120.0673828125,
        1019.7999877929688
      ],
      [
        -3755.699951171875,
        -3136.696533203125,
        1019.7999877929688
      ],
      [
        -3780.0,
        -3047.300048828125,
        1012.5
      ],
      [
        -3780.0,
        -3047.300048828125,
        1012.5
      ],
      [
        -3755.699951171875,
        -3153.0,
        1027.0
      ],
      [
        -3760.0,
        -3153.0,
        1027.0
      ],
      [
        -3760.0,
        -3153.0,
        1023.0
      ],
      [
        -3755.699951171875,
        -3153.0,
        1023.0
      ],
      [
        -3760.0,
        -3150.0,
        1023.0
      ],
      [
        -3760.0,
        -3150.0,
        1027.0
      ],
      [
        -3760.0,
        -3150.0,
        1027.0
      ],
      [
        -3760.0,
        -3153.0,
        1027.0
      ],
      [
        -3755.699951171875,
        -3153.0,
        1027.0
      ],
      [
        -3755.699951171875,
        -3153.0,
        1023.0
      ],
      [
        -3760.0,
        -3153.0,
        1023.0
      ],
      [
        -3760.0,
        -3150.0,
        1023.0
      ],
      [
        -3752.5,
        -3153.0,
        1023.7216186523438
      ],
      [
        -3755.699951171875,
        -3153.0,
        1023.7216186523438
      ],
      [
        -3738.802490234375,
        -3240.800048828125,
        1059.800048828125
      ],
      [
        -3738.802490234375,
        -3203.99755859375,
        1059.800048828125
      ],
      [
        -3746.4248046875,
        -3240.800048828125,
        1072.5999755859375
      ],
      [
        -3746.4248046875,
        -3196.375244140625,
        1072.5999755859375
      ],
      [
        -3758.0,
        -3183.39990234375,
        1059.800048828125
      ],
      [
        -3758.0,
        -3183.39990234375,
        1064.0
      ],
      [
        -3758.0,
        -3183.39990234375,
        1064.0
      ],
      [
        -3758.0,
        -3180.199951171875,
        1064.0
      ],
      [
        -3746.4248046875,
        -3196.375244140625,
        1072.5999755859375
      ],
      [
        -3738.802490234375,
        -3203.99755859375,
        1059.800048828125
      ],
      [
        -3738.802490234375,
        -3240.800048828125,
        1059.800048828125
      ],
      [
        -3746.4248046875,
        -3240.800048828125,
        1072.5999755859375
      ],
      [
        -3779.60009765625,
        -3089.800048828125,
        1023.0
      ],
      [
        -3779.60009765625,
        -3146.4853515625,
        1023.0
      ],
      [
        -3776.400390625,
        -3147.7783203125,
        1019.7999877929688
      ],
      [
        -3776.400390625,
        -3146.4931640625,
        1022.9806518554688
      ],
      [
        -3776.400390625,
        -3146.4853515625,
        1023.0
      ],
      [
        -3776.400390625,
        -3146.4931640625,
        1022.9806518554688
      ],
      [
        -3760.0,
        -3146.4853515625,
        1023.0
      ],
      [
        -3771.50048828125,
        -3119.7685546875,
        1042.5
      ],
      [
        -3768.50048828125,
        -3119.7685546875,
        1042.5
      ],
      [
        -3768.50048828125,
        -3119.7685546875,
        1039.623779296875
      ],
      [
        -3771.50048828125,
        -3119.7685546875,
        1039.623779296875
      ],
      [
        -3768.50048828125,
        -3116.7685546875,
        1042.5
      ],
      [
        -3771.50048828125,
        -3116.7685546875,
        1042.5
      ],
      [
        -3771.50048828125,
        -3116.7685546875,
        1039.623779296875
      ],
      [
        -3768.50048828125,
        -3116.7685546875,
        1039.623779296875
      ],
      [
        -3771.50048828125,
        -3139.7685546875,
        1039.623779296875
      ],
      [
        -3768.50048828125,
        -3139.7685546875,
        1039.623779296875
      ],
      [
        -3768.50048828125,
        -3139.7685546875,
        1042.5
      ],
      [
        -3771.50048828125,
        -3139.7685546875,
        1042.5
      ],
      [
        -3760.0,
        -3139.7685546875,
        1042.5
      ],
      [
        -3779.60009765625,
        -3139.7685546875,
        1042.5
      ],
      [
        -3764.00048828125,
        -3099.800048828125,
        1059.800048828125
      ],
      [
        -3760.0,
        -3094.6611328125,
        1056.0999755859375
      ],
      [
        -3764.00048828125,
        -3094.6611328125,
        1056.0999755859375
      ],
      [
        -3760.0,
        -3139.7685546875,
        1056.0999755859375
      ],
      [
        -3764.00048828125,
        -3139.7685546875,
        1059.800048828125
      ],
      [
        -3764.00048828125,
        -3139.7685546875,
        1056.0999755859375
      ],
      [
        -3776.00048828125,
        -3099.800048828125,
        1059.800048828125
      ],
      [
        -3776.00048828125,
        -3094.6611328125,
        1056.0999755859375
      ],
      [
        -3779.60009765625,
        -3094.6611328125,
        1056.0999755859375
      ],
      [
        -3776.00048828125,
        -3139.7685546875,
        1059.800048828125
      ],
      [
        -3779.60009765625,
        -3139.7685546875,
        1056.0999755859375
      ],
      [
        -3776.00048828125,
        -3139.7685546875,
        1056.0999755859375
      ],
      [
        -3779.60009765625,
        -3237.769287109375,
        1059.800048828125
      ],
      [
        -3779.60009765625,
        -3237.769287109375,
        1072.5999755859375
      ],
      [
        -3960.0,
        -3072.300048828125,
        1015.2000122070312
      ],
      [
        -3960.0,
        -3072.300048828125,
        1029.800048828125
      ],
      [
        -3780.0,
        -3053.14990234375,
        1005.2000122070312
      ],
      [
        -3780.798583984375,
        -3049.00146484375,
        1017.468017578125
      ],
      [
        -3780.798583984375,
        -3049.00146484375,
        1017.468017578125
      ],
      [
        -3780.0,
        -3049.00146484375,
        1017.468017578125
      ],
      [
        -3780.0,
        -3047.4169921875,
        1012.1587524414062
      ],
      [
        -3950.00048828125,
        -3049.799560546875,
        1015.2000122070312
      ],
      [
        -3791.92822265625,
        -3072.300048828125,
        1015.2000122070312
      ],
      [
        -3780.0,
        -3072.300048828125,
        1005.2000122070312
      ],
      [
        -3791.92822265625,
        -3072.300048828125,
        1015.2000122070312
      ],
      [
        -3781.575439453125,
        -3071.37548828125,
        1015.2000122070312
      ],
      [
        -3781.575439453125,
        -3071.37548828125,
        1015.2000122070312
      ],
      [
        -3781.575439453125,
        -3072.300048828125,
        1015.2000122070312
      ],
      [
        -3860.00048828125,
        -3069.804443359375,
        1029.786865234375
      ],
      [
        -3860.00048828125,
        -3072.300048828125,
        1029.786865234375
      ],
      [
        -3840.00048828125,
        -3072.300048828125,
        1029.786865234375
      ],
      [
        -3840.00048828125,
        -3069.804443359375,
        1029.786865234375
      ],
      [
        -3840.00048828125,
        -3069.804443359375,
        1029.786865234375
      ],
      [
        -3840.00048828125,
        -3072.300048828125,
        1029.786865234375
      ],
      [
        -3860.00048828125,
        -3072.300048828125,
        1029.786865234375
      ],
      [
        -3860.00048828125,
        -3069.804443359375,
        1029.786865234375
      ],
      [
        -3780.78759765625,
        -3070.587646484375,
        1017.5001831054688
      ],
      [
        -3780.0,
        -3072.300048828125,
        1019.7999877929688
      ],
      [
        -3780.0,
        -3071.375244140625,
        1019.7999877929688
      ],
      [
        -3780.78759765625,
        -3070.587646484375,
        1017.5001831054688
      ],
      [
        -3860.00048828125,
        -3072.300048828125,
        1015.2066650390625
      ],
      [
        -3860.00048828125,
        -3069.80224609375,
        1015.2066650390625
      ],
      [
        -3840.00048828125,
        -3069.80224609375,
        1015.2066650390625
      ],
      [
        -3840.00048828125,
        -3072.300048828125,
        1015.2066650390625
      ],
      [
        -3860.00048828125,
        -3069.80224609375,
        1015.2066650390625
      ],
      [
        -3860.00048828125,
        -3072.300048828125,
        1015.2066650390625
      ],
      [
        -3840.00048828125,
        -3072.300048828125,
        1015.2066650390625
      ],
      [
        -3840.00048828125,
        -3069.80224609375,
        1015.2066650390625
      ],
      [
        -3950.002685546875,
        -3049.766357421875,
        1015.2066650390625
      ],
      [
        -3950.00048828125,
        -3049.799560546875,
        1015.2000122070312
      ],
      [
        -3950.002685546875,
        -3049.79736328125,
        1015.2066650390625
      ],
      [
        -3950.00048828125,
        -3072.300048828125,
        1015.2000122070312
      ],
      [
        -3930.00048828125,
        -3072.300048828125,
        1015.2000122070312
      ],
      [
        -3950.0,
        -3072.300048828125,
        1029.800048828125
      ],
      [
        -3930.0,
        -3072.300048828125,
        1029.800048828125
      ],
      [
        -3950.00048828125,
        -3072.300048828125,
        1015.2000122070312
      ],
      [
        -3952.50048828125,
        -3072.300048828125,
        1022.5
      ],
      [
        -3950.0,
        -3072.300048828125,
        1029.800048828125
      ],
      [
        -3952.50048828125,
        -3072.300048828125,
        1022.5
      ],
      [
        -3930.00048828125,
        -3072.300048828125,
        1015.2000122070312
      ],
      [
        -3930.0,
        -3072.300048828125,
        1029.800048828125
      ],
      [
        -3960.0,
        -3072.300048828125,
        1029.800048828125
      ],
      [
        -4000.0,
        -3072.300048828125,
        1029.800048828125
      ],
      [
        -4000.0,
        -3072.300048828125,
        1015.2000122070312
      ],
      [
        -3960.0,
        -3072.300048828125,
        1015.2000122070312
      ],
      [
        -4000.0,
        -3072.300048828125,
        1029.800048828125
      ],
      [
        -4000.0,
        -3072.300048828125,
        1015.2000122070312
      ],
      [
        -3782.500244140625,
        -3127.300048828125,
        1012.5003662109375
      ],
      [
        -3922.50048828125,
        -3127.300048828125,
        1012.5003662109375
      ],
      [
        -3812.500244140625,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3826.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3852.500244140625,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3867.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3893.500244140625,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3867.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3852.500244140625,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3826.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3812.500244140625,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3786.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3867.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3893.500244140625,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3826.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3852.500244140625,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3786.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3812.500244140625,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3780.0,
        -3129.805908203125,
        1022.536865234375
      ],
      [
        -3786.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3925.00048828125,
        -3129.805908203125,
        1022.536865234375
      ],
      [
        -3893.500244140625,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3812.500244140625,
        -3129.8046875,
        1022.0
      ],
      [
        -3786.0,
        -3129.8046875,
        1022.0
      ],
      [
        -3852.500244140625,
        -3129.8046875,
        1022.0
      ],
      [
        -3826.0,
        -3129.8046875,
        1022.0
      ],
      [
        -3893.500244140625,
        -3129.8046875,
        1022.0
      ],
      [
        -3867.0,
        -3129.8046875,
        1022.0
      ],
      [
        -3780.0,
        -3127.300048828125,
        1019.7999877929688
      ],
      [
        -3925.00048828125,
        -3127.300048828125,
        1019.7999877929688
      ],
      [
        -3780.0,
        -3127.300048828125,
        1019.7999877929688
      ],
      [
        -3826.0,
        -3129.8046875,
        1022.0
      ],
      [
        -3826.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3786.0,
        -3129.8046875,
        1022.0
      ],
      [
        -3786.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3812.500244140625,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3812.500244140625,
        -3129.8046875,
        1022.0
      ],
      [
        -3867.0,
        -3129.8046875,
        1022.0
      ],
      [
        -3867.0,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3852.500244140625,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3852.500244140625,
        -3129.8046875,
        1022.0
      ],
      [
        -3893.500244140625,
        -3129.805908203125,
        1022.5366821289062
      ],
      [
        -3893.500244140625,
        -3129.8046875,
        1022.0
      ],
      [
        -3905.00048828125,
        -3127.300048828125,
        1119.786865234375
      ],
      [
        -3905.00048828125,
        -3130.015625,
        1119.786865234375
      ],
      [
        -3800.00048828125,
        -3130.015625,
        1119.786865234375
      ],
      [
        -3800.00048828125,
        -3127.300048828125,
        1119.786865234375
      ],
      [
        -3780.0,
        -3129.97216796875,
        1099.786865234375
      ],
      [
        -3780.0,
        -3127.300048828125,
        1099.786865234375
      ],
      [
        -3800.00048828125,
        -3127.300048828125,
        1119.786865234375
      ],
      [
        -3800.00048828125,
        -3130.015625,
        1119.786865234375
      ],
      [
        -3925.00048828125,
        -3127.300048828125,
        1099.786865234375
      ],
      [
        -3925.00048828125,
        -3129.972412109375,
        1099.786865234375
      ],
      [
        -3905.00048828125,
        -3130.015625,
        1119.786865234375
      ],
      [
        -3905.00048828125,
        -3127.300048828125,
        1119.786865234375
      ],
      [
        -3800.0,
        -3129.9150390625,
        1073.1524658203125
      ],
      [
        -3800.0,
        -3127.300048828125,
        1075.767578125
      ],
      [
        -3780.0,
        -3127.300048828125,
        1075.767578125
      ],
      [
        -3780.0,
        -3129.9150390625,
        1073.1524658203125
      ],
      [
        -3800.0,
        -3127.300048828125,
        1056.679931640625
      ],
      [
        -3800.0,
        -3129.88525390625,
        1059.26513671875
      ],
      [
        -3780.0,
        -3129.88525390625,
        1059.26513671875
      ],
      [
        -3780.0,
        -3127.300048828125,
        1056.679931640625
      ],
      [
        -3780.00048828125,
        -3127.300048828125,
        1059.786865234375
      ],
      [
        -3782.944091796875,
        -3129.88623046875,
        1059.8143310546875
      ],
      [
        -3800.00048828125,
        -3129.88671875,
        1059.9737548828125
      ],
      [
        -3800.00048828125,
        -3127.300048828125,
        1059.9737548828125
      ],
      [
        -3843.30126953125,
        -3127.300048828125,
        1056.679931640625
      ],
      [
        -3843.30126953125,
        -3129.88525390625,
        1059.26513671875
      ],
      [
        -3843.519775390625,
        -3129.8876953125,
        1060.3814697265625
      ],
      [
        -3844.028076171875,
        -3127.300048828125,
        1060.38525390625
      ],
      [
        -3843.519775390625,
        -3129.8876953125,
        1060.3814697265625
      ],
      [
        -3843.30126953125,
        -3129.88525390625,
        1059.26513671875
      ],
      [
        -3843.30126953125,
        -3127.300048828125,
        1056.679931640625
      ],
      [
        -3844.028076171875,
        -3127.300048828125,
        1060.38525390625
      ],
      [
        -3800.0,
        -3127.300048828125,
        1059.9737548828125
      ],
      [
        -3800.0,
        -3129.88671875,
        1059.9737548828125
      ],
      [
        -3805.60693359375,
        -3129.88671875,
        1059.9737548828125
      ],
      [
        -3807.8271484375,
        -3127.300048828125,
        1059.9737548828125
      ],
      [
        -3800.0,
        -3127.300048828125,
        1059.9737548828125
      ],
      [
        -3800.0,
        -3129.88671875,
        1059.9737548828125
      ],
      [
        -3800.0,
        -3129.88525390625,
        1059.26513671875
      ],
      [
        -3800.0,
        -3127.300048828125,
        1056.679931640625
      ],
      [
        -3807.8271484375,
        -3127.300048828125,
        1058.9737548828125
      ],
      [
        -3805.858154296875,
        -3129.59375,
        1058.9737548828125
      ],
      [
        -3800.0,
        -3129.59375,
        1058.9737548828125
      ],
      [
        -3800.0,
        -3127.300048828125,
        1058.9737548828125
      ],
      [
        -3807.8271484375,
        -3127.300048828125,
        1059.9737548828125
      ],
      [
        -3805.60693359375,
        -3129.88671875,
        1059.9737548828125
      ],
      [
        -3805.608154296875,
        -3129.88525390625,
        1059.2652587890625
      ],
      [
        -3805.858154296875,
        -3129.59375,
        1058.9737548828125
      ],
      [
        -3807.8271484375,
        -3127.300048828125,
        1058.9737548828125
      ],
      [
        -3780.00048828125,
        -3127.300048828125,
        1072.623779296875
      ],
      [
        -3800.00048828125,
        -3127.300048828125,
        1072.4737548828125
      ],
      [
        -3800.00048828125,
        -3129.91357421875,
        1072.4737548828125
      ],
      [
        -3783.630859375,
        -3129.913818359375,
        1072.5965576171875
      ],
      [
        -3843.498779296875,
        -3129.9130859375,
        1072.1475830078125
      ],
      [
        -3843.30126953125,
        -3129.9150390625,
        1073.1524658203125
      ],
      [
        -3843.30126953125,
        -3127.300048828125,
        1075.767578125
      ],
      [
        -3844.011962890625,
        -3127.300048828125,
        1072.1435546875
      ],
      [
        -3843.30126953125,
        -3127.300048828125,
        1075.767578125
      ],
      [
        -3843.30126953125,
        -3129.9150390625,
        1073.1524658203125
      ],
      [
        -3843.498779296875,
        -3129.9130859375,
        1072.1475830078125
      ],
      [
        -3844.011962890625,
        -3127.300048828125,
        1072.1435546875
      ],
      [
        -3800.0,
        -3129.91357421875,
        1072.4737548828125
      ],
      [
        -3800.0,
        -3127.300048828125,
        1072.4737548828125
      ],
      [
        -3800.0,
        -3127.300048828125,
        1075.767578125
      ],
      [
        -3800.0,
        -3129.9150390625,
        1073.1524658203125
      ],
      [
        -3783.630859375,
        -3129.913818359375,
        1072.5965576171875
      ],
      [
        -3782.944091796875,
        -3129.88623046875,
        1059.8143310546875
      ],
      [
        -3844.63232421875,
        -3127.300048828125,
        1066.2237548828125
      ],
      [
        -3843.935791015625,
        -3129.900146484375,
        1066.2237548828125
      ],
      [
        -3843.511962890625,
        -3129.912841796875,
        1072.08056640625
      ],
      [
        -3844.3203125,
        -3127.300048828125,
        1070.572021484375
      ],
      [
        -3844.3203125,
        -3127.300048828125,
        1070.572021484375
      ],
      [
        -3843.511962890625,
        -3129.912841796875,
        1072.08056640625
      ],
      [
        -3843.935791015625,
        -3129.900146484375,
        1066.2237548828125
      ],
      [
        -3844.63232421875,
        -3127.300048828125,
        1066.2237548828125
      ],
      [
        -3844.63232421875,
        -3127.300048828125,
        1066.2237548828125
      ],
      [
        -3843.935791015625,
        -3129.900146484375,
        1066.2237548828125
      ],
      [
        -3843.519775390625,
        -3129.8876953125,
        1060.3814697265625
      ],
      [
        -3844.3203125,
        -3127.300048828125,
        1061.87548828125
      ],
      [
        -3844.3203125,
        -3127.300048828125,
        1061.87548828125
      ],
      [
        -3843.519775390625,
        -3129.8876953125,
        1060.3814697265625
      ],
      [
        -3843.935791015625,
        -3129.900146484375,
        1066.2237548828125
      ],
      [
        -3844.63232421875,
        -3127.300048828125,
        1066.2237548828125
      ],
      [
        -3844.3203125,
        -3127.300048828125,
        1070.572021484375
      ],
      [
        -3843.511962890625,
        -3129.912841796875,
        1072.08056640625
      ],
      [
        -3843.511962890625,
        -3129.912841796875,
        1072.08056640625
      ],
      [
        -3844.3203125,
        -3127.300048828125,
        1070.572021484375
      ],
      [
        -3844.3203125,
        -3127.300048828125,
        1061.87548828125
      ],
      [
        -3844.3203125,
        -3127.300048828125,
        1061.87548828125
      ],
      [
        -3809.150390625,
        -3129.859619140625,
        1047.4737548828125
      ],
      [
        -3809.150390625,
        -3127.300048828125,
        1047.4737548828125
      ],
      [
        -3821.650390625,
        -3127.300048828125,
        1044.5731201171875
      ],
      [
        -3821.650390625,
        -3129.853271484375,
        1044.5731201171875
      ],
      [
        -3821.650390625,
        -3129.853271484375,
        1044.5731201171875
      ],
      [
        -3821.650390625,
        -3127.300048828125,
        1044.5731201171875
      ],
      [
        -3809.150390625,
        -3127.300048828125,
        1047.4737548828125
      ],
      [
        -3809.150390625,
        -3129.859619140625,
        1047.4737548828125
      ],
      [
        -3821.650390625,
        -3129.853271484375,
        1044.5731201171875
      ],
      [
        -3821.650390625,
        -3127.300048828125,
        1044.5731201171875
      ],
      [
        -3834.150390625,
        -3127.300048828125,
        1047.4737548828125
      ],
      [
        -3834.150390625,
        -3129.859619140625,
        1047.4737548828125
      ],
      [
        -3834.150390625,
        -3129.859619140625,
        1047.4737548828125
      ],
      [
        -3834.150390625,
        -3127.300048828125,
        1047.4737548828125
      ],
      [
        -3821.650390625,
        -3127.300048828125,
        1044.5731201171875
      ],
      [
        -3821.650390625,
        -3129.853271484375,
        1044.5731201171875
      ],
      [
        -3835.61328125,
        -3129.8623046875,
        1048.7406005859375
      ],
      [
        -3840.738037109375,
        -3127.300048828125,
        1053.1787109375
      ],
      [
        -3843.30126953125,
        -3127.300048828125,
        1056.679931640625
      ],
      [
        -3843.30126953125,
        -3129.88525390625,
        1059.26513671875
      ],
      [
        -3843.30126953125,
        -3129.88525390625,
        1059.26513671875
      ],
      [
        -3843.30126953125,
        -3127.300048828125,
        1056.679931640625
      ],
      [
        -3840.738037109375,
        -3127.300048828125,
        1053.1787109375
      ],
      [
        -3835.61328125,
        -3129.8623046875,
        1048.7406005859375
      ],
      [
        -3807.6875,
        -3129.8623046875,
        1048.7406005859375
      ],
      [
        -3802.56298828125,
        -3127.300048828125,
        1053.1787109375
      ],
      [
        -3800.0,
        -3127.300048828125,
        1056.679931640625
      ],
      [
        -3800.0,
        -3129.88525390625,
        1059.26513671875
      ],
      [
        -3800.0,
        -3129.88525390625,
        1059.26513671875
      ],
      [
        -3800.0,
        -3127.300048828125,
        1056.679931640625
      ],
      [
        -3802.56298828125,
        -3127.300048828125,
        1053.1787109375
      ],
      [
        -3807.6875,
        -3129.8623046875,
        1048.7406005859375
      ],
      [
        -3800.212646484375,
        -3129.884521484375,
        1058.9737548828125
      ],
      [
        -3800.0,
        -3129.884521484375,
        1058.9737548828125
      ],
      [
        -3834.150390625,
        -3129.859619140625,
        1047.4737548828125
      ],
      [
        -3834.150390625,
        -3127.300048828125,
        1047.4737548828125
      ],
      [
        -3840.738037109375,
        -3127.300048828125,
        1053.1787109375
      ],
      [
        -3835.61328125,
        -3129.8623046875,
        1048.7406005859375
      ],
      [
        -3835.61328125,
        -3129.8623046875,
        1048.7406005859375
      ],
      [
        -3840.738037109375,
        -3127.300048828125,
        1053.1787109375
      ],
      [
        -3834.150390625,
        -3127.300048828125,
        1047.4737548828125
      ],
      [
        -3834.150390625,
        -3129.859619140625,
        1047.4737548828125
      ],
      [
        -3809.150390625,
        -3129.859619140625,
        1047.4737548828125
      ],
      [
        -3809.150390625,
        -3127.300048828125,
        1047.4737548828125
      ],
      [
        -3802.56298828125,
        -3127.300048828125,
        1053.1787109375
      ],
      [
        -3807.6875,
        -3129.8623046875,
        1048.7406005859375
      ],
      [
        -3807.6875,
        -3129.8623046875,
        1048.7406005859375
      ],
      [
        -3802.56298828125,
        -3127.300048828125,
        1053.1787109375
      ],
      [
        -3809.150390625,
        -3127.300048828125,
        1047.4737548828125
      ],
      [
        -3809.150390625,
        -3129.859619140625,
        1047.4737548828125
      ],
      [
        -3805.608642578125,
        -3129.884521484375,
        1058.9737548828125
      ],
      [
        -3805.608642578125,
        -3129.884521484375,
        1058.9737548828125
      ],
      [
        -3821.650390625,
        -3127.300048828125,
        1087.8743896484375
      ],
      [
        -3821.650390625,
        -3129.94677734375,
        1087.8743896484375
      ],
      [
        -3809.150390625,
        -3129.9404296875,
        1084.9737548828125
      ],
      [
        -3809.150390625,
        -3127.300048828125,
        1084.9737548828125
      ],
      [
        -3809.150390625,
        -3127.300048828125,
        1084.9737548828125
      ],
      [
        -3809.150390625,
        -3129.9404296875,
        1084.9737548828125
      ],
      [
        -3821.650390625,
        -3129.94677734375,
        1087.8743896484375
      ],
      [
        -3821.650390625,
        -3127.300048828125,
        1087.8743896484375
      ],
      [
        -3821.650390625,
        -3127.300048828125,
        1087.8743896484375
      ],
      [
        -3821.650390625,
        -3129.94677734375,
        1087.8743896484375
      ],
      [
        -3834.150390625,
        -3129.9404296875,
        1084.9737548828125
      ],
      [
        -3834.150390625,
        -3127.300048828125,
        1084.9737548828125
      ],
      [
        -3834.150390625,
        -3127.300048828125,
        1084.9737548828125
      ],
      [
        -3834.150390625,
        -3129.9404296875,
        1084.9737548828125
      ],
      [
        -3821.650390625,
        -3129.94677734375,
        1087.8743896484375
      ],
      [
        -3821.650390625,
        -3127.300048828125,
        1087.8743896484375
      ],
      [
        -3843.30126953125,
        -3127.300048828125,
        1075.767578125
      ],
      [
        -3843.30126953125,
        -3129.9150390625,
        1073.1524658203125
      ],
      [
        -3835.4619140625,
        -3129.93798828125,
        1083.837890625
      ],
      [
        -3840.738037109375,
        -3127.300048828125,
        1079.2686767578125
      ],
      [
        -3840.738037109375,
        -3127.300048828125,
        1079.268798828125
      ],
      [
        -3835.4619140625,
        -3129.93798828125,
        1083.837890625
      ],
      [
        -3843.30126953125,
        -3129.9150390625,
        1073.1524658203125
      ],
      [
        -3843.30126953125,
        -3127.300048828125,
        1075.767578125
      ],
      [
        -3807.8388671875,
        -3129.93798828125,
        1083.837890625
      ],
      [
        -3802.56298828125,
        -3127.300048828125,
        1079.2686767578125
      ],
      [
        -3800.0,
        -3127.300048828125,
        1075.767578125
      ],
      [
        -3800.0,
        -3129.9150390625,
        1073.1524658203125
      ],
      [
        -3800.0,
        -3129.9150390625,
        1073.1524658203125
      ],
      [
        -3800.0,
        -3127.300048828125,
        1075.767578125
      ],
      [
        -3802.56298828125,
        -3127.300048828125,
        1079.268798828125
      ],
      [
        -3807.8388671875,
        -3129.93798828125,
        1083.837890625
      ],
      [
        -3834.150390625,
        -3127.300048828125,
        1084.9737548828125
      ],
      [
        -3834.150390625,
        -3129.9404296875,
        1084.9737548828125
      ],
      [
        -3835.4619140625,
        -3129.93798828125,
        1083.837890625
      ],
      [
        -3840.738037109375,
        -3127.300048828125,
        1079.2686767578125
      ],
      [
        -3840.738037109375,
        -3127.300048828125,
        1079.268798828125
      ],
      [
        -3835.4619140625,
        -3129.93798828125,
        1083.837890625
      ],
      [
        -3834.150390625,
        -3129.9404296875,
        1084.9737548828125
      ],
      [
        -3834.150390625,
        -3127.300048828125,
        1084.9737548828125
      ],
      [
        -3809.150390625,
        -3127.300048828125,
        1084.9737548828125
      ],
      [
        -3809.150390625,
        -3129.9404296875,
        1084.9737548828125
      ],
      [
        -3807.8388671875,
        -3129.93798828125,
        1083.837890625
      ],
      [
        -3802.56298828125,
        -3127.300048828125,
        1079.2686767578125
      ],
      [
        -3802.56298828125,
        -3127.300048828125,
        1079.268798828125
      ],
      [
        -3807.8388671875,
        -3129.93798828125,
        1083.837890625
      ],
      [
        -3809.150390625,
        -3129.9404296875,
        1084.9737548828125
      ],
      [
        -3809.150390625,
        -3127.300048828125,
        1084.9737548828125
      ],
      [
        -3820.00048828125,
        -3117.352294921875,
        983.4528198242188
      ],
      [
        -3880.00048828125,
        -3117.352294921875,
        983.4528198242188
      ],
      [
        -3922.50048828125,
        -3124.800048828125,
        1005.2000122070312
      ],
      [
        -3920.324951171875,
        -3124.484619140625,
        1004.2789306640625
      ],
      [
        -3880.00048828125,
        -3117.352294921875,
        983.4528198242188
      ],
      [
        -3920.324951171875,
        -3124.484619140625,
        1004.2789306640625
      ],
      [
        -3782.5,
        -3124.800048828125,
        1005.2000122070312
      ],
      [
        -3813.88427734375,
        -3118.32958984375,
        986.3059692382812
      ],
      [
        -3780.427490234375,
        -3072.300048828125,
        1006.4479370117188
      ],
      [
        -3780.0,
        -3124.7998046875,
        1005.2000122070312
      ],
      [
        -3780.42724609375,
        -3125.22705078125,
        1006.4476928710938
      ],
      [
        -3820.00048828125,
        -3117.352294921875,
        983.4528198242188
      ],
      [
        -3813.88427734375,
        -3118.32958984375,
        986.3059692382812
      ],
      [
        -3782.5,
        -3124.800048828125,
        1005.2000122070312
      ],
      [
        -3782.500244140625,
        -3127.300048828125,
        1012.5003662109375
      ],
      [
        -3782.5,
        -3127.300048828125,
        1059.8101806640625
      ],
      [
        -3782.500244140625,
        -3109.66845703125,
        1059.8101806640625
      ],
      [
        -3782.5,
        -3126.0185546875,
        1055.3984375
      ],
      [
        -3782.500244140625,
        -3113.5185546875,
        1055.3984375
      ],
      [
        -3782.500244140625,
        -3113.5185546875,
        1055.3984375
      ],
      [
        -3780.0,
        -3109.130126953125,
        1059.786865234375
      ],
      [
        -3782.500244140625,
        -3109.10693359375,
        1059.810302734375
      ],
      [
        -3782.5,
        -3127.300048828125,
        1056.679931640625
      ],
      [
        -3782.5,
        -3126.0185546875,
        1055.3984375
      ],
      [
        -3782.500244140625,
        -3109.66845703125,
        1072.60498046875
      ],
      [
        -3782.5,
        -3127.300048828125,
        1072.60498046875
      ],
      [
        -3782.500244140625,
        -3113.5185546875,
        1077.049072265625
      ],
      [
        -3782.5,
        -3126.0185546875,
        1077.049072265625
      ],
      [
        -3780.0,
        -3109.093505859375,
        1072.6239013671875
      ],
      [
        -3782.500244140625,
        -3113.5185546875,
        1077.049072265625
      ],
      [
        -3782.500244140625,
        -3109.07470703125,
        1072.6051025390625
      ],
      [
        -3782.5,
        -3126.0185546875,
        1077.049072265625
      ],
      [
        -3782.5,
        -3127.300048828125,
        1075.767578125
      ],
      [
        -3782.500244140625,
        -3109.66845703125,
        1059.8101806640625
      ],
      [
        -3782.500244140625,
        -3109.66845703125,
        1072.60498046875
      ],
      [
        -3782.500244140625,
        -3107.2685546875,
        1066.2237548828125
      ],
      [
        -3782.500244140625,
        -3108.943359375,
        1072.4737548828125
      ],
      [
        -3782.500244140625,
        -3108.943359375,
        1059.9737548828125
      ],
      [
        -3782.500244140625,
        -3107.2685546875,
        1066.2237548828125
      ],
      [
        -3782.500244140625,
        -3108.943359375,
        1059.9737548828125
      ],
      [
        -3782.500244140625,
        -3108.943359375,
        1072.4737548828125
      ],
      [
        -3922.50048828125,
        -3124.800048828125,
        1005.2000122070312
      ],
      [
        -3922.50048828125,
        -3127.300048828125,
        1012.5003662109375
      ],
      [
        -3798.520263671875,
        -3127.300048828125,
        1056.679931640625
      ],
      [
        -3782.500244140625,
        -3109.10693359375,
        1059.810302734375
      ],
      [
        -3794.7734375,
        -3108.9921875,
        1059.9249267578125
      ],
      [
        -3834.150390625,
        -3099.70703125,
        1060.29296875
      ],
      [
        -3821.650390625,
        -3096.388916015625,
        1060.1761474609375
      ],
      [
        -3821.650390625,
        -3096.388916015625,
        1060.1761474609375
      ],
      [
        -3834.150390625,
        -3099.70703125,
        1060.29296875
      ],
      [
        -3821.650390625,
        -3096.388916015625,
        1060.1761474609375
      ],
      [
        -3809.150390625,
        -3099.769775390625,
        1060.059326171875
      ],
      [
        -3809.150390625,
        -3099.769775390625,
        1060.059326171875
      ],
      [
        -3821.650390625,
        -3096.388916015625,
        1060.1761474609375
      ],
      [
        -3843.30126953125,
        -3108.8349609375,
        1060.37841796875
      ],
      [
        -3834.150390625,
        -3099.70703125,
        1060.29296875
      ],
      [
        -3834.150390625,
        -3099.70703125,
        1060.29296875
      ],
      [
        -3843.30126953125,
        -3108.8349609375,
        1060.37841796875
      ],
      [
        -3800.0,
        -3109.94384765625,
        1058.9737548828125
      ],
      [
        -3800.732421875,
        -3108.943359375,
        1058.9737548828125
      ],
      [
        -3800.732421875,
        -3108.943359375,
        1058.9737548828125
      ],
      [
        -3809.150390625,
        -3099.769775390625,
        1060.059326171875
      ],
      [
        -3809.150390625,
        -3099.769775390625,
        1060.059326171875
      ],
      [
        -3844.846435546875,
        -3123.135009765625,
        1060.3929443359375
      ],
      [
        -3844.846435546875,
        -3116.402099609375,
        1060.3929443359375
      ],
      [
        -3844.846435546875,
        -3116.402099609375,
        1060.3929443359375
      ],
      [
        -3844.846435546875,
        -3123.135009765625,
        1060.3929443359375
      ],
      [
        -3816.8671875,
        -3115.7685546875,
        1060.1314697265625
      ],
      [
        -3816.8671875,
        -3123.7685546875,
        1060.1314697265625
      ],
      [
        -3816.61279296875,
        -3115.7685546875,
        1059.9737548828125
      ],
      [
        -3816.61279296875,
        -3123.7685546875,
        1059.9737548828125
      ],
      [
        -3815.2275390625,
        -3123.7685546875,
        1060.1160888671875
      ],
      [
        -3815.2275390625,
        -3115.7685546875,
        1060.1160888671875
      ],
      [
        -3816.8671875,
        -3123.7685546875,
        1060.1314697265625
      ],
      [
        -3815.2275390625,
        -3123.7685546875,
        1060.1160888671875
      ],
      [
        -3815.2275390625,
        -3115.7685546875,
        1060.1160888671875
      ],
      [
        -3816.8671875,
        -3115.7685546875,
        1060.1314697265625
      ],
      [
        -3843.519287109375,
        -3109.647705078125,
        1060.3804931640625
      ],
      [
        -3843.30126953125,
        -3109.943359375,
        1058.9737548828125
      ],
      [
        -3844.407470703125,
        -3115.582763671875,
        1058.9737548828125
      ],
      [
        -3844.846435546875,
        -3116.402099609375,
        1060.3929443359375
      ],
      [
        -3844.846435546875,
        -3116.402099609375,
        1060.3929443359375
      ],
      [
        -3844.407470703125,
        -3115.582763671875,
        1058.9737548828125
      ],
      [
        -3843.30126953125,
        -3109.943359375,
        1058.9737548828125
      ],
      [
        -3843.519287109375,
        -3109.647705078125,
        1060.3804931640625
      ],
      [
        -3844.028076171875,
        -3127.300048828125,
        1060.38525390625
      ],
      [
        -3843.751220703125,
        -3127.300048828125,
        1058.9737548828125
      ],
      [
        -3844.407470703125,
        -3123.954345703125,
        1058.9737548828125
      ],
      [
        -3844.846435546875,
        -3123.135009765625,
        1060.3929443359375
      ],
      [
        -3844.846435546875,
        -3123.135009765625,
        1060.3929443359375
      ],
      [
        -3844.407470703125,
        -3123.954345703125,
        1058.9737548828125
      ],
      [
        -3843.751220703125,
        -3127.300048828125,
        1058.9737548828125
      ],
      [
        -3844.028076171875,
        -3127.300048828125,
        1060.38525390625
      ],
      [
        -3843.30126953125,
        -3108.8349609375,
        1060.37841796875
      ],
      [
        -3843.519287109375,
        -3109.647705078125,
        1060.3804931640625
      ],
      [
        -3843.519287109375,
        -3109.647705078125,
        1060.3804931640625
      ],
      [
        -3843.30126953125,
        -3108.8349609375,
        1060.37841796875
      ],
      [
        -3848.78173828125,
        -3072.300048828125,
        1038.2772216796875
      ],
      [
        -3848.78173828125,
        -3084.7685546875,
        1038.2772216796875
      ],
      [
        -3859.546875,
        -3072.300048828125,
        1035.7791748046875
      ],
      [
        -3859.546875,
        -3084.7685546875,
        1035.7791748046875
      ],
      [
        -3851.108642578125,
        -3085.876708984375,
        1037.7373046875
      ],
      [
        -3859.146240234375,
        -3085.062255859375,
        1035.8721923828125
      ],
      [
        -3849.390625,
        -3085.37841796875,
        1038.135986328125
      ],
      [
        -3851.108642578125,
        -3085.876708984375,
        1037.7373046875
      ],
      [
        -3849.390625,
        -3085.37841796875,
        1038.135986328125
      ],
      [
        -3848.78173828125,
        -3084.7685546875,
        1038.2772216796875
      ],
      [
        -3859.146240234375,
        -3085.062255859375,
        1035.8721923828125
      ],
      [
        -3859.546875,
        -3085.11376953125,
        1035.7791748046875
      ],
      [
        -3859.546875,
        -3084.7685546875,
        1035.7791748046875
      ],
      [
        -3859.737548828125,
        -3085.138427734375,
        1035.7349853515625
      ],
      [
        -3859.737548828125,
        -3085.138427734375,
        1035.7349853515625
      ],
      [
        -3839.0107421875,
        -3084.7685546875,
        1015.2066650390625
      ],
      [
        -3839.0107421875,
        -3072.300048828125,
        1015.2066650390625
      ],
      [
        -3860.990234375,
        -3072.300048828125,
        1015.2066650390625
      ],
      [
        -3860.990234375,
        -3084.7685546875,
        1015.2066650390625
      ],
      [
        -3840.00048828125,
        -3084.7685546875,
        1035.23291015625
      ],
      [
        -3840.00048828125,
        -3072.300048828125,
        1035.23291015625
      ],
      [
        -3864.5224609375,
        -3072.300048828125,
        1029.786865234375
      ],
      [
        -3860.506103515625,
        -3084.7685546875,
        1034.6239013671875
      ],
      [
        -3864.5224609375,
        -3074.7685546875,
        1029.786865234375
      ],
      [
        -3860.409912109375,
        -3072.300048828125,
        1028.5928955078125
      ],
      [
        -3865.21728515625,
        -3073.03857421875,
        1028.9500732421875
      ],
      [
        -3865.21728515625,
        -3072.300048828125,
        1028.5928955078125
      ],
      [
        -3865.21728515625,
        -3073.03857421875,
        1028.9500732421875
      ],
      [
        -3861.14404296875,
        -3084.7685546875,
        1033.85595703125
      ],
      [
        -3838.85693359375,
        -3084.7685546875,
        1033.85595703125
      ],
      [
        -3844.50048828125,
        -3105.7685546875,
        1031.1927490234375
      ],
      [
        -3855.5009765625,
        -3105.7685546875,
        1031.1925048828125
      ],
      [
        -3860.00048828125,
        -3085.430908203125,
        1014.5936889648438
      ],
      [
        -3860.00048828125,
        -3085.430908203125,
        1014.5936889648438
      ],
      [
        -3860.00048828125,
        -3084.7685546875,
        1014.0147094726562
      ],
      [
        -3863.00048828125,
        -3084.7685546875,
        1017.6277465820312
      ],
      [
        -3838.50048828125,
        -3089.2841796875,
        1020.123779296875
      ],
      [
        -3837.4599609375,
        -3088.257568359375,
        1020.123779296875
      ],
      [
        -3837.4599609375,
        -3088.257568359375,
        1020.123779296875
      ],
      [
        -3837.00048828125,
        -3087.62451171875,
        1020.123779296875
      ],
      [
        -3837.00048828125,
        -3084.7685546875,
        1017.6277465820312
      ],
      [
        -3838.50048828125,
        -3089.2841796875,
        1020.123779296875
      ],
      [
        -3838.50048828125,
        -3089.800048828125,
        1020.123779296875
      ],
      [
        -3838.50048828125,
        -3101.7685546875,
        1020.123779296875
      ],
      [
        -3855.500732421875,
        -3105.7685546875,
        1019.123779296875
      ],
      [
        -3844.50048828125,
        -3105.7685546875,
        1019.123779296875
      ],
      [
        -3856.39990234375,
        -3089.798583984375,
        1020.123779296875
      ],
      [
        -3854.44482421875,
        -3089.800048828125,
        1019.123779296875
      ],
      [
        -3854.44482421875,
        -3099.212890625,
        1019.123779296875
      ],
      [
        -3845.55615234375,
        -3099.212890625,
        1019.123779296875
      ],
      [
        -3845.55615234375,
        -3089.800048828125,
        1019.123779296875
      ],
      [
        -3854.44482421875,
        -3099.212890625,
        1019.123779296875
      ],
      [
        -3845.55615234375,
        -3099.212890625,
        1019.123779296875
      ],
      [
        -3856.400390625,
        -3089.800048828125,
        1020.123779296875
      ],
      [
        -3860.00048828125,
        -3089.7919921875,
        1020.623779296875
      ],
      [
        -3856.400390625,
        -3089.7919921875,
        1020.623779296875
      ],
      [
        -3856.25048828125,
        -3089.7919921875,
        1020.623779296875
      ],
      [
        -3857.6005859375,
        -3089.7919921875,
        1020.623779296875
      ],
      [
        -3860.00048828125,
        -3089.7841796875,
        1021.123779296875
      ],
      [
        -3857.6005859375,
        -3089.7841796875,
        1021.123779296875
      ],
      [
        -3857.50048828125,
        -3089.7841796875,
        1021.123779296875
      ],
      [
        -3858.800537109375,
        -3089.7841796875,
        1021.123779296875
      ],
      [
        -3860.00048828125,
        -3089.7763671875,
        1021.623779296875
      ],
      [
        -3858.800537109375,
        -3089.7763671875,
        1021.623779296875
      ],
      [
        -3858.75048828125,
        -3089.7763671875,
        1021.623779296875
      ],
      [
        -3840.00048828125,
        -3089.7919921875,
        1020.623779296875
      ],
      [
        -3843.6005859375,
        -3089.800048828125,
        1020.123779296875
      ],
      [
        -3843.6005859375,
        -3089.7919921875,
        1020.623779296875
      ],
      [
        -3843.75048828125,
        -3089.7919921875,
        1020.623779296875
      ],
      [
        -3840.00048828125,
        -3089.7841796875,
        1021.123779296875
      ],
      [
        -3842.400390625,
        -3089.7919921875,
        1020.623779296875
      ],
      [
        -3842.400390625,
        -3089.7841796875,
        1021.123779296875
      ],
      [
        -3842.50048828125,
        -3089.7841796875,
        1021.123779296875
      ],
      [
        -3840.00048828125,
        -3089.7763671875,
        1021.623779296875
      ],
      [
        -3841.200439453125,
        -3089.7841796875,
        1021.123779296875
      ],
      [
        -3841.200439453125,
        -3089.7763671875,
        1021.623779296875
      ],
      [
        -3841.25048828125,
        -3089.7763671875,
        1021.623779296875
      ],
      [
        -3844.50048828125,
        -3105.7685546875,
        1023.5548095703125
      ],
      [
        -3855.5009765625,
        -3105.7685546875,
        1023.5550537109375
      ],
      [
        -3838.546142578125,
        -3087.049072265625,
        1034.623779296875
      ],
      [
        -3838.546142578125,
        -3087.049072265625,
        1034.623779296875
      ],
      [
        -3839.49462890625,
        -3084.7685546875,
        1034.623779296875
      ],
      [
        -3843.00048828125,
        -3105.7685546875,
        1019.123779296875
      ],
      [
        -3861.454833984375,
        -3087.049072265625,
        1034.623779296875
      ],
      [
        -3860.50634765625,
        -3084.7685546875,
        1034.623779296875
      ],
      [
        -3861.454833984375,
        -3087.049072265625,
        1034.623779296875
      ],
      [
        -3857.0,
        -3105.7685546875,
        1019.123779296875
      ],
      [
        -3838.829833984375,
        -3086.36669921875,
        1034.623779296875
      ],
      [
        -3782.500244140625,
        -3109.07470703125,
        1072.6051025390625
      ],
      [
        -3826.693359375,
        -3126.7685546875,
        1066.2237548828125
      ],
      [
        -3846.325439453125,
        -3120.374755859375,
        1065.173828125
      ],
      [
        -3846.325439453125,
        -3119.162353515625,
        1065.173828125
      ],
      [
        -3846.325439453125,
        -3119.162353515625,
        1065.173828125
      ],
      [
        -3846.325439453125,
        -3120.374755859375,
        1065.173828125
      ],
      [
        -3780.0,
        -3127.300048828125,
        1005.2000122070312
      ],
      [
        -3922.50048828125,
        -3124.869384765625,
        1005.4025268554688
      ],
      [
        -3780.42724609375,
        -3125.22705078125,
        1006.4476928710938
      ],
      [
        -3780.42724609375,
        -3127.300048828125,
        1006.4476928710938
      ],
      [
        -3922.50048828125,
        -3129.7841796875,
        1012.5
      ],
      [
        -3922.50048828125,
        -3129.7841796875,
        1012.5
      ],
      [
        -3925.0,
        -3224.7685546875,
        1005.2000122070312
      ],
      [
        -3925.0,
        -3184.800048828125,
        1005.2000122070312
      ],
      [
        -3858.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3858.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      [
        -3858.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3858.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3898.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3898.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      [
        -3898.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      [
        -3901.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3901.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3901.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3898.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      [
        -3901.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      [
        -3901.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3898.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3861.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      [
        -3861.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3861.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3861.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3861.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3858.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3861.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3858.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3858.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      [
        -3861.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      [
        -3861.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3858.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3821.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      [
        -3821.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3821.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3821.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3818.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      [
        -3818.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3818.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3818.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3821.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3818.50048828125,
        -3148.093505859375,
        1039.786865234375
      ],
      [
        -3818.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3821.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      [
        -3818.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      [
        -3821.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      [
        -3821.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3818.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      [
        -3812.500244140625,
        -3131.767822265625,
        1022.0
      ],
      [
        -3786.0,
        -3131.767822265625,
        1022.0
      ],
      [
        -3852.500244140625,
        -3131.767822265625,
        1022.0
      ],
      [
        -3826.0,
        -3131.767822265625,
        1022.0
      ],
      [
        -3893.500244140625,
        -3131.767822265625,
        1022.0
      ],
      [
        -3867.0,
        -3131.767822265625,
        1022.0
      ],
      [
        -3826.0,
        -3131.767822265625,
        1022.0
      ],
      [
        -3786.0,
        -3131.767822265625,
        1022.0
      ],
      [
        -3812.500244140625,
        -3131.767822265625,
        1022.0
      ],
      [
        -3867.0,
        -3131.767822265625,
        1022.0
      ],
      [
        -3852.500244140625,
        -3131.767822265625,
        1022.0
      ],
      [
        -3893.500244140625,
        -3131.767822265625,
        1022.0
      ],
      [
        -3858.50048828125,
        -3181.7685546875,
        1076.492919921875
      ],
      [
        -3858.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3898.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3898.50048828125,
        -3181.7685546875,
        1076.492919921875
      ],
      [
        -3901.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3901.50048828125,
        -3181.7685546875,
        1076.492919921875
      ],
      [
        -3898.50048828125,
        -3181.7685546875,
        1076.492919921875
      ],
      [
        -3901.50048828125,
        -3181.7685546875,
        1076.492919921875
      ],
      [
        -3901.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3898.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3861.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3861.50048828125,
        -3181.7685546875,
        1076.492919921875
      ],
      [
        -3858.50048828125,
        -3181.7685546875,
        1076.492919921875
      ],
      [
        -3861.50048828125,
        -3181.7685546875,
        1076.492919921875
      ],
      [
        -3858.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3861.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3821.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3821.50048828125,
        -3181.7685546875,
        1076.492919921875
      ],
      [
        -3818.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3818.50048828125,
        -3181.7685546875,
        1076.492919921875
      ],
      [
        -3818.50048828125,
        -3181.7685546875,
        1076.492919921875
      ],
      [
        -3821.50048828125,
        -3181.7685546875,
        1076.492919921875
      ],
      [
        -3821.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3818.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      [
        -3858.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      [
        -3858.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3858.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3898.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      [
        -3898.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      [
        -3901.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3901.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3898.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      [
        -3901.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      [
        -3861.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      [
        -3861.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3861.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3861.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3858.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3861.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3858.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3858.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      [
        -3861.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      [
        -3821.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      [
        -3821.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3821.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3818.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      [
        -3818.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3818.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3821.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3818.50048828125,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3818.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3821.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      [
        -3818.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      [
        -3821.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      [
        -3800.0,
        -3130.568359375,
        1059.9737548828125
      ],
      [
        -3800.0,
        -3130.568359375,
        1059.9483642578125
      ],
      [
        -3800.0,
        -3130.568359375,
        1072.4737548828125
      ],
      [
        -3800.0,
        -3130.568359375,
        1072.4991455078125
      ],
      [
        -3800.0,
        -3130.568359375,
        1059.9737548828125
      ],
      [
        -3800.635009765625,
        -3130.59375,
        1059.9737548828125
      ],
      [
        -3805.608154296875,
        -3129.88525390625,
        1059.2652587890625
      ],
      [
        -3843.30126953125,
        -3130.7021484375,
        1060.37841796875
      ],
      [
        -3843.30126953125,
        -3130.7021484375,
        1060.37841796875
      ],
      [
        -3843.47607421875,
        -3130.029052734375,
        1072.147705078125
      ],
      [
        -3843.498779296875,
        -3129.9130859375,
        1072.1475830078125
      ],
      [
        -3843.47607421875,
        -3130.029052734375,
        1072.147705078125
      ],
      [
        -3843.498779296875,
        -3129.9130859375,
        1072.1475830078125
      ],
      [
        -3843.30126953125,
        -3130.6806640625,
        1072.1490478515625
      ],
      [
        -3843.47607421875,
        -3130.029052734375,
        1072.147705078125
      ],
      [
        -3843.47607421875,
        -3130.029052734375,
        1072.147705078125
      ],
      [
        -3843.30126953125,
        -3130.6806640625,
        1072.1490478515625
      ],
      [
        -3801.93359375,
        -3133.2353515625,
        1069.83203125
      ],
      [
        -3801.93359375,
        -3133.2353515625,
        1069.83203125
      ],
      [
        -3804.574951171875,
        -3136.843505859375,
        1066.2237548828125
      ],
      [
        -3804.574951171875,
        -3136.843505859375,
        1066.2237548828125
      ],
      [
        -3804.574951171875,
        -3136.843505859375,
        1066.2237548828125
      ],
      [
        -3804.574951171875,
        -3136.843505859375,
        1066.2237548828125
      ],
      [
        -3800.731689453125,
        -3130.59375,
        1058.9737548828125
      ],
      [
        -3800.731689453125,
        -3130.59375,
        1058.9737548828125
      ],
      [
        -3800.212646484375,
        -3129.884521484375,
        1058.9737548828125
      ],
      [
        -3809.150390625,
        -3140.4521484375,
        1062.614990234375
      ],
      [
        -3809.150390625,
        -3140.4521484375,
        1062.614990234375
      ],
      [
        -3898.50048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      [
        -3880.00048828125,
        -3154.2685546875,
        1007.623779296875
      ],
      [
        -3880.00048828125,
        -3154.2685546875,
        1029.464111328125
      ],
      [
        -3880.00048828125,
        -3154.2685546875,
        1029.464111328125
      ],
      [
        -3880.00048828125,
        -3154.2685546875,
        1007.623779296875
      ],
      [
        -3800.00048828125,
        -3154.2685546875,
        1007.623779296875
      ],
      [
        -3800.00048828125,
        -3154.2685546875,
        1029.464111328125
      ],
      [
        -3800.00048828125,
        -3154.2685546875,
        1029.464111328125
      ],
      [
        -3800.00048828125,
        -3154.2685546875,
        1007.623779296875
      ],
      [
        -3800.00048828125,
        -3164.10009765625,
        1022.3794555664062
      ],
      [
        -3794.139404296875,
        -3164.10009765625,
        1025.3099365234375
      ],
      [
        -3794.139404296875,
        -3164.10009765625,
        1025.3099365234375
      ],
      [
        -3800.00048828125,
        -3164.10009765625,
        1022.3794555664062
      ],
      [
        -3880.00048828125,
        -3164.10009765625,
        1022.3794555664062
      ],
      [
        -3874.139404296875,
        -3164.10009765625,
        1025.3099365234375
      ],
      [
        -3874.139404296875,
        -3164.10009765625,
        1025.3099365234375
      ],
      [
        -3880.00048828125,
        -3164.10009765625,
        1022.3794555664062
      ],
      [
        -3805.861572265625,
        -3164.10009765625,
        1025.3099365234375
      ],
      [
        -3800.00048828125,
        -3164.10009765625,
        1022.3794555664062
      ],
      [
        -3800.00048828125,
        -3164.10009765625,
        1022.3794555664062
      ],
      [
        -3805.861572265625,
        -3164.10009765625,
        1025.3099365234375
      ],
      [
        -3885.861572265625,
        -3164.10009765625,
        1025.3099365234375
      ],
      [
        -3880.00048828125,
        -3164.10009765625,
        1022.3794555664062
      ],
      [
        -3880.00048828125,
        -3164.10009765625,
        1022.3794555664062
      ],
      [
        -3885.861572265625,
        -3164.10009765625,
        1025.3099365234375
      ],
      [
        -3920.00048828125,
        -3164.10009765625,
        1005.2000122070312
      ],
      [
        -3922.50048828125,
        -3164.10009765625,
        1012.5
      ],
      [
        -3922.50048828125,
        -3164.10009765625,
        1012.5
      ],
      [
        -3920.000244140625,
        -3164.10009765625,
        1019.7999877929688
      ],
      [
        -3920.000244140625,
        -3164.10009765625,
        1019.7999877929688
      ],
      [
        -3920.00048828125,
        -3164.10009765625,
        1036.786865234375
      ],
      [
        -3920.000244140625,
        -3145.371337890625,
        1036.786865234375
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1019.7999877929688
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      [
        -3922.50048828125,
        -3181.77001953125,
        1012.5
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1019.7999877929688
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1005.2000122070312
      ],
      [
        -3922.50048828125,
        -3181.77001953125,
        1012.5
      ],
      [
        -3901.50048828125,
        -3181.77001953125,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3181.77001953125,
        1039.786865234375
      ],
      [
        -3861.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      [
        -3861.50048828125,
        -3164.7685546875,
        1036.786865234375
      ],
      [
        -3861.50048828125,
        -3164.7685546875,
        1039.786865234375
      ],
      [
        -3861.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      [
        -3821.50048828125,
        -3164.7685546875,
        1039.786865234375
      ],
      [
        -3821.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      [
        -3821.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      [
        -3821.50048828125,
        -3164.7685546875,
        1036.786865234375
      ],
      [
        -3818.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      [
        -3818.50048828125,
        -3164.7685546875,
        1039.786865234375
      ],
      [
        -3818.50048828125,
        -3164.7685546875,
        1036.786865234375
      ],
      [
        -3818.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      [
        -3858.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      [
        -3858.50048828125,
        -3164.7685546875,
        1039.786865234375
      ],
      [
        -3858.50048828125,
        -3164.7685546875,
        1036.786865234375
      ],
      [
        -3858.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3164.7685546875,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3164.7685546875,
        1039.786865234375
      ],
      [
        -3901.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3164.7685546875,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3164.7685546875,
        1036.786865234375
      ],
      [
        -3898.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      [
        -3920.000244140625,
        -3167.7685546875,
        1039.786865234375
      ],
      [
        -3920.000244140625,
        -3164.7685546875,
        1039.786865234375
      ],
      [
        -3920.00048828125,
        -3164.7685546875,
        1036.786865234375
      ],
      [
        -3920.00048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3181.77001953125,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3181.77001953125,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1039.786865234375
      ],
      [
        -3920.000244140625,
        -3148.121337890625,
        1039.786865234375
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1076.49462890625
      ],
      [
        -3898.50048828125,
        -3181.77001953125,
        1056.786865234375
      ],
      [
        -3901.50048828125,
        -3181.77001953125,
        1056.786865234375
      ],
      [
        -3898.50048828125,
        -3181.77001953125,
        1059.786865234375
      ],
      [
        -3898.50048828125,
        -3181.77001953125,
        1056.786865234375
      ],
      [
        -3901.50048828125,
        -3181.77001953125,
        1056.786865234375
      ],
      [
        -3901.50048828125,
        -3181.77001953125,
        1059.786865234375
      ],
      [
        -3901.50048828125,
        -3181.77001953125,
        1059.786865234375
      ],
      [
        -3898.50048828125,
        -3181.77001953125,
        1059.786865234375
      ],
      [
        -3901.50048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3184.77001953125,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3184.77001953125,
        1036.786865234375
      ],
      [
        -3898.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      [
        -3898.50048828125,
        -3184.7685546875,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      [
        -3898.50048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      [
        -3898.50048828125,
        -3184.77001953125,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3184.7685546875,
        1039.786865234375
      ],
      [
        -3901.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      [
        -3901.50048828125,
        -3184.77001953125,
        1036.786865234375
      ],
      [
        -3901.50048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1036.786865234375
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1039.786865234375
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      [
        -3821.50048828125,
        -3184.7685546875,
        1039.786865234375
      ],
      [
        -3821.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      [
        -3821.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      [
        -3821.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      [
        -3818.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      [
        -3818.50048828125,
        -3184.7685546875,
        1039.786865234375
      ],
      [
        -3818.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      [
        -3818.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      [
        -3861.50048828125,
        -3184.7685546875,
        1039.786865234375
      ],
      [
        -3861.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      [
        -3861.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      [
        -3861.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      [
        -3858.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      [
        -3858.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      [
        -3858.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      [
        -3858.50048828125,
        -3184.7685546875,
        1039.786865234375
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1019.7999877929688
      ],
      [
        -3920.030029296875,
        -3184.77001953125,
        1005.28662109375
      ],
      [
        -3925.0,
        -3184.77001953125,
        1005.28662109375
      ],
      [
        -3925.0,
        -3182.2685546875,
        1012.5
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1005.2000122070312
      ],
      [
        -3920.030029296875,
        -3184.77001953125,
        1005.28662109375
      ],
      [
        -3922.00830078125,
        -3181.77001953125,
        1013.9375
      ],
      [
        -3920.030029296875,
        -3184.77001953125,
        1019.71337890625
      ],
      [
        -3925.0,
        -3182.2685546875,
        1012.5
      ],
      [
        -3925.0,
        -3184.77001953125,
        1019.71337890625
      ],
      [
        -3920.030029296875,
        -3184.77001953125,
        1019.71337890625
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1019.7999877929688
      ],
      [
        -3898.50048828125,
        -3184.77001953125,
        1056.786865234375
      ],
      [
        -3901.50048828125,
        -3184.77001953125,
        1056.786865234375
      ],
      [
        -3901.50048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      [
        -3898.50048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      [
        -3898.50048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      [
        -3898.50048828125,
        -3184.77001953125,
        1056.786865234375
      ],
      [
        -3898.50048828125,
        -3184.7685546875,
        1056.786865234375
      ],
      [
        -3898.50048828125,
        -3184.7685546875,
        1059.786865234375
      ],
      [
        -3898.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      [
        -3898.50048828125,
        -3181.7685546875,
        1056.786865234375
      ],
      [
        -3901.50048828125,
        -3184.77001953125,
        1056.786865234375
      ],
      [
        -3901.50048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      [
        -3901.50048828125,
        -3184.7685546875,
        1059.786865234375
      ],
      [
        -3901.50048828125,
        -3184.7685546875,
        1056.786865234375
      ],
      [
        -3901.50048828125,
        -3181.7685546875,
        1056.786865234375
      ],
      [
        -3901.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1056.786865234375
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1059.786865234375
      ],
      [
        -3920.00048828125,
        -3181.77001953125,
        1056.786865234375
      ],
      [
        -3821.50048828125,
        -3184.7685546875,
        1059.786865234375
      ],
      [
        -3821.50048828125,
        -3184.7685546875,
        1056.786865234375
      ],
      [
        -3821.50048828125,
        -3181.7685546875,
        1056.786865234375
      ],
      [
        -3821.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      [
        -3818.50048828125,
        -3184.7685546875,
        1056.786865234375
      ],
      [
        -3818.50048828125,
        -3184.7685546875,
        1059.786865234375
      ],
      [
        -3818.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      [
        -3818.50048828125,
        -3181.7685546875,
        1056.786865234375
      ],
      [
        -3861.50048828125,
        -3184.7685546875,
        1059.786865234375
      ],
      [
        -3861.50048828125,
        -3184.7685546875,
        1056.786865234375
      ],
      [
        -3861.50048828125,
        -3181.7685546875,
        1056.786865234375
      ],
      [
        -3861.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      [
        -3858.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      [
        -3858.50048828125,
        -3181.7685546875,
        1056.786865234375
      ],
      [
        -3858.50048828125,
        -3184.7685546875,
        1056.786865234375
      ],
      [
        -3858.50048828125,
        -3184.7685546875,
        1059.786865234375
      ],
      [
        -3920.00048828125,
        -3184.77001953125,
        1079.767333984375
      ],
      [
        -3797.0,
        -3224.7685546875,
        1079.800048828125
      ],
      [
        -3797.0,
        -3184.800048828125,
        1079.800048828125
      ],
      [
        -3797.0,
        -3216.7685546875,
        1059.796875
      ],
      [
        -3797.0,
        -3224.7685546875,
        1059.796875
      ],
      [
        -3797.0,
        -3224.7685546875,
        1059.796875
      ],
      [
        -3797.0,
        -3215.7685546875,
        1059.796875
      ],
      [
        -3797.0,
        -3215.7685546875,
        1059.796875
      ],
      [
        -3797.0,
        -3215.7685546875,
        1056.605712890625
      ],
      [
        -3797.0,
        -3216.7685546875,
        1056.605712890625
      ],
      [
        -3797.0,
        -3216.7685546875,
        1059.796875
      ],
      [
        -3797.0,
        -3215.7685546875,
        1056.605712890625
      ],
      [
        -3797.0,
        -3216.7685546875,
        1056.605712890625
      ],
      [
        -3850.0,
        -3224.7685546875,
        1079.800048828125
      ],
      [
        -3850.0,
        -3184.800048828125,
        1079.800048828125
      ],
      [
        -3815.0,
        -3209.7685546875,
        1012.1500244140625
      ],
      [
        -3815.0,
        -3210.7685546875,
        1008.9783325195312
      ],
      [
        -3815.0,
        -3209.7685546875,
        1008.9783325195312
      ],
      [
        -3815.0,
        -3209.7685546875,
        1005.2000122070312
      ],
      [
        -3815.0,
        -3200.7685546875,
        1008.9783325195312
      ],
      [
        -3815.0,
        -3201.7685546875,
        1012.1500244140625
      ],
      [
        -3815.0,
        -3201.7685546875,
        1008.9783325195312
      ],
      [
        -3815.0,
        -3201.7685546875,
        1005.2000122070312
      ],
      [
        -3898.5,
        -3224.7685546875,
        1079.800048828125
      ],
      [
        -3898.5,
        -3184.800048828125,
        1079.800048828125
      ],
      [
        -3866.00048828125,
        -3200.7685546875,
        1026.286865234375
      ],
      [
        -3866.00048828125,
        -3200.7685546875,
        1023.123779296875
      ],
      [
        -3866.00048828125,
        -3200.7685546875,
        1059.786865234375
      ],
      [
        -3866.00048828125,
        -3200.7685546875,
        1056.623779296875
      ],
      [
        -3925.0,
        -3224.7685546875,
        1019.7999877929688
      ],
      [
        -3925.0,
        -3184.800048828125,
        1019.7999877929688
      ],
      [
        -3925.0,
        -3184.800048828125,
        1005.2000122070312
      ],
      [
        -3925.0,
        -3184.800048828125,
        1019.7999877929688
      ],
      [
        -3950.0,
        -3115.0,
        1029.800048828125
      ],
      [
        -3952.50048828125,
        -3115.0,
        1022.5
      ],
      [
        -3952.50048828125,
        -3115.0,
        1022.5
      ],
      [
        -3950.00048828125,
        -3115.0,
        1015.2000122070312
      ],
      [
        -3946.50927734375,
        -3182.2685546875,
        1012.5
      ],
      [
        -3945.001708984375,
        -3184.800048828125,
        1005.2000122070312
      ],
      [
        -3946.50927734375,
        -3182.2685546875,
        1012.5
      ],
      [
        -3946.953125,
        -3184.800048828125,
        1005.2000122070312
      ],
      [
        -3940.00048828125,
        -3224.76806640625,
        1012.5
      ],
      [
        -3940.00048828125,
        -3224.76806640625,
        1005.2000122070312
      ],
      [
        -3940.00048828125,
        -3224.76806640625,
        1019.7999877929688
      ],
      [
        -3940.00048828125,
        -3209.768310546875,
        1019.7999877929688
      ],
      [
        -3940.00048828125,
        -3224.76806640625,
        1012.5
      ],
      [
        -3899.980712890625,
        -3264.60009765625,
        1005.2000122070312
      ],
      [
        -3880.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      [
        -3899.980712890625,
        -3264.60009765625,
        1005.2000122070312
      ],
      [
        -3940.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      [
        -3940.00048828125,
        -3264.60009765625,
        1005.264892578125
      ],
      [
        -3940.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      [
        -3940.00048828125,
        -3264.60009765625,
        1019.735107421875
      ],
      [
        -3940.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      [
        -3940.00048828125,
        -3264.60009765625,
        1019.735107421875
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1019.735107421875
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1005.264892578125
      ],
      [
        -3940.00048828125,
        -3264.60009765625,
        1005.264892578125
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1012.5
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1005.264892578125
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1019.735107421875
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1012.5
      ],
      [
        -3898.89990234375,
        -3264.60009765625,
        1016.623779296875
      ],
      [
        -3880.00048828125,
        -3264.60009765625,
        1016.623779296875
      ],
      [
        -3920.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      [
        -3940.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      [
        -3920.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      [
        -3919.978271484375,
        -3264.60009765625,
        1019.7349243164062
      ],
      [
        -3918.912841796875,
        -3244.7685546875,
        1016.623779296875
      ],
      [
        -3918.912841796875,
        -3224.7685546875,
        1016.623779296875
      ],
      [
        -3899.97802734375,
        -3264.60009765625,
        1019.7349243164062
      ],
      [
        -3919.978271484375,
        -3264.60009765625,
        1019.7349243164062
      ],
      [
        -3880.00048828125,
        -3264.60009765625,
        1016.623779296875
      ],
      [
        -3880.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      [
        -3920.00048828125,
        -3225.60009765625,
        1005.2000122070312
      ],
      [
        -3917.50048828125,
        -3225.60009765625,
        1012.5
      ],
      [
        -3917.50048828125,
        -3225.60009765625,
        1012.5
      ],
      [
        -3918.912841796875,
        -3225.60009765625,
        1016.623779296875
      ],
      [
        -3896.89990234375,
        -3264.60009765625,
        1005.2000122070312
      ],
      [
        -3896.89990234375,
        -3264.60009765625,
        1016.5999755859375
      ],
      [
        -4214.13916015625,
        -3340.6875,
        1026.07861328125
      ],
      [
        -4258.64306640625,
        -3379.756591796875,
        1010.9993896484375
      ],
      [
        -4258.64306640625,
        -3379.756591796875,
        1010.9993896484375
      ],
      [
        -4258.8056640625,
        -3379.9912109375,
        1010.9088134765625
      ],
      [
        -4214.13916015625,
        -3340.6875,
        1026.07861328125
      ],
      [
        -4214.12890625,
        -3340.685791015625,
        1026.079345703125
      ],
      [
        -4306.07080078125,
        -3431.590087890625,
        1010.9518432617188
      ],
      [
        -4316.0537109375,
        -3445.42919921875,
        1006.3128662109375
      ],
      [
        -4340.5546875,
        -3479.203125,
        995.0011596679688
      ],
      [
        -4316.0537109375,
        -3445.42919921875,
        1006.3128051757812
      ],
      [
        -4027.950439453125,
        -3339.50390625,
        1026.535400390625
      ],
      [
        -4336.22607421875,
        -3474.480224609375,
        995.0011596679688
      ],
      [
        -4313.90185546875,
        -3443.229736328125,
        1006.074462890625
      ],
      [
        -4304.140625,
        -3429.48291015625,
        1010.9500732421875
      ],
      [
        -4313.90185546875,
        -3443.229736328125,
        1006.0745239257812
      ],
      [
        -4192.56787109375,
        -3375.20849609375,
        1012.7548217773438
      ],
      [
        -4287.40185546875,
        -3421.20703125,
        995.0011596679688
      ],
      [
        -4275.16455078125,
        -3403.633056640625,
        1001.7840576171875
      ],
      [
        -4267.6611328125,
        -3389.658447265625,
        1010.9168701171875
      ],
      [
        -4266.6083984375,
        -3391.267333984375,
        1006.556640625
      ],
      [
        -4275.16455078125,
        -3403.6328125,
        1001.7840576171875
      ],
      [
        -4113.39306640625,
        -3329.743896484375,
        1030.302490234375
      ],
      [
        -4199.7412109375,
        -3338.3056640625,
        1026.997802734375
      ],
      [
        -4113.39306640625,
        -3329.743896484375,
        1030.302490234375
      ],
      [
        -4199.7412109375,
        -3338.3056640625,
        1026.997802734375
      ],
      [
        -4207.80712890625,
        -3339.630126953125,
        1026.4866943359375
      ],
      [
        -4207.80712890625,
        -3339.6298828125,
        1026.4866943359375
      ],
      [
        -4249.34033203125,
        -3379.67724609375,
        995.0011596679688
      ],
      [
        -4254.45458984375,
        -3382.463623046875,
        999.4902954101562
      ],
      [
        -4254.45458984375,
        -3382.463623046875,
        999.4902954101562
      ],
      [
        -4264.15087890625,
        -3387.71630859375,
        1007.92724609375
      ],
      [
        -4024.613525390625,
        -3345.499267578125,
        1011.4553833007812
      ],
      [
        -4075.737548828125,
        -3350.100830078125,
        1021.9727172851562
      ],
      [
        -4077.6240234375,
        -3350.27783203125,
        1022.3770751953125
      ],
      [
        -4075.737548828125,
        -3350.100830078125,
        1021.9727172851562
      ],
      [
        -4227.09716796875,
        -3345.2998046875,
        1010.9993896484375
      ],
      [
        -4214.712890625,
        -3339.769775390625,
        998.3604736328125
      ],
      [
        -4227.09716796875,
        -3345.2998046875,
        1010.9993896484375
      ],
      [
        -4225.06396484375,
        -3350.278076171875,
        1022.3770751953125
      ],
      [
        -4203.6474609375,
        -3338.67578125,
        995.8596801757812
      ],
      [
        -4199.7119140625,
        -3338.300048828125,
        995.0011596679688
      ],
      [
        -4214.712890625,
        -3339.769775390625,
        998.3604736328125
      ],
      [
        -4203.6474609375,
        -3338.67578125,
        995.8596801757812
      ],
      [
        -4214.71240234375,
        -3339.770263671875,
        1023.639404296875
      ],
      [
        -4214.71240234375,
        -3339.770263671875,
        1023.639404296875
      ],
      [
        -4203.65087890625,
        -3338.676513671875,
        1026.1395263671875
      ],
      [
        -4203.64990234375,
        -3338.676513671875,
        1026.139404296875
      ],
      [
        -3880.0,
        -3301.60595703125,
        1025.992919921875
      ],
      [
        -4002.39990234375,
        -3301.60595703125,
        1025.992919921875
      ],
      [
        -3898.89990234375,
        -3273.837646484375,
        1016.623779296875
      ],
      [
        -3880.00048828125,
        -3273.837646484375,
        1016.623779296875
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1016.623779296875
      ],
      [
        -3980.00048828125,
        -3273.837646484375,
        1016.623779296875
      ],
      [
        -3880.00048828125,
        -3273.837646484375,
        1016.623779296875
      ],
      [
        -3880.00048828125,
        -3264.60009765625,
        1011.6766967773438
      ],
      [
        -3980.00048828125,
        -3266.137451171875,
        1012.5
      ],
      [
        -3980.00048828125,
        -3266.137451171875,
        1012.5
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1011.6766357421875
      ],
      [
        -3896.89990234375,
        -3270.8056640625,
        1015.0
      ],
      [
        -3896.89990234375,
        -3273.793212890625,
        1016.5999755859375
      ],
      [
        -3896.89990234375,
        -3265.2001953125,
        1011.9981079101562
      ],
      [
        -3896.89990234375,
        -3264.60009765625,
        1011.6766967773438
      ],
      [
        -3898.89990234375,
        -3270.8056640625,
        1015.0
      ],
      [
        -3898.89990234375,
        -3265.199951171875,
        1011.9979248046875
      ],
      [
        -3898.89990234375,
        -3265.199951171875,
        1011.9979248046875
      ],
      [
        -3898.89990234375,
        -3270.8056640625,
        1015.0
      ],
      [
        -3898.89990234375,
        -3270.8056640625,
        1015.0
      ],
      [
        -3896.89990234375,
        -3270.8056640625,
        1015.0
      ],
      [
        -3898.89990234375,
        -3265.199951171875,
        1011.9979248046875
      ],
      [
        -3896.89990234375,
        -3265.2001953125,
        1011.9981079101562
      ],
      [
        -3880.00048828125,
        -3278.991943359375,
        1017.21337890625
      ],
      [
        -3880.0,
        -3301.60595703125,
        1025.992919921875
      ],
      [
        -3880.00048828125,
        -3277.47314453125,
        1016.623779296875
      ],
      [
        -3880.00048828125,
        -3264.60009765625,
        1011.6260375976562
      ],
      [
        -4002.39990234375,
        -3301.60595703125,
        1025.992919921875
      ],
      [
        -4002.39990234375,
        -3278.989501953125,
        1017.21240234375
      ],
      [
        -3880.00048828125,
        -3278.991943359375,
        1017.21337890625
      ],
      [
        -3899.104248046875,
        -3278.991943359375,
        1017.21337890625
      ],
      [
        -3898.89990234375,
        -3277.47314453125,
        1016.623779296875
      ],
      [
        -3880.00048828125,
        -3277.47314453125,
        1016.623779296875
      ],
      [
        -3980.00048828125,
        -3278.989501953125,
        1017.21240234375
      ],
      [
        -3980.00048828125,
        -3273.837646484375,
        1016.623779296875
      ],
      [
        -3980.00048828125,
        -3277.473388671875,
        1016.623779296875
      ],
      [
        -3980.00048828125,
        -3266.851318359375,
        1012.5
      ],
      [
        -3980.00048828125,
        -3266.851318359375,
        1012.5
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1011.6259765625
      ],
      [
        -3882.60009765625,
        -3276.800048828125,
        1016.3623657226562
      ],
      [
        -3894.0,
        -3276.800048828125,
        1016.3623657226562
      ],
      [
        -3880.0,
        -3276.800048828125,
        1016.3623657226562
      ],
      [
        -3882.60009765625,
        -3276.800048828125,
        1016.3623657226562
      ],
      [
        -3896.89990234375,
        -3276.800048828125,
        1016.3623657226562
      ],
      [
        -3894.0,
        -3276.800048828125,
        1016.3623657226562
      ],
      [
        -3898.89990234375,
        -3276.800048828125,
        1016.5999755859375
      ],
      [
        -3898.89990234375,
        -3277.411865234375,
        1016.5999755859375
      ],
      [
        -3898.89990234375,
        -3276.800048828125,
        1016.3624267578125
      ],
      [
        -3898.89990234375,
        -3273.290771484375,
        1015.0
      ],
      [
        -3898.89990234375,
        -3265.199951171875,
        1011.85888671875
      ],
      [
        -3898.89990234375,
        -3265.199951171875,
        1011.85888671875
      ],
      [
        -3898.89990234375,
        -3273.290771484375,
        1015.0
      ],
      [
        -3898.89990234375,
        -3275.2001953125,
        1015.7412719726562
      ],
      [
        -3896.89990234375,
        -3273.290771484375,
        1015.0
      ],
      [
        -3896.89990234375,
        -3275.2001953125,
        1015.7412719726562
      ],
      [
        -3896.89990234375,
        -3276.800048828125,
        1016.3623657226562
      ],
      [
        -3896.89990234375,
        -3275.2001953125,
        1015.7412719726562
      ],
      [
        -3896.89990234375,
        -3265.2001953125,
        1011.8590087890625
      ],
      [
        -3896.89990234375,
        -3264.60009765625,
        1011.6260375976562
      ],
      [
        -3898.89990234375,
        -3273.290771484375,
        1015.0
      ],
      [
        -3896.89990234375,
        -3273.290771484375,
        1015.0
      ],
      [
        -3898.89990234375,
        -3265.199951171875,
        1011.85888671875
      ],
      [
        -3896.89990234375,
        -3265.2001953125,
        1011.8589477539062
      ],
      [
        -4002.39990234375,
        -3295.723876953125,
        1005.040283203125
      ],
      [
        -3920.581787109375,
        -3279.7685546875,
        1005.2000122070312
      ],
      [
        -3900.00048828125,
        -3275.771728515625,
        1005.2000122070312
      ],
      [
        -3880.00048828125,
        -3271.887939453125,
        1005.2000122070312
      ],
      [
        -3900.00048828125,
        -3275.771728515625,
        1005.2000122070312
      ],
      [
        -3920.582763671875,
        -3279.7685546875,
        1005.2000122070312
      ],
      [
        -3896.89990234375,
        -3264.619873046875,
        1005.2000122070312
      ],
      [
        -3896.89990234375,
        -3264.60009765625,
        1005.2658081054688
      ],
      [
        -3880.00048828125,
        -3264.619873046875,
        1005.2000122070312
      ],
      [
        -3880.00048828125,
        -3264.60009765625,
        1005.2658081054688
      ],
      [
        -3980.00048828125,
        -3264.60009765625,
        1005.3519287109375
      ],
      [
        -3896.89990234375,
        -3265.2001953125,
        1005.3458862304688
      ],
      [
        -3896.89990234375,
        -3275.169677734375,
        1005.2000122070312
      ],
      [
        -3896.89990234375,
        -3275.150146484375,
        1005.246337890625
      ],
      [
        -3896.89990234375,
        -3265.2001953125,
        1005.3458862304688
      ],
      [
        -3896.89990234375,
        -3264.60009765625,
        1005.3518676757812
      ],
      [
        -3898.89990234375,
        -3275.2001953125,
        1005.2457885742188
      ],
      [
        -3898.89990234375,
        -3265.2001953125,
        1005.3458862304688
      ],
      [
        -3898.89990234375,
        -3275.557861328125,
        1005.2000122070312
      ],
      [
        -3898.89990234375,
        -3275.2001953125,
        1005.2457885742188
      ],
      [
        -3898.89990234375,
        -3275.5400390625,
        1005.242431640625
      ],
      [
        -3880.00048828125,
        -3271.887939453125,
        1005.2000122070312
      ],
      [
        -3880.00048828125,
        -3264.60009765625,
        1005.3518676757812
      ],
      [
        -3880.00048828125,
        -3271.8544921875,
        1005.2793579101562
      ],
      [
        -4002.39990234375,
        -3293.08056640625,
        1011.3087158203125
      ],
      [
        -4002.39990234375,
        -3295.723876953125,
        1005.040283203125
      ],
      [
        -4002.39990234375,
        -3288.958740234375,
        1021.0828857421875
      ],
      [
        -4002.39990234375,
        -3293.08056640625,
        1011.3087158203125
      ],
      [
        -3898.89990234375,
        -3273.871337890625,
        1009.2000122070312
      ],
      [
        -3898.89990234375,
        -3275.2001953125,
        1006.0484008789062
      ],
      [
        -3898.89990234375,
        -3273.871337890625,
        1009.2000122070312
      ],
      [
        -3898.89990234375,
        -3271.687744140625,
        1014.377685546875
      ],
      [
        -3898.89990234375,
        -3273.871337890625,
        1009.2000122070312
      ],
      [
        -3898.89990234375,
        -3271.687744140625,
        1014.377685546875
      ],
      [
        -3898.89990234375,
        -3275.2001953125,
        1006.04833984375
      ],
      [
        -3896.89990234375,
        -3273.48291015625,
        1009.2000122070312
      ],
      [
        -3898.89990234375,
        -3273.871337890625,
        1009.2000122070312
      ],
      [
        -3896.89990234375,
        -3273.48291015625,
        1009.2000122070312
      ],
      [
        -3880.00048828125,
        -3268.5341796875,
        1013.1533203125
      ],
      [
        -4002.39990234375,
        -3293.333251953125,
        1011.289306640625
      ],
      [
        -4002.39990234375,
        -3293.2109375,
        1010.9994506835938
      ],
      [
        -4002.39990234375,
        -3299.127685546875,
        1025.03076171875
      ],
      [
        -4002.39990234375,
        -3293.333251953125,
        1011.289306640625
      ],
      [
        -3898.89990234375,
        -3274.799072265625,
        1015.0
      ],
      [
        -3898.89990234375,
        -3273.1123046875,
        1011.0
      ],
      [
        -3898.89990234375,
        -3274.799072265625,
        1015.0
      ],
      [
        -3898.89990234375,
        -3273.1123046875,
        1011.0
      ],
      [
        -3880.00048828125,
        -3269.442138671875,
        1011.0003051757812
      ],
      [
        -3880.00048828125,
        -3270.705322265625,
        1013.9962768554688
      ],
      [
        -3898.89990234375,
        -3274.799072265625,
        1015.0
      ],
      [
        -3896.89990234375,
        -3274.410400390625,
        1015.0
      ],
      [
        -3896.89990234375,
        -3274.410400390625,
        1015.0
      ],
      [
        -3896.89990234375,
        -3274.629638671875,
        1015.519775390625
      ],
      [
        -4002.39990234375,
        -3293.375244140625,
        1011.2860717773438
      ],
      [
        -4002.39990234375,
        -3293.22900390625,
        1010.95654296875
      ],
      [
        -4002.39990234375,
        -3299.55224609375,
        1025.195556640625
      ],
      [
        -4002.39990234375,
        -3293.375244140625,
        1011.2860717773438
      ],
      [
        -3898.89990234375,
        -3275.119140625,
        1015.0
      ],
      [
        -3898.89990234375,
        -3273.224609375,
        1010.7335205078125
      ],
      [
        -3898.89990234375,
        -3275.119140625,
        1015.0
      ],
      [
        -3898.89990234375,
        -3273.224609375,
        1010.7335205078125
      ],
      [
        -3898.89990234375,
        -3275.2001953125,
        1015.18212890625
      ],
      [
        -3898.89990234375,
        -3275.500244140625,
        1015.8577880859375
      ],
      [
        -3880.00048828125,
        -3269.57177734375,
        1010.6926879882812
      ],
      [
        -3880.00048828125,
        -3271.1083984375,
        1014.1527709960938
      ],
      [
        -3898.89990234375,
        -3275.119140625,
        1015.0
      ],
      [
        -3896.89990234375,
        -3274.734619140625,
        1015.0
      ],
      [
        -3896.89990234375,
        -3274.734619140625,
        1015.0
      ],
      [
        -3896.89990234375,
        -3275.035400390625,
        1015.6773071289062
      ],
      [
        -4002.39990234375,
        -3295.89599609375,
        1005.03857421875
      ],
      [
        -3918.913330078125,
        -3279.7685546875,
        1005.2000122070312
      ],
      [
        -3900.00048828125,
        -3276.13134765625,
        1005.2000122070312
      ],
      [
        -3880.00048828125,
        -3272.284912109375,
        1005.2000122070312
      ],
      [
        -3900.00048828125,
        -3276.13134765625,
        1005.2000122070312
      ],
      [
        -3918.912841796875,
        -3279.7685546875,
        1005.2000122070312
      ],
      [
        -3896.89990234375,
        -3275.150146484375,
        1005.246337890625
      ],
      [
        -3896.89990234375,
        -3275.2001953125,
        1005.2457885742188
      ],
      [
        -3896.89990234375,
        -3275.2001953125,
        1005.2457885742188
      ],
      [
        -3896.89990234375,
        -3275.534912109375,
        1005.2000122070312
      ],
      [
        -3896.89990234375,
        -3275.515869140625,
        1005.24267578125
      ],
      [
        -3898.89990234375,
        -3275.919677734375,
        1005.2000122070312
      ],
      [
        -3898.89990234375,
        -3275.5400390625,
        1005.242431640625
      ],
      [
        -3898.89990234375,
        -3275.902587890625,
        1005.23876953125
      ],
      [
        -3880.00048828125,
        -3272.284912109375,
        1005.2000122070312
      ],
      [
        -3880.00048828125,
        -3271.8544921875,
        1005.2793579101562
      ],
      [
        -3880.00048828125,
        -3272.25146484375,
        1005.2753295898438
      ],
      [
        -4002.39990234375,
        -3293.248291015625,
        1011.000244140625
      ],
      [
        -4002.39990234375,
        -3295.89599609375,
        1005.03857421875
      ],
      [
        -3880.00048828125,
        -3269.708740234375,
        1011.0010986328125
      ],
      [
        -3896.89990234375,
        -3273.7587890625,
        1009.2000122070312
      ],
      [
        -3896.89990234375,
        -3275.2001953125,
        1005.9537353515625
      ],
      [
        -3896.89990234375,
        -3275.2001953125,
        1005.9536743164062
      ],
      [
        -3898.89990234375,
        -3274.143310546875,
        1009.2000122070312
      ],
      [
        -3898.89990234375,
        -3275.2001953125,
        1006.81982421875
      ],
      [
        -3898.89990234375,
        -3274.143310546875,
        1009.2000122070312
      ],
      [
        -3898.89990234375,
        -3273.343505859375,
        1011.0010375976562
      ],
      [
        -3898.89990234375,
        -3274.143310546875,
        1009.2000122070312
      ],
      [
        -3898.89990234375,
        -3273.343505859375,
        1011.0010375976562
      ],
      [
        -3898.89990234375,
        -3275.2001953125,
        1006.8202514648438
      ],
      [
        -3898.89990234375,
        -3274.143310546875,
        1009.2000122070312
      ],
      [
        -3896.89990234375,
        -3273.7587890625,
        1009.2000122070312
      ],
      [
        -4216.1845703125,
        -3337.414794921875,
        1004.6229858398438
      ],
      [
        -4220.79931640625,
        -3342.487548828125,
        1004.5722045898438
      ],
      [
        -3880.00048828125,
        -3272.25146484375,
        1005.2753295898438
      ],
      [
        -3880.0,
        -3276.800048828125,
        1005.2297973632812
      ],
      [
        -3882.60009765625,
        -3276.800048828125,
        1005.2297973632812
      ],
      [
        -3896.89990234375,
        -3276.800048828125,
        1005.2297973632812
      ],
      [
        -3894.0,
        -3276.800048828125,
        1005.2297973632812
      ],
      [
        -3894.0,
        -3276.800048828125,
        1005.2297973632812
      ],
      [
        -3882.60009765625,
        -3276.800048828125,
        1005.2297973632812
      ],
      [
        -3898.89990234375,
        -3278.800048828125,
        1005.2097778320312
      ],
      [
        -3898.89990234375,
        -3276.800048828125,
        1005.2000122070312
      ],
      [
        -3898.89990234375,
        -3276.800048828125,
        1005.2297973632812
      ],
      [
        -3896.89990234375,
        -3276.800048828125,
        1005.2297973632812
      ],
      [
        -3896.89990234375,
        -3275.515869140625,
        1005.24267578125
      ],
      [
        -3898.89990234375,
        -3275.902587890625,
        1005.23876953125
      ],
      [
        -4002.39990234375,
        -3299.591064453125,
        1016.623779296875
      ],
      [
        -4002.39990234375,
        -3295.74560546875,
        1016.623779296875
      ],
      [
        -3695.0,
        -3160.0,
        1072.5999755859375
      ],
      [
        -3705.606689453125,
        -3155.313720703125,
        1072.5999755859375
      ],
      [
        -3657.0,
        -3160.0,
        1072.5999755859375
      ],
      [
        -3667.606689453125,
        -3155.313720703125,
        1072.5999755859375
      ],
      [
        -3737.0,
        -3240.800048828125,
        1072.5999755859375
      ],
      [
        -3732.669921875,
        -3243.300048828125,
        1072.5999755859375
      ],
      [
        -3708.000244140625,
        -3273.859619140625,
        1072.5999755859375
      ],
      [
        -3708.000244140625,
        -3276.677490234375,
        1072.5999755859375
      ],
      [
        -3706.591064453125,
        -3275.2685546875,
        1072.5999755859375
      ],
      [
        -3708.000244140625,
        -3275.2685546875,
        1081.84033203125
      ],
      [
        -3708.000244140625,
        -3275.2685546875,
        1072.5999755859375
      ],
      [
        -3709.409423828125,
        -3275.2685546875,
        1072.5999755859375
      ],
      [
        -3708.000244140625,
        -3275.2685546875,
        1059.800048828125
      ],
      [
        -3708.000244140625,
        -3275.2685546875,
        1072.5999755859375
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3780.0,
      "bbox_min": [
        -4008.0,
        -3264.60009765625,
        978.0
      ],
      "bbox_max": [
        -3717.5,
        -3040.0,
        1128.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1019.7999877929688,
      "bbox_min": [
        -3780.0,
        -3240.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3717.5,
        -3047.0,
        1079.800048828125
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1005.2000122070312,
      "bbox_min": [
        -3780.0,
        -3166.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3719.66357421875,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9460787773132324,
        0.0,
        0.3239368498325348
      ],
      "plane_d": -3882.87744140625,
      "bbox_min": [
        -3780.0,
        -3166.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3719.66357421875,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.23386968672275543,
        0.9722679257392883
      ],
      "plane_d": -257.9405517578125,
      "bbox_min": [
        -3760.0,
        -3136.696533203125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3719.66357421875,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3752.5,
      "bbox_min": [
        -3760.0,
        -3136.696533203125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3719.66357421875,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9460592865943909,
        0.323993444442749
      ],
      "plane_d": -3210.969970703125,
      "bbox_min": [
        -3752.5,
        -3088.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3719.66357421875,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9460592865943909,
        -0.323993444442749
      ],
      "plane_d": -2554.883056640625,
      "bbox_min": [
        -3752.5,
        -3088.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3719.66357421875,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.32343733310699463,
        0.9462496638298035
      ],
      "plane_d": 41.7177734375,
      "bbox_min": [
        -3752.5,
        -3088.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3719.66357421875,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9460592865943909,
        0.0,
        0.323993444442749
      ],
      "plane_d": -3847.10009765625,
      "bbox_min": [
        -3752.5,
        -3088.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3719.66357421875,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3088.800048828125,
      "bbox_min": [
        -3752.5,
        -3088.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3719.66357421875,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9460592865943909,
        -0.0,
        -0.323993444442749
      ],
      "plane_d": -3191.01318359375,
      "bbox_min": [
        -3752.5,
        -3088.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3719.66357421875,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.951312780380249,
        -0.10197892785072327,
        -0.29086828231811523
      ],
      "plane_d": -3557.40380859375,
      "bbox_min": [
        -3722.199951171875,
        -3088.800048828125,
        1012.5
      ],
      "bbox_max": [
        -3719.66357421875,
        -3069.800048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9497520327568054,
        -0.10131615400314331,
        -0.29615211486816406
      ],
      "plane_d": -3544.17138671875,
      "bbox_min": [
        -3722.199951171875,
        -3088.800048828125,
        1012.5
      ],
      "bbox_max": [
        -3719.66357421875,
        -3069.800048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9252837300300598,
        0.12267191708087921,
        0.35888949036598206
      ],
      "plane_d": -3428.2685546875,
      "bbox_min": [
        -3752.5,
        -3088.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3719.699951171875,
        -3069.800048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9240537881851196,
        0.12232581526041031,
        0.36216145753860474
      ],
      "plane_d": -3428.06982421875,
      "bbox_min": [
        -3722.199951171875,
        -3088.800048828125,
        1011.6943969726562
      ],
      "bbox_max": [
        -3719.699951171875,
        -3072.300048828125,
        1015.4744262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -7.390111136373889e-07,
        0.9460594654083252,
        0.3239932656288147
      ],
      "plane_d": 2578.53271484375,
      "bbox_min": [
        -3752.5,
        -3072.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3741.10009765625,
        -3069.800048828125,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9460593461990356,
        -0.323993444442749
      ],
      "plane_d": 3234.62158203125,
      "bbox_min": [
        -3752.5,
        -3072.300048828125,
        1012.5
      ],
      "bbox_max": [
        -3743.58203125,
        -3069.800048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9519665837287903,
        -0.09944718331098557,
        -0.28960320353507996
      ],
      "plane_d": 3551.456787109375,
      "bbox_min": [
        -3746.734130859375,
        -3088.800048828125,
        1012.5
      ],
      "bbox_max": [
        -3743.57958984375,
        -3069.800048828125,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9460593461990356,
        -0.323993444442749
      ],
      "plane_d": 3234.62158203125,
      "bbox_min": [
        -3746.734130859375,
        -3072.300048828125,
        1012.5
      ],
      "bbox_max": [
        -3743.58203125,
        -3069.800048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9519665837287903,
        -0.09944718331098557,
        -0.28960320353507996
      ],
      "plane_d": 3551.456787109375,
      "bbox_min": [
        -3746.727294921875,
        -3088.800048828125,
        1012.5
      ],
      "bbox_max": [
        -3741.10009765625,
        -3069.800048828125,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9460593461990356,
        -0.323993444442749
      ],
      "plane_d": 3234.62158203125,
      "bbox_min": [
        -3746.727294921875,
        -3072.300048828125,
        1012.5
      ],
      "bbox_max": [
        -3741.10009765625,
        -3069.800048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3755.699951171875,
      "bbox_min": [
        -3760.0,
        -3128.208740234375,
        1005.2000122070312
      ],
      "bbox_max": [
        -3752.5,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9460592865943909,
        0.323993444442749
      ],
      "plane_d": -3210.969970703125,
      "bbox_min": [
        -3760.0,
        -3072.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3755.699951171875,
        -3047.300048828125,
        1017.7586059570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.473546702385647e-06,
        0.9460587501525879,
        0.32399511337280273
      ],
      "plane_d": 2578.559326171875,
      "bbox_min": [
        -3760.0,
        -3072.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3755.699951171875,
        -3047.300048828125,
        1017.7586059570312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9460592865943909,
        -0.323993444442749
      ],
      "plane_d": -2554.883056640625,
      "bbox_min": [
        -3757.50048828125,
        -3072.300048828125,
        1012.5
      ],
      "bbox_max": [
        -3755.699951171875,
        -3047.300048828125,
        1017.7586059570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9460593461990356,
        -0.323993444442749
      ],
      "plane_d": 3234.62158203125,
      "bbox_min": [
        -3757.5,
        -3072.300048828125,
        1012.5
      ],
      "bbox_max": [
        -3755.699951171875,
        -3070.499267578125,
        1017.7581787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.23386968672275543,
        -0.9722679257392883
      ],
      "plane_d": 261.82965087890625,
      "bbox_min": [
        -3755.699951171875,
        -3120.0673828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3752.5,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9460592865943909,
        -0.323993444442749
      ],
      "plane_d": -2554.883056640625,
      "bbox_min": [
        -3755.699951171875,
        -3076.0,
        1009.2000122070312
      ],
      "bbox_max": [
        -3752.5,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9460593461990356,
        -0.323993444442749
      ],
      "plane_d": 3234.62158203125,
      "bbox_min": [
        -3755.699951171875,
        -3072.300048828125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3752.5,
        -3069.800048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9460599422454834,
        0.32399144768714905
      ],
      "plane_d": 2578.53857421875,
      "bbox_min": [
        -3755.699951171875,
        -3072.300048828125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3752.5,
        -3071.169921875,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9460587501525879,
        5.281247013044776e-06,
        -0.32399508357048035
      ],
      "plane_d": -3226.75439453125,
      "bbox_min": [
        -3780.0,
        -3166.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3755.0009765625,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3755.699951171875,
      "bbox_min": [
        -3760.0,
        -3136.696533203125,
        1012.5
      ],
      "bbox_max": [
        -3755.0009765625,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9460593461990356,
        -0.323993444442749
      ],
      "plane_d": 3234.62158203125,
      "bbox_min": [
        -3760.0,
        -3072.300048828125,
        1012.5
      ],
      "bbox_max": [
        -3755.699951171875,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9460592865943909,
        -0.323993444442749
      ],
      "plane_d": -2554.883056640625,
      "bbox_min": [
        -3759.999755859375,
        -3049.800048828125,
        1012.5
      ],
      "bbox_max": [
        -3755.699951171875,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.23386968672275543,
        -0.9722679257392883
      ],
      "plane_d": 261.82965087890625,
      "bbox_min": [
        -3755.699951171875,
        -3136.696533203125,
        1017.7581787109375
      ],
      "bbox_max": [
        -3755.0009765625,
        -3049.100830078125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9460593461990356,
        -0.323993444442749
      ],
      "plane_d": 3234.62158203125,
      "bbox_min": [
        -3755.699951171875,
        -3070.499267578125,
        1017.7581787109375
      ],
      "bbox_max": [
        -3755.0009765625,
        -3049.100830078125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9460592865943909,
        -0.323993444442749
      ],
      "plane_d": -2554.883056640625,
      "bbox_min": [
        -3755.699951171875,
        -3049.800048828125,
        1017.7586059570312
      ],
      "bbox_max": [
        -3755.0009765625,
        -3049.100830078125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.23386968672275543,
        0.9722679257392883
      ],
      "plane_d": -257.9405517578125,
      "bbox_min": [
        -3755.699951171875,
        -3136.696533203125,
        1017.75830078125
      ],
      "bbox_max": [
        -3755.0009765625,
        -3128.208740234375,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2775242328643799,
        0.9560077786445618,
        -0.09502413868904114
      ],
      "plane_d": 2074.177734375,
      "bbox_min": [
        -3780.0,
        -3166.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3757.50048828125,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31043967604637146,
        0.9505931735038757,
        0.0
      ],
      "plane_d": 1836.401123046875,
      "bbox_min": [
        -3780.0,
        -3166.300048828125,
        1012.5
      ],
      "bbox_max": [
        -3760.0,
        -3159.7685546875,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2775242030620575,
        0.956007719039917,
        0.09502413868904114
      ],
      "plane_d": 1881.75390625,
      "bbox_min": [
        -3780.0,
        -3166.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3757.50048828125,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31043967604637146,
        0.9505931735038757,
        0.0
      ],
      "plane_d": 1836.4012451171875,
      "bbox_min": [
        -3780.0,
        -3166.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3760.0,
        -3159.7685546875,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9460592865943909,
        -0.323993444442749
      ],
      "plane_d": -2554.883056640625,
      "bbox_min": [
        -3780.0,
        -3049.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3757.50048828125,
        -3047.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9460592865943909,
        0.323993444442749
      ],
      "plane_d": -3210.969970703125,
      "bbox_min": [
        -3780.0,
        -3049.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3757.50048828125,
        -3047.300048828125,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3089.800048828125,
      "bbox_min": [
        -3780.0,
        -3240.800048828125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3720.173095703125,
        -3069.800048828125,
        1079.800048828125
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3746.5,
      "bbox_min": [
        -3779.60009765625,
        -3089.800048828125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3720.173095703125,
        -3069.800048828125,
        1046.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3776.5,
      "bbox_min": [
        -3779.60009765625,
        -3089.800048828125,
        1023.0
      ],
      "bbox_max": [
        -3746.5,
        -3076.800048828125,
        1046.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3079.800048828125,
      "bbox_min": [
        -3776.5,
        -3089.800048828125,
        1023.0
      ],
      "bbox_max": [
        -3746.5,
        -3076.800048828125,
        1046.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3768.39990234375,
      "bbox_min": [
        -3771.60009765625,
        -3089.800048828125,
        1034.0
      ],
      "bbox_max": [
        -3746.5,
        -3081.800048828125,
        1046.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3081.800048828125,
      "bbox_min": [
        -3768.39990234375,
        -3084.800048828125,
        1034.0
      ],
      "bbox_max": [
        -3746.5,
        -3081.800048828125,
        1046.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3084.800048828125,
      "bbox_min": [
        -3768.39990234375,
        -3084.800048828125,
        1034.0
      ],
      "bbox_max": [
        -3746.5,
        -3081.800048828125,
        1046.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36183130741119385,
        -0.0,
        0.9322435855865479
      ],
      "plane_d": 391.66107177734375,
      "bbox_min": [
        -3768.39990234375,
        -3084.800048828125,
        1034.0
      ],
      "bbox_max": [
        -3746.5,
        -3081.800048828125,
        1046.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36183130741119385,
        0.0,
        -0.9322435855865479
      ],
      "plane_d": -387.93212890625,
      "bbox_min": [
        -3768.39990234375,
        -3084.800048828125,
        1038.0
      ],
      "bbox_max": [
        -3746.5,
        -3081.800048828125,
        1046.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3771.60009765625,
      "bbox_min": [
        -3771.60009765625,
        -3089.800048828125,
        1042.5
      ],
      "bbox_max": [
        -3768.39990234375,
        -3081.800048828125,
        1046.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1042.5,
      "bbox_min": [
        -3771.60009765625,
        -3089.800048828125,
        1042.5
      ],
      "bbox_max": [
        -3768.39990234375,
        -3081.800048828125,
        1046.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1046.5,
      "bbox_min": [
        -3771.60009765625,
        -3089.800048828125,
        1042.5
      ],
      "bbox_max": [
        -3768.39990234375,
        -3081.800048828125,
        1046.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3081.800048828125,
      "bbox_min": [
        -3771.60009765625,
        -3081.800048828125,
        1042.5
      ],
      "bbox_max": [
        -3768.39990234375,
        -3081.800048828125,
        1046.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3076.800048828125,
      "bbox_min": [
        -3776.5,
        -3079.800048828125,
        1023.0
      ],
      "bbox_max": [
        -3746.5,
        -3076.800048828125,
        1038.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34425464272499084,
        0.0,
        0.9388763308525085
      ],
      "plane_d": -2260.548095703125,
      "bbox_min": [
        -3776.5,
        -3079.800048828125,
        1023.0
      ],
      "bbox_max": [
        -3746.5,
        -3076.800048828125,
        1038.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34425464272499084,
        0.0,
        -0.9388763308525085
      ],
      "plane_d": 2264.3037109375,
      "bbox_min": [
        -3776.5,
        -3079.800048828125,
        1027.0
      ],
      "bbox_max": [
        -3746.5,
        -3076.800048828125,
        1038.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3779.60009765625,
      "bbox_min": [
        -3779.60009765625,
        -3089.800048828125,
        1023.0
      ],
      "bbox_max": [
        -3776.5,
        -3076.800048828125,
        1027.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1023.0,
      "bbox_min": [
        -3779.60009765625,
        -3089.800048828125,
        1023.0
      ],
      "bbox_max": [
        -3776.5,
        -3076.800048828125,
        1027.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1027.0,
      "bbox_min": [
        -3779.60009765625,
        -3089.800048828125,
        1023.0
      ],
      "bbox_max": [
        -3776.5,
        -3076.800048828125,
        1027.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3076.800048828125,
      "bbox_min": [
        -3779.60009765625,
        -3076.800048828125,
        1023.0
      ],
      "bbox_max": [
        -3776.5,
        -3076.800048828125,
        1027.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.32369041442871094,
        -0.9461631178855896
      ],
      "plane_d": -28.7677001953125,
      "bbox_min": [
        -3746.5,
        -3088.800048828125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3720.173095703125,
        -3069.800048828125,
        1038.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3743.5,
      "bbox_min": [
        -3746.5,
        -3084.800048828125,
        1034.0
      ],
      "bbox_max": [
        -3743.5,
        -3076.800048828125,
        1038.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3084.800048828125,
      "bbox_min": [
        -3746.5,
        -3084.800048828125,
        1034.0
      ],
      "bbox_max": [
        -3743.5,
        -3076.800048828125,
        1038.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3076.800048828125,
      "bbox_min": [
        -3746.5,
        -3084.800048828125,
        1034.0
      ],
      "bbox_max": [
        -3743.5,
        -3076.800048828125,
        1038.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1034.0,
      "bbox_min": [
        -3746.5,
        -3084.800048828125,
        1034.0
      ],
      "bbox_max": [
        -3743.5,
        -3076.800048828125,
        1038.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1038.0,
      "bbox_min": [
        -3746.5,
        -3084.800048828125,
        1038.0
      ],
      "bbox_max": [
        -3743.5,
        -3076.800048828125,
        1038.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3088.800048828125,
      "bbox_min": [
        -3743.08349609375,
        -3088.800048828125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3720.173095703125,
        -3069.800048828125,
        1026.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9497520327568054,
        -0.10131615400314331,
        -0.29615211486816406
      ],
      "plane_d": -3544.17138671875,
      "bbox_min": [
        -3743.08349609375,
        -3088.800048828125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3720.173095703125,
        -3069.800048828125,
        1026.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9517341256141663,
        -0.09934829920530319,
        -0.29040002822875977
      ],
      "plane_d": 3551.703125,
      "bbox_min": [
        -3743.08349609375,
        -3088.800048828125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3741.10009765625,
        -3069.800048828125,
        1026.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3759.999755859375,
      "bbox_min": [
        -3780.0,
        -3240.800048828125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3738.802490234375,
        -3089.800048828125,
        1079.800048828125
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3119.89990234375,
      "bbox_min": [
        -3760.0,
        -3240.800048828125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3738.802490234375,
        -3116.699951171875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3180.199951171875,
      "bbox_min": [
        -3760.0,
        -3240.800048828125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3738.802490234375,
        -3119.89990234375,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3752.0,
      "bbox_min": [
        -3760.0,
        -3180.199951171875,
        1019.7999877929688
      ],
      "bbox_max": [
        -3752.0,
        -3119.89990234375,
        1064.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.27871522307395935,
        -0.9603738188743591
      ],
      "plane_d": 135.4676513671875,
      "bbox_min": [
        -3760.0,
        -3180.199951171875,
        1019.7999877929688
      ],
      "bbox_max": [
        -3752.0,
        -3119.89990234375,
        1064.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.27577418088912964,
        0.9612225294113159
      ],
      "plane_d": -141.6866455078125,
      "bbox_min": [
        -3760.0,
        -3180.199951171875,
        1019.7999877929688
      ],
      "bbox_max": [
        -3752.0,
        -3119.89990234375,
        1064.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.23386968672275543,
        -0.9722679257392883
      ],
      "plane_d": 261.82965087890625,
      "bbox_min": [
        -3760.0,
        -3153.0,
        1019.7999877929688
      ],
      "bbox_max": [
        -3752.5,
        -3120.0673828125,
        1027.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3752.5,
      "bbox_min": [
        -3760.0,
        -3153.0,
        1019.7999877929688
      ],
      "bbox_max": [
        -3752.5,
        -3120.0673828125,
        1027.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3755.699951171875,
      "bbox_min": [
        -3760.0,
        -3153.0,
        1019.7999877929688
      ],
      "bbox_max": [
        -3752.5,
        -3120.0673828125,
        1027.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3153.0,
      "bbox_min": [
        -3760.0,
        -3153.0,
        1023.0
      ],
      "bbox_max": [
        -3755.699951171875,
        -3150.0,
        1027.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3150.0,
      "bbox_min": [
        -3760.0,
        -3153.0,
        1023.0
      ],
      "bbox_max": [
        -3755.699951171875,
        -3150.0,
        1027.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1027.0,
      "bbox_min": [
        -3760.0,
        -3153.0,
        1023.0
      ],
      "bbox_max": [
        -3755.699951171875,
        -3150.0,
        1027.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1023.0,
      "bbox_min": [
        -3760.0,
        -3153.0,
        1023.0
      ],
      "bbox_max": [
        -3755.699951171875,
        -3150.0,
        1023.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.23386968672275543,
        0.9722679257392883
      ],
      "plane_d": -257.9405517578125,
      "bbox_min": [
        -3755.699951171875,
        -3153.0,
        1019.7999877929688
      ],
      "bbox_max": [
        -3752.5,
        -3136.696533203125,
        1027.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1023.0,
      "bbox_min": [
        -3755.699951171875,
        -3153.0,
        1023.0
      ],
      "bbox_max": [
        -3752.5,
        -3150.0,
        1023.7216186523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3153.0,
      "bbox_min": [
        -3755.699951171875,
        -3153.0,
        1023.0
      ],
      "bbox_max": [
        -3752.5,
        -3153.0,
        1023.7216186523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3153.0,
      "bbox_min": [
        -3755.699951171875,
        -3153.0,
        1023.7216186523438
      ],
      "bbox_max": [
        -3752.5,
        -3150.0,
        1027.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1027.0,
      "bbox_min": [
        -3755.699951171875,
        -3153.0,
        1027.0
      ],
      "bbox_max": [
        -3752.5,
        -3150.0,
        1027.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3755.0,
      "bbox_min": [
        -3755.0,
        -3180.199951171875,
        1042.5
      ],
      "bbox_max": [
        -3755.0,
        -3119.89990234375,
        1064.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1059.800048828125,
      "bbox_min": [
        -3760.0,
        -3240.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3738.802490234375,
        -3180.199951171875,
        1072.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1072.5999755859375,
      "bbox_min": [
        -3760.0,
        -3240.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3738.802490234375,
        -3180.199951171875,
        1072.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3758.0,
      "bbox_min": [
        -3760.0,
        -3240.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3738.802490234375,
        -3180.199951171875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3184.800048828125,
      "bbox_min": [
        -3760.0,
        -3204.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3758.0,
        -3180.199951171875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3183.39990234375,
      "bbox_min": [
        -3760.0,
        -3183.39990234375,
        1059.800048828125
      ],
      "bbox_max": [
        -3758.0,
        -3180.199951171875,
        1064.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1064.0,
      "bbox_min": [
        -3760.0,
        -3183.39990234375,
        1064.0
      ],
      "bbox_max": [
        -3758.0,
        -3180.199951171875,
        1064.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3204.800048828125,
      "bbox_min": [
        -3760.0,
        -3204.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3758.0,
        -3204.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -4909.30126953125,
      "bbox_min": [
        -3758.0,
        -3240.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3738.802490234375,
        -3180.199951171875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3752.0,
      "bbox_min": [
        -3758.0,
        -3183.39990234375,
        1059.800048828125
      ],
      "bbox_max": [
        -3752.0,
        -3180.199951171875,
        1064.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3183.39990234375,
      "bbox_min": [
        -3758.0,
        -3183.39990234375,
        1059.800048828125
      ],
      "bbox_max": [
        -3752.0,
        -3180.199951171875,
        1064.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1064.0,
      "bbox_min": [
        -3758.0,
        -3183.39990234375,
        1064.0
      ],
      "bbox_max": [
        -3752.0,
        -3180.199951171875,
        1064.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3240.800048828125,
      "bbox_min": [
        -3758.0,
        -3240.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3738.802490234375,
        -3240.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3116.699951171875,
      "bbox_min": [
        -3760.0,
        -3119.89990234375,
        1042.5
      ],
      "bbox_max": [
        -3752.0,
        -3116.699951171875,
        1046.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1042.5,
      "bbox_min": [
        -3760.0,
        -3119.89990234375,
        1042.5
      ],
      "bbox_max": [
        -3752.0,
        -3116.699951171875,
        1046.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1046.5,
      "bbox_min": [
        -3760.0,
        -3119.89990234375,
        1042.5
      ],
      "bbox_max": [
        -3752.0,
        -3116.699951171875,
        1046.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3752.0,
      "bbox_min": [
        -3752.0,
        -3119.89990234375,
        1042.5
      ],
      "bbox_max": [
        -3752.0,
        -3116.699951171875,
        1046.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.800048828125,
      "bbox_min": [
        -3780.0,
        -3237.800048828125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3760.0,
        -3089.800048828125,
        1079.800048828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1023.0,
      "bbox_min": [
        -3779.60009765625,
        -3153.0,
        1019.7999877929688
      ],
      "bbox_max": [
        -3760.0,
        -3089.800048828125,
        1059.800048828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 3776.400146484375,
      "bbox_min": [
        -3779.60009765625,
        -3147.7783203125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3760.0,
        -3089.800048828125,
        1023.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3779.60009765625,
      "bbox_min": [
        -3779.60009765625,
        -3147.7783203125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3776.400390625,
        -3089.800048828125,
        1023.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9271758198738098,
        -0.374626487493515
      ],
      "plane_d": 3300.588134765625,
      "bbox_min": [
        -3779.60009765625,
        -3147.7783203125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3776.400390625,
        -3146.4853515625,
        1023.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.6035021417337703e-06,
        0.927176833152771,
        -0.3746240437030792
      ],
      "plane_d": 3300.5947265625,
      "bbox_min": [
        -3776.400390625,
        -3147.7783203125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3760.0,
        -3146.4853515625,
        1023.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3779.60009765625,
      "bbox_min": [
        -3779.60009765625,
        -3153.0,
        1023.0
      ],
      "bbox_max": [
        -3760.0,
        -3089.800048828125,
        1059.800048828125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1039.623779296875,
      "bbox_min": [
        -3779.60009765625,
        -3153.0,
        1023.0
      ],
      "bbox_max": [
        -3760.0,
        -3089.800048828125,
        1059.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1042.5,
      "bbox_min": [
        -3779.60009765625,
        -3139.7685546875,
        1039.623779296875
      ],
      "bbox_max": [
        -3760.0,
        -3089.800048828125,
        1059.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3771.50048828125,
      "bbox_min": [
        -3779.60009765625,
        -3139.7685546875,
        1039.623779296875
      ],
      "bbox_max": [
        -3760.0,
        -3089.800048828125,
        1042.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3768.50048828125,
      "bbox_min": [
        -3771.50048828125,
        -3139.7685546875,
        1039.623779296875
      ],
      "bbox_max": [
        -3760.0,
        -3089.800048828125,
        1042.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3119.7685546875,
      "bbox_min": [
        -3771.50048828125,
        -3139.7685546875,
        1039.623779296875
      ],
      "bbox_max": [
        -3768.50048828125,
        -3116.7685546875,
        1042.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3116.7685546875,
      "bbox_min": [
        -3771.50048828125,
        -3116.7685546875,
        1039.623779296875
      ],
      "bbox_max": [
        -3768.50048828125,
        -3116.7685546875,
        1042.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3139.7685546875,
      "bbox_min": [
        -3771.50048828125,
        -3139.7685546875,
        1039.623779296875
      ],
      "bbox_max": [
        -3768.50048828125,
        -3139.7685546875,
        1042.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3119.7685546875,
      "bbox_min": [
        -3768.50048828125,
        -3139.7685546875,
        1039.623779296875
      ],
      "bbox_max": [
        -3760.0,
        -3116.7685546875,
        1042.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3116.7685546875,
      "bbox_min": [
        -3768.50048828125,
        -3116.7685546875,
        1039.623779296875
      ],
      "bbox_max": [
        -3760.0,
        -3116.7685546875,
        1042.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3139.7685546875,
      "bbox_min": [
        -3768.50048828125,
        -3139.7685546875,
        1039.623779296875
      ],
      "bbox_max": [
        -3760.0,
        -3139.7685546875,
        1042.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3119.7685546875,
      "bbox_min": [
        -3779.60009765625,
        -3139.7685546875,
        1039.623779296875
      ],
      "bbox_max": [
        -3771.50048828125,
        -3116.7685546875,
        1042.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3116.7685546875,
      "bbox_min": [
        -3779.60009765625,
        -3116.7685546875,
        1039.623779296875
      ],
      "bbox_max": [
        -3771.50048828125,
        -3116.7685546875,
        1042.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3139.7685546875,
      "bbox_min": [
        -3779.60009765625,
        -3139.7685546875,
        1039.623779296875
      ],
      "bbox_max": [
        -3771.50048828125,
        -3139.7685546875,
        1042.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1056.0999755859375,
      "bbox_min": [
        -3779.60009765625,
        -3139.7685546875,
        1042.5
      ],
      "bbox_max": [
        -3760.0,
        -3089.800048828125,
        1059.800048828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3764.00048828125,
      "bbox_min": [
        -3779.60009765625,
        -3139.7685546875,
        1056.0999755859375
      ],
      "bbox_max": [
        -3760.0,
        -3094.6611328125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5843086838722229,
        -0.8115315437316895
      ],
      "plane_d": -951.178955078125,
      "bbox_min": [
        -3764.00048828125,
        -3139.7685546875,
        1056.0999755859375
      ],
      "bbox_max": [
        -3760.0,
        -3094.6611328125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3139.7685546875,
      "bbox_min": [
        -3764.00048828125,
        -3139.7685546875,
        1056.0999755859375
      ],
      "bbox_max": [
        -3760.0,
        -3139.7685546875,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3776.00048828125,
      "bbox_min": [
        -3779.60009765625,
        -3139.7685546875,
        1056.0999755859375
      ],
      "bbox_max": [
        -3764.00048828125,
        -3094.6611328125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5843086838722229,
        -0.8115315437316895
      ],
      "plane_d": -951.178955078125,
      "bbox_min": [
        -3779.60009765625,
        -3139.7685546875,
        1056.0999755859375
      ],
      "bbox_max": [
        -3776.00048828125,
        -3094.6611328125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3139.7685546875,
      "bbox_min": [
        -3779.60009765625,
        -3139.7685546875,
        1056.0999755859375
      ],
      "bbox_max": [
        -3776.00048828125,
        -3139.7685546875,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5843086838722229,
        -0.8115315437316895
      ],
      "plane_d": -951.178955078125,
      "bbox_min": [
        -3776.00048828125,
        -3139.7685546875,
        1056.0999755859375
      ],
      "bbox_max": [
        -3764.00048828125,
        -3094.6611328125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3099.800048828125,
      "bbox_min": [
        -3776.00048828125,
        -3139.7685546875,
        1056.0999755859375
      ],
      "bbox_max": [
        -3764.00048828125,
        -3099.800048828125,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3139.7685546875,
      "bbox_min": [
        -3776.00048828125,
        -3139.7685546875,
        1056.0999755859375
      ],
      "bbox_max": [
        -3764.00048828125,
        -3139.7685546875,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3139.7685546875,
      "bbox_min": [
        -3779.60009765625,
        -3139.7685546875,
        1042.5
      ],
      "bbox_max": [
        -3760.0,
        -3089.800048828125,
        1056.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5843086838722229,
        -0.8115315437316895
      ],
      "plane_d": -951.178955078125,
      "bbox_min": [
        -3779.60009765625,
        -3094.6611328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3760.0,
        -3089.800048828125,
        1056.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.6035021417337703e-06,
        0.927176833152771,
        -0.3746240437030792
      ],
      "plane_d": 3300.5947265625,
      "bbox_min": [
        -3779.60009765625,
        -3153.0,
        1023.0
      ],
      "bbox_max": [
        -3760.0,
        -3139.7685546875,
        1039.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1027.0,
      "bbox_min": [
        -3779.60009765625,
        -3153.0,
        1023.0
      ],
      "bbox_max": [
        -3760.0,
        -3144.869140625,
        1027.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3150.0,
      "bbox_min": [
        -3776.5,
        -3150.0,
        1023.0
      ],
      "bbox_max": [
        -3760.0,
        -3144.869140625,
        1027.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3776.5,
      "bbox_min": [
        -3776.5,
        -3150.0,
        1023.0
      ],
      "bbox_max": [
        -3776.5,
        -3144.869140625,
        1027.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1072.5999755859375,
      "bbox_min": [
        -3780.0,
        -3237.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3760.0,
        -3099.800048828125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1079.7999267578125,
      "bbox_min": [
        -3780.0,
        -3237.800048828125,
        1072.5999755859375
      ],
      "bbox_max": [
        -3760.0,
        -3178.2001953125,
        1079.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2081708163022995,
        0.20849911868572235,
        -0.9556112885475159
      ],
      "plane_d": 917.3447875976562,
      "bbox_min": [
        -3780.0,
        -3237.800048828125,
        1072.5999755859375
      ],
      "bbox_max": [
        -3760.0,
        -3178.2001953125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0007629509782418609,
        0.48450347781181335,
        -0.8747890591621399
      ],
      "plane_d": 2509.892822265625,
      "bbox_min": [
        -3780.0,
        -3237.800048828125,
        1072.5999755859375
      ],
      "bbox_max": [
        -3760.0,
        -3178.2001953125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.737165093421936,
        -0.6757127642631531
      ],
      "plane_d": -1618.088623046875,
      "bbox_min": [
        -3780.0,
        -3184.800048828125,
        1072.5999755859375
      ],
      "bbox_max": [
        -3760.0,
        -3178.2001953125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3779.60009765625,
      "bbox_min": [
        -3780.0,
        -3237.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3760.0,
        -3099.800048828125,
        1072.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.737052321434021,
        -0.6758357286453247
      ],
      "plane_d": -1617.598388671875,
      "bbox_min": [
        -3780.0,
        -3237.769287109375,
        1059.800048828125
      ],
      "bbox_max": [
        -3779.60009765625,
        -3109.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3109.800048828125,
      "bbox_min": [
        -3780.0,
        -3129.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3779.60009765625,
        -3109.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3129.800048828125,
      "bbox_min": [
        -3780.0,
        -3129.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3779.60009765625,
        -3129.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0015747050056234002,
        0.9999987483024597,
        -0.0
      ],
      "plane_d": 3243.716796875,
      "bbox_min": [
        -3780.0,
        -3237.769287109375,
        1059.800048828125
      ],
      "bbox_max": [
        -3779.60009765625,
        -3237.7685546875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0015747050056234002,
        0.9999987483024597,
        -0.0
      ],
      "plane_d": 3243.716796875,
      "bbox_min": [
        -3779.60009765625,
        -3237.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3760.0,
        -3099.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3099.800048828125,
      "bbox_min": [
        -3779.60009765625,
        -3099.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3760.0,
        -3099.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3072.300048828125,
      "bbox_min": [
        -4008.0,
        -3264.60009765625,
        982.623779296875
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1128.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3960.0,
      "bbox_min": [
        -4000.0,
        -3072.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9460601210594177,
        -0.3239910304546356
      ],
      "plane_d": -2551.648193359375,
      "bbox_min": [
        -3952.50048828125,
        -3072.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1029.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.947304904460907,
        0.3203330934047699
      ],
      "plane_d": -3214.2626953125,
      "bbox_min": [
        -3952.50048828125,
        -3072.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1029.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.27531054615974426,
        -0.0,
        0.9613553881645203
      ],
      "plane_d": 74.31939697265625,
      "bbox_min": [
        -3817.4189453125,
        -3053.14990234375,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08495627343654633,
        -0.9511972665786743,
        -0.29665836691856384
      ],
      "plane_d": -2919.56396484375,
      "bbox_min": [
        -3817.4189453125,
        -3049.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9460592865943909,
        -0.323993444442749
      ],
      "plane_d": -2554.883056640625,
      "bbox_min": [
        -3782.5,
        -3049.00146484375,
        1012.1587524414062
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1017.468017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9460592865943909,
        0.323993444442749
      ],
      "plane_d": -3210.969970703125,
      "bbox_min": [
        -3782.5,
        -3047.4169921875,
        1012.1587524414062
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10022688657045364,
        -0.9302731156349182,
        0.3529115617275238
      ],
      "plane_d": -2813.0361328125,
      "bbox_min": [
        -3817.4189453125,
        -3049.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10003136098384857,
        -0.9316565990447998,
        0.3492989242076874
      ],
      "plane_d": -2814.33349609375,
      "bbox_min": [
        -3817.4189453125,
        -3049.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9460592865943909,
        0.323993444442749
      ],
      "plane_d": -3210.969970703125,
      "bbox_min": [
        -3782.5,
        -3049.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1029.800048828125,
      "bbox_min": [
        -3952.50048828125,
        -3072.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1029.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1015.2000122070312,
      "bbox_min": [
        -3952.50048828125,
        -3072.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1029.800048828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.27531054615974426,
        -0.0,
        0.9613553881645203
      ],
      "plane_d": 74.31939697265625,
      "bbox_min": [
        -3814.9189453125,
        -3072.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3049.7685546875,
        1015.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10113630443811417,
        0.9300814270973206,
        0.35315731167793274
      ],
      "plane_d": 2882.465576171875,
      "bbox_min": [
        -3814.9189453125,
        -3072.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3069.800048828125,
        1015.2000122070312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9460592269897461,
        -0.0,
        0.32399341464042664
      ],
      "plane_d": 3250.425537109375,
      "bbox_min": [
        -3782.5,
        -3072.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3069.800048828125,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08495627343654633,
        0.9511972665786743,
        -0.29665836691856384
      ],
      "plane_d": 2901.383056640625,
      "bbox_min": [
        -3791.92822265625,
        -3072.300048828125,
        1012.5
      ],
      "bbox_max": [
        -3781.575439453125,
        -3071.37548828125,
        1015.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 3906.512451171875,
      "bbox_min": [
        -3782.5,
        -3072.300048828125,
        1012.5
      ],
      "bbox_max": [
        -3781.575439453125,
        -3071.37548828125,
        1015.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9460601806640625,
        -0.323991060256958
      ],
      "plane_d": 3237.861572265625,
      "bbox_min": [
        -3952.50048828125,
        -3072.300048828125,
        1015.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1029.800048828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1029.786865234375,
      "bbox_min": [
        -3862.50048828125,
        -3072.300048828125,
        1022.4967651367188
      ],
      "bbox_max": [
        -3837.50048828125,
        -3069.804443359375,
        1029.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9459245800971985,
        -0.0,
        -0.32438668608665466
      ],
      "plane_d": -3298.3017578125,
      "bbox_min": [
        -3862.50048828125,
        -3072.300048828125,
        1022.4967651367188
      ],
      "bbox_max": [
        -3837.50048828125,
        -3069.804443359375,
        1029.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9459245800971985,
        0.0,
        -0.32438668608665466
      ],
      "plane_d": 3985.318359375,
      "bbox_min": [
        -3862.50048828125,
        -3072.300048828125,
        1022.4967651367188
      ],
      "bbox_max": [
        -3860.00048828125,
        -3069.804443359375,
        1029.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9460592865943909,
        0.323993444442749
      ],
      "plane_d": 2575.294677734375,
      "bbox_min": [
        -3952.50048828125,
        -3072.300048828125,
        1015.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1029.800048828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.08495627343654633,
        0.9511972665786743,
        -0.29665836691856384
      ],
      "plane_d": 2901.383056640625,
      "bbox_min": [
        -3862.50048828125,
        -3072.300048828125,
        1015.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3069.800048828125,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.2066650390625,
      "bbox_min": [
        -3862.50048828125,
        -3072.300048828125,
        1015.2066650390625
      ],
      "bbox_max": [
        -3837.50048828125,
        -3069.80224609375,
        1022.4967651367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9459245800971985,
        0.0,
        0.32438668608665466
      ],
      "plane_d": 3321.94970703125,
      "bbox_min": [
        -3862.50048828125,
        -3072.300048828125,
        1015.2066650390625
      ],
      "bbox_max": [
        -3837.50048828125,
        -3069.80224609375,
        1022.4967651367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9459245800971985,
        0.0,
        0.32438668608665466
      ],
      "plane_d": -3961.67041015625,
      "bbox_min": [
        -3840.00048828125,
        -3072.300048828125,
        1015.2066650390625
      ],
      "bbox_max": [
        -3837.50048828125,
        -3069.80224609375,
        1022.4967651367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2753120958805084,
        -0.0,
        -0.9613549709320068
      ],
      "plane_d": -60.2899169921875,
      "bbox_min": [
        -3952.50048828125,
        -3072.300048828125,
        1015.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08495616912841797,
        0.9511979818344116,
        -0.29665616154670715
      ],
      "plane_d": 2901.38330078125,
      "bbox_min": [
        -3952.50048828125,
        -3072.300048828125,
        1015.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1029.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 3906.512451171875,
      "bbox_min": [
        -3780.78759765625,
        -3071.375244140625,
        1017.5001831054688
      ],
      "bbox_max": [
        -3780.0,
        -3069.800048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08495616912841797,
        -0.9511979818344116,
        -0.29665616154670715
      ],
      "plane_d": -2919.56787109375,
      "bbox_min": [
        -3952.50048828125,
        -3072.300048828125,
        1015.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3047.300048828125,
        1029.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9460592865943909,
        -0.323993444442749
      ],
      "plane_d": -2554.883056640625,
      "bbox_min": [
        -3780.798583984375,
        -3049.800048828125,
        1017.468017578125
      ],
      "bbox_max": [
        -3780.0,
        -3049.00146484375,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1029.786865234375,
      "bbox_min": [
        -3952.50048828125,
        -3072.300048828125,
        1015.2000122070312
      ],
      "bbox_max": [
        -3837.50048828125,
        -3047.300048828125,
        1029.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.2066650390625,
      "bbox_min": [
        -3952.50048828125,
        -3072.300048828125,
        1015.2000122070312
      ],
      "bbox_max": [
        -3837.50048828125,
        -3047.300048828125,
        1029.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        0.323993444442749
      ],
      "plane_d": 3408.0166015625,
      "bbox_min": [
        -3950.002685546875,
        -3049.799560546875,
        1015.2000122070312
      ],
      "bbox_max": [
        -3950.00048828125,
        -3049.766357421875,
        1015.2066650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        0.323993444442749
      ],
      "plane_d": 3408.0166015625,
      "bbox_min": [
        -3952.50048828125,
        -3049.79736328125,
        1015.2066650390625
      ],
      "bbox_max": [
        -3950.002685546875,
        -3047.300048828125,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9459245800971985,
        0.0,
        0.32438668608665466
      ],
      "plane_d": -3961.67041015625,
      "bbox_min": [
        -3862.50048828125,
        -3072.300048828125,
        1015.2066650390625
      ],
      "bbox_max": [
        -3837.50048828125,
        -3069.7685546875,
        1029.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9459245800971985,
        -0.0,
        -0.32438668608665466
      ],
      "plane_d": -3298.3017578125,
      "bbox_min": [
        -3862.50048828125,
        -3072.300048828125,
        1022.4967651367188
      ],
      "bbox_max": [
        -3837.50048828125,
        -3069.7685546875,
        1029.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9459245800971985,
        0.0,
        -0.32438668608665466
      ],
      "plane_d": 3985.318359375,
      "bbox_min": [
        -3862.50048828125,
        -3072.300048828125,
        1022.4967651367188
      ],
      "bbox_max": [
        -3860.00048828125,
        -3069.7685546875,
        1029.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.2000122070312,
      "bbox_min": [
        -3952.50048828125,
        -3072.300048828125,
        1015.2000122070312
      ],
      "bbox_max": [
        -3927.50048828125,
        -3047.300048828125,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        0.323993444442749
      ],
      "plane_d": 3408.0166015625,
      "bbox_min": [
        -3952.50048828125,
        -3072.300048828125,
        1015.2000122070312
      ],
      "bbox_max": [
        -3927.50048828125,
        -3047.300048828125,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9460592865943909,
        0.0,
        0.323993444442749
      ],
      "plane_d": -4046.931640625,
      "bbox_min": [
        -3930.00048828125,
        -3072.300048828125,
        1015.2000122070312
      ],
      "bbox_max": [
        -3927.50048828125,
        -3069.800048828125,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9460794925689697,
        3.778449997327016e-09,
        -0.3239343762397766
      ],
      "plane_d": -3384.504638671875,
      "bbox_min": [
        -3930.0,
        -3072.300048828125,
        1022.5
      ],
      "bbox_max": [
        -3927.50048828125,
        -3069.800048828125,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3065.0,
      "bbox_min": [
        -4000.0,
        -3072.300048828125,
        1015.2000122070312
      ],
      "bbox_max": [
        -3960.0,
        -3065.0,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1029.800048828125,
      "bbox_min": [
        -4000.0,
        -3072.300048828125,
        1015.2000122070312
      ],
      "bbox_max": [
        -3960.0,
        -3065.0,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.2000122070312,
      "bbox_min": [
        -4000.0,
        -3072.300048828125,
        1015.2000122070312
      ],
      "bbox_max": [
        -3960.0,
        -3065.0,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 4000.0,
      "bbox_min": [
        -4000.0,
        -3072.300048828125,
        1015.2000122070312
      ],
      "bbox_max": [
        -4000.0,
        -3065.0,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3224.76806640625,
      "bbox_min": [
        -4000.0,
        -3264.60009765625,
        982.623779296875
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1128.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3925.0,
      "bbox_min": [
        -4000.0,
        -3224.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9460593461990356,
        -0.323993444442749
      ],
      "plane_d": -2630.56787109375,
      "bbox_min": [
        -3925.00048828125,
        -3130.015625,
        982.623779296875
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3127.2998046875,
      "bbox_min": [
        -3925.00048828125,
        -3130.015625,
        983.4528198242188
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.737533688545227,
        0.6753103137016296
      ],
      "plane_d": 1617.807861328125,
      "bbox_min": [
        -3925.00048828125,
        -3130.015625,
        1012.5
      ],
      "bbox_max": [
        -3780.0,
        -3127.300048828125,
        1119.786865234375
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1022.0,
      "bbox_min": [
        -3925.00048828125,
        -3129.805908203125,
        1012.5
      ],
      "bbox_max": [
        -3780.0,
        -3127.300048828125,
        1022.5366821289062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 3906.512451171875,
      "bbox_min": [
        -3925.00048828125,
        -3129.800048828125,
        1012.5
      ],
      "bbox_max": [
        -3780.0,
        -3127.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1019.7999877929688,
      "bbox_min": [
        -3925.00048828125,
        -3129.800048828125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3780.0,
        -3127.300048828125,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3812.500244140625,
      "bbox_min": [
        -3812.500244140625,
        -3129.805908203125,
        1022.0
      ],
      "bbox_max": [
        -3812.500244140625,
        -3129.314453125,
        1022.5366821289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3867.0,
      "bbox_min": [
        -3893.500244140625,
        -3129.805908203125,
        1022.0
      ],
      "bbox_max": [
        -3852.500244140625,
        -3129.314453125,
        1022.5366821289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3852.500244140625,
      "bbox_min": [
        -3852.500244140625,
        -3129.805908203125,
        1022.0
      ],
      "bbox_max": [
        -3852.500244140625,
        -3129.314453125,
        1022.5366821289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3893.500244140625,
      "bbox_min": [
        -3893.500244140625,
        -3129.805908203125,
        1022.0
      ],
      "bbox_max": [
        -3893.500244140625,
        -3129.314453125,
        1022.5366821289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1119.786865234375,
      "bbox_min": [
        -3925.00048828125,
        -3130.015625,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3127.300048828125,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070981860160828,
        -0.0,
        -0.7071154713630676
      ],
      "plane_d": -1895.15478515625,
      "bbox_min": [
        -3925.00048828125,
        -3130.015625,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3127.300048828125,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3553.061279296875,
      "bbox_min": [
        -3925.00048828125,
        -3130.015625,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3127.300048828125,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071162462234497,
        0.7070974111557007
      ],
      "plane_d": -2972.037109375,
      "bbox_min": [
        -3844.63232421875,
        -3129.94677734375,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3127.300048828125,
        1087.8743896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071162462234497,
        -0.7070974111557007
      ],
      "plane_d": -1464.18896484375,
      "bbox_min": [
        -3844.63232421875,
        -3129.9150390625,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3127.300048828125,
        1075.767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.009344073943793774,
        -0.0,
        0.9999563097953796
      ],
      "plane_d": -1024.4200439453125,
      "bbox_min": [
        -3844.63232421875,
        -3129.9150390625,
        1056.679931640625
      ],
      "bbox_max": [
        -3780.00048828125,
        -3127.300048828125,
        1075.767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9636161923408508,
        0.1890050619840622,
        0.18900002539157867
      ],
      "plane_d": 4094.830322265625,
      "bbox_min": [
        -3844.028076171875,
        -3129.8876953125,
        1056.679931640625
      ],
      "bbox_max": [
        -3800.0,
        -3127.300048828125,
        1060.38525390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1059.9737548828125,
      "bbox_min": [
        -3807.8271484375,
        -3129.88671875,
        1056.679931640625
      ],
      "bbox_max": [
        -3800.0,
        -3127.300048828125,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3799.999755859375,
      "bbox_min": [
        -3807.8271484375,
        -3129.88671875,
        1056.679931640625
      ],
      "bbox_max": [
        -3800.0,
        -3127.300048828125,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1058.9737548828125,
      "bbox_min": [
        -3807.8271484375,
        -3129.88671875,
        1058.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3127.300048828125,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7588074803352356,
        -0.6513150930404663,
        -0.0
      ],
      "plane_d": -4926.26513671875,
      "bbox_min": [
        -3807.8271484375,
        -3129.88671875,
        1058.9737548828125
      ],
      "bbox_max": [
        -3805.60693359375,
        -3127.300048828125,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007501009851694107,
        0.0,
        -0.9999719262123108
      ],
      "plane_d": 1100.947509765625,
      "bbox_min": [
        -3844.63232421875,
        -3129.9150390625,
        1059.786865234375
      ],
      "bbox_max": [
        -3780.00048828125,
        -3127.300048828125,
        1075.767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.963616132736206,
        0.1890050768852234,
        -0.18900004029273987
      ],
      "plane_d": 4497.86279296875,
      "bbox_min": [
        -3844.011962890625,
        -3129.9150390625,
        1072.1435546875
      ],
      "bbox_max": [
        -3800.0,
        -3127.300048828125,
        1075.767578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3799.999755859375,
      "bbox_min": [
        -3800.0,
        -3129.9150390625,
        1072.4737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3127.300048828125,
        1075.767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03997047618031502,
        0.9992009401321411,
        0.0
      ],
      "plane_d": 2976.17919921875,
      "bbox_min": [
        -3844.63232421875,
        -3129.913818359375,
        1059.786865234375
      ],
      "bbox_max": [
        -3780.00048828125,
        -3127.300048828125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.963616132736206,
        0.2581813633441925,
        -0.06918454170227051
      ],
      "plane_d": 4585.9267578125,
      "bbox_min": [
        -3844.63232421875,
        -3129.9130859375,
        1060.3814697265625
      ],
      "bbox_max": [
        -3843.498779296875,
        -3127.300048828125,
        1072.1475830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.963616132736206,
        -0.2581813633441925,
        -0.06918454170227051
      ],
      "plane_d": -4438.39453125,
      "bbox_min": [
        -3844.63232421875,
        -3129.9130859375,
        1060.3814697265625
      ],
      "bbox_max": [
        -3843.498779296875,
        -3127.300048828125,
        1072.1475830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.963616132736206,
        0.1890050768852234,
        -0.18900004029273987
      ],
      "plane_d": 4497.86279296875,
      "bbox_min": [
        -3844.3203125,
        -3129.9130859375,
        1060.3814697265625
      ],
      "bbox_max": [
        -3843.498779296875,
        -3127.300048828125,
        1072.1475830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.963616132736206,
        -0.1890050768852234,
        -0.18900004029273987
      ],
      "plane_d": -4094.830078125,
      "bbox_min": [
        -3844.3203125,
        -3129.8876953125,
        1060.3814697265625
      ],
      "bbox_max": [
        -3843.519775390625,
        -3127.300048828125,
        1061.87548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.22604458034038544,
        0.0,
        -0.9741169214248657
      ],
      "plane_d": 1881.399658203125,
      "bbox_min": [
        -3843.30126953125,
        -3129.88525390625,
        1044.5731201171875
      ],
      "bbox_max": [
        -3800.0,
        -3127.300048828125,
        1059.2652587890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.22604458034038544,
        -0.0,
        -0.9741169214248657
      ],
      "plane_d": 153.67303466796875,
      "bbox_min": [
        -3843.30126953125,
        -3129.88525390625,
        1044.5731201171875
      ],
      "bbox_max": [
        -3800.0,
        -3127.300048828125,
        1059.2652587890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6947397589683533,
        -0.5085904598236084,
        -0.5085983276367188
      ],
      "plane_d": -3723.183349609375,
      "bbox_min": [
        -3843.30126953125,
        -3129.88525390625,
        1047.4737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3127.300048828125,
        1059.2652587890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6947534680366516,
        0.5085812211036682,
        0.5085890889167786
      ],
      "plane_d": -1586.992919921875,
      "bbox_min": [
        -3840.738037109375,
        -3129.88525390625,
        1047.4737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3127.300048828125,
        1059.2652587890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1058.9737548828125,
      "bbox_min": [
        -3800.212646484375,
        -3129.884521484375,
        1058.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3129.59375,
        1058.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6546636819839478,
        0.0,
        0.7559202909469604
      ],
      "plane_d": -3285.51904296875,
      "bbox_min": [
        -3809.150390625,
        -3129.88525390625,
        1047.4737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3127.300048828125,
        1059.2652587890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1058.9737548828125,
      "bbox_min": [
        -3805.858154296875,
        -3129.88525390625,
        1058.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3129.59375,
        1059.2652587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7588074803352356,
        -0.6513150930404663,
        -0.0
      ],
      "plane_d": -4926.26513671875,
      "bbox_min": [
        -3805.858154296875,
        -3129.88525390625,
        1058.9737548828125
      ],
      "bbox_max": [
        -3805.608154296875,
        -3129.59375,
        1059.2652587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22604458034038544,
        0.0,
        -0.9741169214248657
      ],
      "plane_d": 195.85345458984375,
      "bbox_min": [
        -3843.30126953125,
        -3129.94677734375,
        1073.1524658203125
      ],
      "bbox_max": [
        -3800.0,
        -3127.300048828125,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.22604458034038544,
        0.0,
        0.9741169214248657
      ],
      "plane_d": -1923.580078125,
      "bbox_min": [
        -3843.30126953125,
        -3129.94677734375,
        1073.1524658203125
      ],
      "bbox_max": [
        -3800.0,
        -3127.300048828125,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6947418451309204,
        0.5085998773574829,
        -0.5085863471031189
      ],
      "plane_d": 4807.767578125,
      "bbox_min": [
        -3843.30126953125,
        -3129.9404296875,
        1073.1524658203125
      ],
      "bbox_max": [
        -3800.0,
        -3127.300048828125,
        1084.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6947513818740845,
        -0.5085932612419128,
        0.5085797309875488
      ],
      "plane_d": 502.41796875,
      "bbox_min": [
        -3840.738037109375,
        -3129.9404296875,
        1073.1524658203125
      ],
      "bbox_max": [
        -3800.0,
        -3127.300048828125,
        1084.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.654643714427948,
        0.0,
        0.7559375762939453
      ],
      "plane_d": -3330.1748046875,
      "bbox_min": [
        -3840.738037109375,
        -3129.9404296875,
        1079.2686767578125
      ],
      "bbox_max": [
        -3802.56298828125,
        -3127.300048828125,
        1084.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6546636819839478,
        0.0,
        -0.7559202909469604
      ],
      "plane_d": -1673.5587158203125,
      "bbox_min": [
        -3809.150390625,
        -3129.9404296875,
        1079.2686767578125
      ],
      "bbox_max": [
        -3802.56298828125,
        -3127.300048828125,
        1084.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.7531641721725464,
        -0.6578325629234314
      ],
      "plane_d": -1590.470703125,
      "bbox_min": [
        -3925.00048828125,
        -3127.300048828125,
        983.4528198242188
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1119.786865234375,
      "bbox_min": [
        -3925.00048828125,
        -3127.300048828125,
        983.4528198242188
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.08305060863494873,
        0.9965454339981079
      ],
      "plane_d": -1238.953369140625,
      "bbox_min": [
        -3925.00048828125,
        -3127.300048828125,
        983.4528198242188
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3898577094078064,
        0.0,
        0.9208751916885376
      ],
      "plane_d": 603.5532836914062,
      "bbox_min": [
        -3925.00048828125,
        -3127.300048828125,
        983.4528198242188
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46785908937454224,
        -0.07340037077665329,
        0.8807497620582581
      ],
      "plane_d": 720.3028564453125,
      "bbox_min": [
        -3920.324951171875,
        -3124.484619140625,
        983.4528198242188
      ],
      "bbox_max": [
        -3880.00048828125,
        -3072.300048828125,
        1004.2789306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5157708525657654,
        -4.578932021104265e-06,
        0.8567266464233398
      ],
      "plane_d": -2812.09912109375,
      "bbox_min": [
        -3925.00048828125,
        -3127.300048828125,
        983.4528198242188
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592269897461,
        -0.0,
        0.32399341464042664
      ],
      "plane_d": 3250.425537109375,
      "bbox_min": [
        -3780.427490234375,
        -3125.22705078125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1006.4479370117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4313707649707794,
        -0.07492615282535553,
        0.8990580439567566
      ],
      "plane_d": -2765.5888671875,
      "bbox_min": [
        -3925.00048828125,
        -3127.300048828125,
        983.4528198242188
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070981860160828,
        -0.0,
        -0.7071154713630676
      ],
      "plane_d": -1895.15478515625,
      "bbox_min": [
        -3925.00048828125,
        -3127.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3553.061279296875,
      "bbox_min": [
        -3925.00048828125,
        -3127.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -8.877840627974365e-06,
        0.0
      ],
      "plane_d": -3782.52783203125,
      "bbox_min": [
        -3925.00048828125,
        -3127.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1087.8743896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1019.7999877929688,
      "bbox_min": [
        -3782.50048828125,
        -3127.300048828125,
        1006.4476928710938
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1077.049072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 3906.512451171875,
      "bbox_min": [
        -3782.5,
        -3127.300048828125,
        1012.5
      ],
      "bbox_max": [
        -3780.0,
        -3072.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.009344073943793774,
        -0.0,
        0.9999563097953796
      ],
      "plane_d": -1024.4200439453125,
      "bbox_min": [
        -3782.500244140625,
        -3127.300048828125,
        1055.3984375
      ],
      "bbox_max": [
        -3780.0,
        -3107.2685546875,
        1077.049072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071162462234497,
        -0.7070974111557007
      ],
      "plane_d": 2947.888916015625,
      "bbox_min": [
        -3782.500244140625,
        -3127.300048828125,
        1055.3984375
      ],
      "bbox_max": [
        -3780.0,
        -3109.10693359375,
        1059.810302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007501009851694107,
        0.0,
        -0.9999719262123108
      ],
      "plane_d": 1100.947509765625,
      "bbox_min": [
        -3782.500244140625,
        -3127.300048828125,
        1059.786865234375
      ],
      "bbox_max": [
        -3780.0,
        -3107.2685546875,
        1077.049072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071162462234497,
        0.7070974111557007
      ],
      "plane_d": 1440.041015625,
      "bbox_min": [
        -3782.500244140625,
        -3127.300048828125,
        1072.6051025390625
      ],
      "bbox_max": [
        -3780.0,
        -3109.07470703125,
        1077.049072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03997047245502472,
        -0.9992008805274963,
        0.0
      ],
      "plane_d": -3258.371826171875,
      "bbox_min": [
        -3782.500244140625,
        -3109.7685546875,
        1059.786865234375
      ],
      "bbox_max": [
        -3780.0,
        -3107.2685546875,
        1072.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9659211039543152,
        0.25883668661117554
      ],
      "plane_d": 2725.3984375,
      "bbox_min": [
        -3782.500244140625,
        -3109.130126953125,
        1059.786865234375
      ],
      "bbox_max": [
        -3780.0,
        -3107.2685546875,
        1072.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9659211039543152,
        -0.25883668661117554
      ],
      "plane_d": 3277.35400390625,
      "bbox_min": [
        -3782.500244140625,
        -3109.130126953125,
        1059.786865234375
      ],
      "bbox_max": [
        -3780.0,
        -3107.2685546875,
        1072.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071162462234497,
        -0.7070974111557007
      ],
      "plane_d": 2947.888916015625,
      "bbox_min": [
        -3782.500244140625,
        -3109.130126953125,
        1059.786865234375
      ],
      "bbox_max": [
        -3780.0,
        -3108.943359375,
        1072.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071162462234497,
        0.7070974111557007
      ],
      "plane_d": 1440.041015625,
      "bbox_min": [
        -3782.500244140625,
        -3109.093505859375,
        1072.4737548828125
      ],
      "bbox_max": [
        -3780.0,
        -3108.943359375,
        1072.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3922.50048828125,
      "bbox_min": [
        -3925.00048828125,
        -3127.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3782.5,
        -3072.300048828125,
        1087.8743896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1019.7999267578125,
      "bbox_min": [
        -3925.00048828125,
        -3127.300048828125,
        1019.7999877929688
      ],
      "bbox_max": [
        -3922.50048828125,
        -3072.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22604458034038544,
        0.0,
        -0.9741169214248657
      ],
      "plane_d": 1881.399658203125,
      "bbox_min": [
        -3865.21728515625,
        -3127.300048828125,
        1010.623779296875
      ],
      "bbox_max": [
        -3782.5,
        -3072.300048828125,
        1060.3929443359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.22604458034038544,
        -0.0,
        -0.9741169214248657
      ],
      "plane_d": 153.67303466796875,
      "bbox_min": [
        -3859.737548828125,
        -3127.300048828125,
        1035.7349853515625
      ],
      "bbox_max": [
        -3782.5,
        -3072.300048828125,
        1060.3929443359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.654643714427948,
        -0.0,
        -0.7559375762939453
      ],
      "plane_d": -1718.177734375,
      "bbox_min": [
        -3844.846435546875,
        -3127.300048828125,
        1044.5731201171875
      ],
      "bbox_max": [
        -3782.5,
        -3096.388916015625,
        1060.3929443359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25056278705596924,
        -0.6845502853393555,
        0.6845502853393555
      ],
      "plane_d": -3799.70751953125,
      "bbox_min": [
        -3844.846435546875,
        -3127.300048828125,
        1044.5731201171875
      ],
      "bbox_max": [
        -3782.5,
        -3096.388916015625,
        1060.3929443359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25056231021881104,
        -0.6845451593399048,
        0.68455570936203
      ],
      "plane_d": -1884.57275390625,
      "bbox_min": [
        -3844.846435546875,
        -3127.300048828125,
        1044.5731201171875
      ],
      "bbox_max": [
        -3782.5,
        -3096.388916015625,
        1060.3929443359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6546636819839478,
        0.0,
        0.7559202909469604
      ],
      "plane_d": -3285.51904296875,
      "bbox_min": [
        -3844.846435546875,
        -3127.300048828125,
        1047.4737548828125
      ],
      "bbox_max": [
        -3782.5,
        -3096.388916015625,
        1060.3929443359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1055.3984375,
      "bbox_min": [
        -3800.0,
        -3127.300048828125,
        1055.3984375
      ],
      "bbox_max": [
        -3782.5,
        -3108.9921875,
        1059.9249267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071162462234497,
        -0.7070974111557007
      ],
      "plane_d": -1464.18896484375,
      "bbox_min": [
        -3800.0,
        -3127.300048828125,
        1055.3984375
      ],
      "bbox_max": [
        -3782.5,
        -3108.9921875,
        1059.9249267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3799.999755859375,
      "bbox_min": [
        -3844.846435546875,
        -3127.300048828125,
        1047.4737548828125
      ],
      "bbox_max": [
        -3794.7734375,
        -3096.388916015625,
        1060.3929443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071162462234497,
        -0.7070974111557007
      ],
      "plane_d": 2947.888916015625,
      "bbox_min": [
        -3800.0,
        -3127.300048828125,
        1055.3984375
      ],
      "bbox_max": [
        -3794.7734375,
        -3108.943359375,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071162462234497,
        -0.7070974111557007
      ],
      "plane_d": -1464.18896484375,
      "bbox_min": [
        -3800.0,
        -3127.300048828125,
        1055.3984375
      ],
      "bbox_max": [
        -3798.520263671875,
        -3126.0185546875,
        1056.679931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6947418451309204,
        -0.5085998773574829,
        0.5085863471031189
      ],
      "plane_d": 549.805908203125,
      "bbox_min": [
        -3844.846435546875,
        -3127.300048828125,
        1047.4737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3096.388916015625,
        1060.3929443359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2505628168582916,
        -0.9351130723953247,
        0.25056275725364685
      ],
      "plane_d": -2203.551025390625,
      "bbox_min": [
        -3844.846435546875,
        -3127.300048828125,
        1047.4737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3096.388916015625,
        1060.3929443359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2505628168582916,
        -0.9351131319999695,
        0.2505628168582916
      ],
      "plane_d": -4118.67822265625,
      "bbox_min": [
        -3844.846435546875,
        -3127.300048828125,
        1047.4737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3096.388916015625,
        1060.3929443359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6947352886199951,
        -0.6947538256645203,
        0.18617232143878937
      ],
      "plane_d": 312.788818359375,
      "bbox_min": [
        -3844.846435546875,
        -3127.300048828125,
        1047.4737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3099.70703125,
        1060.3929443359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.694758951663971,
        -0.5085774064064026,
        0.5085852742195129
      ],
      "plane_d": -4760.3095703125,
      "bbox_min": [
        -3844.846435546875,
        -3127.300048828125,
        1047.4737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3099.769775390625,
        1060.3929443359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1058.9737548828125,
      "bbox_min": [
        -3800.732421875,
        -3109.94384765625,
        1058.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3108.943359375,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3108.943359375,
      "bbox_min": [
        -3800.732421875,
        -3108.943359375,
        1058.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3108.943359375,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6947561502456665,
        -0.6947376728057861,
        0.18615436553955078
      ],
      "plane_d": -4997.2919921875,
      "bbox_min": [
        -3844.846435546875,
        -3127.300048828125,
        1053.1787109375
      ],
      "bbox_max": [
        -3800.0,
        -3099.769775390625,
        1060.3929443359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1058.9737548828125,
      "bbox_min": [
        -3844.846435546875,
        -3127.300048828125,
        1053.1787109375
      ],
      "bbox_max": [
        -3800.0,
        -3108.8349609375,
        1060.3929443359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5269442200660706,
        -0.0,
        -0.84989994764328
      ],
      "plane_d": -1110.2705078125,
      "bbox_min": [
        -3844.846435546875,
        -3127.300048828125,
        1058.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3108.8349609375,
        1060.3929443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1059.9737548828125,
      "bbox_min": [
        -3816.8671875,
        -3127.300048828125,
        1058.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3108.943359375,
        1060.1314697265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3115.7685546875,
      "bbox_min": [
        -3816.61279296875,
        -3127.300048828125,
        1058.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3108.943359375,
        1059.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3123.7685546875,
      "bbox_min": [
        -3816.61279296875,
        -3127.300048828125,
        1058.9737548828125
      ],
      "bbox_max": [
        -3807.8271484375,
        -3123.7685546875,
        1059.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3810.0,
      "bbox_min": [
        -3810.0,
        -3124.7685546875,
        1058.9737548828125
      ],
      "bbox_max": [
        -3810.0,
        -3123.7685546875,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7588074803352356,
        0.6513150930404663,
        0.0
      ],
      "plane_d": -862.3607177734375,
      "bbox_min": [
        -3810.0,
        -3115.7685546875,
        1058.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3108.943359375,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3108.943359375,
      "bbox_min": [
        -3810.0,
        -3115.7685546875,
        1058.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3108.943359375,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3810.0,
      "bbox_min": [
        -3810.0,
        -3115.7685546875,
        1058.9737548828125
      ],
      "bbox_max": [
        -3810.0,
        -3114.7685546875,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5299989581108093,
        -0.0,
        0.8479983806610107
      ],
      "plane_d": 1123.090087890625,
      "bbox_min": [
        -3816.8671875,
        -3123.7685546875,
        1059.9737548828125
      ],
      "bbox_max": [
        -3815.0,
        -3115.7685546875,
        1060.1314697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3123.768310546875,
      "bbox_min": [
        -3816.8671875,
        -3123.7685546875,
        1059.9737548828125
      ],
      "bbox_max": [
        -3815.0,
        -3115.7685546875,
        1060.1314697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3115.7685546875,
      "bbox_min": [
        -3816.8671875,
        -3115.7685546875,
        1059.9737548828125
      ],
      "bbox_max": [
        -3815.0,
        -3115.7685546875,
        1060.1314697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.963616132736206,
        -0.1890050768852234,
        0.18900004029273987
      ],
      "plane_d": 2915.52587890625,
      "bbox_min": [
        -3844.846435546875,
        -3127.300048828125,
        1058.9737548828125
      ],
      "bbox_max": [
        -3843.30126953125,
        -3108.8349609375,
        1060.3929443359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.963616132736206,
        -0.1890050768852234,
        -0.18900004029273987
      ],
      "plane_d": -4094.830078125,
      "bbox_min": [
        -3844.846435546875,
        -3127.300048828125,
        1058.9737548828125
      ],
      "bbox_max": [
        -3843.30126953125,
        -3108.8349609375,
        1060.3929443359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.963616132736206,
        -0.2581813633441925,
        0.06918454170227051
      ],
      "plane_d": 2827.4619140625,
      "bbox_min": [
        -3843.519287109375,
        -3109.647705078125,
        1059.9737548828125
      ],
      "bbox_max": [
        -3843.30126953125,
        -3108.8349609375,
        1060.3804931640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.963616132736206,
        -0.1890050768852234,
        0.18900004029273987
      ],
      "plane_d": 2915.52587890625,
      "bbox_min": [
        -3844.407470703125,
        -3127.300048828125,
        1053.1787109375
      ],
      "bbox_max": [
        -3800.0,
        -3109.943359375,
        1058.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.963616132736206,
        -0.1890050768852234,
        -0.18900004029273987
      ],
      "plane_d": -4094.830078125,
      "bbox_min": [
        -3844.407470703125,
        -3127.300048828125,
        1053.1787109375
      ],
      "bbox_max": [
        -3800.0,
        -3123.954345703125,
        1058.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6947534680366516,
        0.5085812211036682,
        0.5085890889167786
      ],
      "plane_d": -1586.992919921875,
      "bbox_min": [
        -3802.56298828125,
        -3127.300048828125,
        1053.1787109375
      ],
      "bbox_max": [
        -3800.0,
        -3126.0185546875,
        1056.679931640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2734627425670624,
        0.0,
        0.9618827104568481
      ],
      "plane_d": -2051.865966796875,
      "bbox_min": [
        -3859.737548828125,
        -3085.876708984375,
        1035.7349853515625
      ],
      "bbox_max": [
        -3848.78173828125,
        -3072.300048828125,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2734627425670624,
        0.0,
        0.9618827104568481
      ],
      "plane_d": 53.79742431640625,
      "bbox_min": [
        -3859.737548828125,
        -3085.876708984375,
        1035.7349853515625
      ],
      "bbox_max": [
        -3848.78173828125,
        -3072.300048828125,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7693594694137573,
        0.0,
        0.638816237449646
      ],
      "plane_d": -3631.051513671875,
      "bbox_min": [
        -3859.737548828125,
        -3085.876708984375,
        1035.7349853515625
      ],
      "bbox_max": [
        -3848.78173828125,
        -3072.300048828125,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24497897922992706,
        -0.4443757236003876,
        0.8616933226585388
      ],
      "plane_d": -3208.940673828125,
      "bbox_min": [
        -3859.546875,
        -3085.876708984375,
        1035.7791748046875
      ],
      "bbox_max": [
        -3848.78173828125,
        -3084.7685546875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6246950626373291,
        0.7808687686920166
      ],
      "plane_d": -2738.068603515625,
      "bbox_min": [
        -3851.108642578125,
        -3085.876708984375,
        1037.7373046875
      ],
      "bbox_max": [
        -3848.78173828125,
        -3084.7685546875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24497897922992706,
        -0.4443757236003876,
        0.8616933226585388
      ],
      "plane_d": -1322.602294921875,
      "bbox_min": [
        -3850.00048828125,
        -3085.37841796875,
        1038.135986328125
      ],
      "bbox_max": [
        -3848.78173828125,
        -3084.7685546875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16160258650779724,
        -0.383549302816391,
        0.9092714190483093
      ],
      "plane_d": -2748.810546875,
      "bbox_min": [
        -3859.546875,
        -3085.11376953125,
        1035.7791748046875
      ],
      "bbox_max": [
        -3859.146240234375,
        -3084.7685546875,
        1035.9500732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7327498197555542,
        0.30480295419692993,
        0.6084184646606445
      ],
      "plane_d": -2518.02294921875,
      "bbox_min": [
        -3859.737548828125,
        -3085.138427734375,
        1035.7349853515625
      ],
      "bbox_max": [
        -3859.405029296875,
        -3084.7685546875,
        1035.9500732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16160258650779724,
        -0.383549302816391,
        0.9092714190483093
      ],
      "plane_d": -2748.810546875,
      "bbox_min": [
        -3859.737548828125,
        -3085.138427734375,
        1035.7349853515625
      ],
      "bbox_max": [
        -3859.405029296875,
        -3084.7685546875,
        1035.9500732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3084.7685546875,
      "bbox_min": [
        -3865.21728515625,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3834.78369140625,
        -3072.300048828125,
        1038.2772216796875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.2066650390625,
      "bbox_min": [
        -3865.21728515625,
        -3084.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3834.78369140625,
        -3072.300048828125,
        1038.2772216796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2734684944152832,
        0.0,
        -0.9618809819221497
      ],
      "plane_d": 2024.95361328125,
      "bbox_min": [
        -3860.990234375,
        -3084.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3839.0107421875,
        -3072.300048828125,
        1015.2066650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2734684944152832,
        0.0,
        -0.9618809819221497
      ],
      "plane_d": -80.7540283203125,
      "bbox_min": [
        -3860.990234375,
        -3084.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3839.0107421875,
        -3072.300048828125,
        1015.2066650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7693594694137573,
        0.0,
        -0.638816237449646
      ],
      "plane_d": 3602.10986328125,
      "bbox_min": [
        -3860.990234375,
        -3084.7685546875,
        1013.2975463867188
      ],
      "bbox_max": [
        -3839.0107421875,
        -3072.300048828125,
        1015.2066650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7693594694137573,
        -0.0,
        -0.638816237449646
      ],
      "plane_d": -2321.958984375,
      "bbox_min": [
        -3860.990234375,
        -3084.7685546875,
        1013.2975463867188
      ],
      "bbox_max": [
        -3859.405029296875,
        -3072.300048828125,
        1015.2066650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3840.00048828125,
      "bbox_min": [
        -3865.21728515625,
        -3084.7685546875,
        1015.2066650390625
      ],
      "bbox_max": [
        -3834.78369140625,
        -3072.300048828125,
        1038.2772216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3834.78369140625,
      "bbox_min": [
        -3840.00048828125,
        -3084.7685546875,
        1015.2066650390625
      ],
      "bbox_max": [
        -3834.78369140625,
        -3072.300048828125,
        1035.23291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7693594694137573,
        -0.0,
        0.638816237449646
      ],
      "plane_d": 2293.01708984375,
      "bbox_min": [
        -3840.00048828125,
        -3084.7685546875,
        1015.2066650390625
      ],
      "bbox_max": [
        -3834.78369140625,
        -3072.300048828125,
        1035.23291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7693594694137573,
        0.0,
        -0.638816237449646
      ],
      "plane_d": 3602.10986328125,
      "bbox_min": [
        -3840.00048828125,
        -3084.7685546875,
        1015.2066650390625
      ],
      "bbox_max": [
        -3834.78369140625,
        -3072.300048828125,
        1029.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3074.7685546875,
      "bbox_min": [
        -3840.00048828125,
        -3074.7685546875,
        1015.2066650390625
      ],
      "bbox_max": [
        -3837.50048828125,
        -3072.300048828125,
        1029.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9459245800971985,
        -0.0,
        -0.32438668608665466
      ],
      "plane_d": -3298.3017578125,
      "bbox_min": [
        -3840.00048828125,
        -3074.7685546875,
        1015.2066650390625
      ],
      "bbox_max": [
        -3837.50048828125,
        -3072.300048828125,
        1029.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9459245800971985,
        0.0,
        0.32438668608665466
      ],
      "plane_d": -3961.67041015625,
      "bbox_min": [
        -3840.00048828125,
        -3074.7685546875,
        1015.2066650390625
      ],
      "bbox_max": [
        -3837.50048828125,
        -3072.300048828125,
        1022.4967651367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.43542996048927307,
        -0.900222659111023
      ],
      "plane_d": -411.808837890625,
      "bbox_min": [
        -3865.21728515625,
        -3084.7685546875,
        1015.2066650390625
      ],
      "bbox_max": [
        -3840.00048828125,
        -3072.300048828125,
        1038.2772216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1029.786865234375,
      "bbox_min": [
        -3865.21728515625,
        -3084.7685546875,
        1028.5928955078125
      ],
      "bbox_max": [
        -3840.00048828125,
        -3072.300048828125,
        1038.2772216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2734627425670624,
        0.0,
        0.9618827104568481
      ],
      "plane_d": 53.79742431640625,
      "bbox_min": [
        -3864.5224609375,
        -3084.7685546875,
        1029.786865234375
      ],
      "bbox_max": [
        -3840.00048828125,
        -3072.300048828125,
        1038.2772216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7693594694137573,
        0.0,
        0.638816237449646
      ],
      "plane_d": -3631.051513671875,
      "bbox_min": [
        -3864.5224609375,
        -3084.7685546875,
        1029.786865234375
      ],
      "bbox_max": [
        -3840.00048828125,
        -3072.300048828125,
        1035.9500732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7693594694137573,
        -0.0,
        0.638816237449646
      ],
      "plane_d": 2293.01708984375,
      "bbox_min": [
        -3840.595947265625,
        -3084.7685546875,
        1035.23291015625
      ],
      "bbox_max": [
        -3840.00048828125,
        -3072.300048828125,
        1035.9500732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9459245800971985,
        0.0,
        -0.32438668608665466
      ],
      "plane_d": 3985.318359375,
      "bbox_min": [
        -3865.21728515625,
        -3074.7685546875,
        1028.5928955078125
      ],
      "bbox_max": [
        -3860.00048828125,
        -3072.300048828125,
        1029.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7693594694137573,
        0.0,
        0.638816237449646
      ],
      "plane_d": -3631.051513671875,
      "bbox_min": [
        -3865.21728515625,
        -3074.7685546875,
        1028.5928955078125
      ],
      "bbox_max": [
        -3864.5224609375,
        -3072.300048828125,
        1029.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3865.21728515625,
      "bbox_min": [
        -3865.21728515625,
        -3073.03857421875,
        1028.5928955078125
      ],
      "bbox_max": [
        -3865.21728515625,
        -3072.300048828125,
        1028.9500732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3860.00048828125,
      "bbox_min": [
        -3865.21728515625,
        -3084.7685546875,
        1015.2066650390625
      ],
      "bbox_max": [
        -3840.00048828125,
        -3072.300048828125,
        1034.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3865.21728515625,
      "bbox_min": [
        -3865.21728515625,
        -3084.7685546875,
        1015.2066650390625
      ],
      "bbox_max": [
        -3860.00048828125,
        -3072.300048828125,
        1034.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7693594694137573,
        -0.0,
        -0.638816237449646
      ],
      "plane_d": -2321.958984375,
      "bbox_min": [
        -3865.21728515625,
        -3084.7685546875,
        1015.2066650390625
      ],
      "bbox_max": [
        -3860.00048828125,
        -3072.300048828125,
        1034.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7693594694137573,
        0.0,
        0.638816237449646
      ],
      "plane_d": -3631.051513671875,
      "bbox_min": [
        -3865.21728515625,
        -3084.7685546875,
        1015.2066650390625
      ],
      "bbox_max": [
        -3860.00048828125,
        -3072.300048828125,
        1034.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3074.7685546875,
      "bbox_min": [
        -3862.50048828125,
        -3074.7685546875,
        1015.2066650390625
      ],
      "bbox_max": [
        -3860.00048828125,
        -3072.300048828125,
        1029.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9459245800971985,
        0.0,
        0.32438668608665466
      ],
      "plane_d": 3321.94970703125,
      "bbox_min": [
        -3862.50048828125,
        -3074.7685546875,
        1015.2066650390625
      ],
      "bbox_max": [
        -3860.00048828125,
        -3072.300048828125,
        1029.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9459245800971985,
        0.0,
        -0.32438668608665466
      ],
      "plane_d": 3985.318359375,
      "bbox_min": [
        -3862.50048828125,
        -3074.7685546875,
        1022.4967651367188
      ],
      "bbox_max": [
        -3860.00048828125,
        -3072.300048828125,
        1029.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44125330448150635,
        0.8973826169967651
      ],
      "plane_d": 445.72296142578125,
      "bbox_min": [
        -3860.00048828125,
        -3084.7685546875,
        1015.2066650390625
      ],
      "bbox_max": [
        -3840.00048828125,
        -3074.7685546875,
        1020.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3855.00048828125,
      "bbox_min": [
        -3855.00048828125,
        -3084.7685546875,
        1015.2066650390625
      ],
      "bbox_max": [
        -3845.00048828125,
        -3074.7685546875,
        1020.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3845.00048828125,
      "bbox_min": [
        -3855.00048828125,
        -3084.7685546875,
        1015.2066650390625
      ],
      "bbox_max": [
        -3845.00048828125,
        -3074.7685546875,
        1020.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1017.123779296875,
      "bbox_min": [
        -3855.00048828125,
        -3084.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3076.7685546875,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1016.123779296875,
      "bbox_min": [
        -3855.00048828125,
        -3078.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3076.7685546875,
        1017.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3076.7685546875,
      "bbox_min": [
        -3855.00048828125,
        -3076.7685546875,
        1015.623779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3076.7685546875,
        1016.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3078.7685546875,
      "bbox_min": [
        -3855.00048828125,
        -3078.7685546875,
        1016.623779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3078.7685546875,
        1017.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1018.123779296875,
      "bbox_min": [
        -3855.00048828125,
        -3084.7685546875,
        1017.623779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3080.7685546875,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3080.7685546875,
      "bbox_min": [
        -3855.00048828125,
        -3080.7685546875,
        1017.623779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3080.7685546875,
        1018.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1019.123779296875,
      "bbox_min": [
        -3855.00048828125,
        -3084.7685546875,
        1018.623779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3082.7685546875,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3082.7685546875,
      "bbox_min": [
        -3855.00048828125,
        -3082.7685546875,
        1018.623779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3082.7685546875,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3105.7685546875,
      "bbox_min": [
        -3865.21728515625,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3834.78369140625,
        -3084.7685546875,
        1038.2772216796875
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1034.623779296875,
      "bbox_min": [
        -3865.21728515625,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3834.78369140625,
        -3084.7685546875,
        1038.2772216796875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        -0.8320502638816833,
        0.0
      ],
      "plane_d": -4722.802734375,
      "bbox_min": [
        -3865.21728515625,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3834.78369140625,
        -3084.7685546875,
        1034.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12403474003076553,
        0.0,
        0.9922779202461243
      ],
      "plane_d": -1504.788330078125,
      "bbox_min": [
        -3865.21728515625,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3834.78369140625,
        -3084.7685546875,
        1034.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -0.8320502638816833,
        0.0
      ],
      "plane_d": -451.6103515625,
      "bbox_min": [
        -3865.21728515625,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3834.78369140625,
        -3084.7685546875,
        1034.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12403474003076553,
        -0.0,
        0.9922779202461243
      ],
      "plane_d": -549.720703125,
      "bbox_min": [
        -3865.21728515625,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3834.78369140625,
        -3084.7685546875,
        1034.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2925.578125,
      "bbox_min": [
        -3865.21728515625,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3834.78369140625,
        -3084.7685546875,
        1034.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7327498197555542,
        0.30480295419692993,
        0.6084184646606445
      ],
      "plane_d": -2518.02294921875,
      "bbox_min": [
        -3865.21728515625,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3834.78369140625,
        -3084.7685546875,
        1034.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3863.000244140625,
      "bbox_min": [
        -3865.21728515625,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3834.78369140625,
        -3084.7685546875,
        1034.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7327498197555542,
        0.30480292439460754,
        0.6084184050559998
      ],
      "plane_d": 3124.1513671875,
      "bbox_min": [
        -3863.00048828125,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3834.78369140625,
        -3084.7685546875,
        1034.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3837.000244140625,
      "bbox_min": [
        -3863.00048828125,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3834.78369140625,
        -3084.7685546875,
        1034.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.2626146674156189,
        0.7071019411087036,
        -0.6565366387367249
      ],
      "plane_d": 1863.488525390625,
      "bbox_min": [
        -3863.00048828125,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3084.7685546875,
        1034.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2626116871833801,
        0.7071099281311035,
        -0.6565291881561279
      ],
      "plane_d": 3885.62744140625,
      "bbox_min": [
        -3863.00048828125,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3084.7685546875,
        1034.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3860.00048828125,
      "bbox_min": [
        -3863.00048828125,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3084.7685546875,
        1034.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        -0.8320502638816833
      ],
      "plane_d": -1293.180908203125,
      "bbox_min": [
        -3863.00048828125,
        -3102.7685546875,
        1014.0147094726562
      ],
      "bbox_max": [
        -3860.00048828125,
        -3084.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3089.7685546875,
      "bbox_min": [
        -3863.00048828125,
        -3099.7685546875,
        1022.123779296875
      ],
      "bbox_max": [
        -3860.00048828125,
        -3089.7685546875,
        1032.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3099.7685546875,
      "bbox_min": [
        -3863.00048828125,
        -3099.7685546875,
        1022.123779296875
      ],
      "bbox_max": [
        -3860.00048828125,
        -3089.7685546875,
        1032.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1032.623779296875,
      "bbox_min": [
        -3863.00048828125,
        -3099.7685546875,
        1022.123779296875
      ],
      "bbox_max": [
        -3860.00048828125,
        -3089.7685546875,
        1032.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1022.123779296875,
      "bbox_min": [
        -3863.00048828125,
        -3099.7685546875,
        1022.123779296875
      ],
      "bbox_max": [
        -3860.00048828125,
        -3089.7685546875,
        1022.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5790749192237854,
        -0.5868234634399414,
        -0.5659598708152771
      ],
      "plane_d": -3471.613525390625,
      "bbox_min": [
        -3863.00048828125,
        -3089.800048828125,
        1014.0147094726562
      ],
      "bbox_max": [
        -3860.00048828125,
        -3084.7685546875,
        1021.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3713906705379486,
        0.0,
        -0.9284766912460327
      ],
      "plane_d": 2392.335205078125,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3084.7685546875,
        1034.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1020.123779296875,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3084.7685546875,
        1034.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3089.800048828125,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1010.623779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3084.7685546875,
        1020.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1967976987361908,
        -0.6943517327308655,
        -0.6922038793563843
      ],
      "plane_d": -2200.02783203125,
      "bbox_min": [
        -3860.00048828125,
        -3089.800048828125,
        1010.623779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3084.7685546875,
        1020.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1967976987361908,
        -0.6943517327308655,
        -0.6922038793563843
      ],
      "plane_d": -684.6854248046875,
      "bbox_min": [
        -3860.00048828125,
        -3089.800048828125,
        1010.623779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3084.7685546875,
        1020.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7568392753601074,
        -0.6536011099815369
      ],
      "plane_d": -1672.381591796875,
      "bbox_min": [
        -3860.00048828125,
        -3089.800048828125,
        1010.623779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3084.7685546875,
        1020.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5790748596191406,
        -0.5868234634399414,
        -0.5659598708152771
      ],
      "plane_d": 987.2638549804688,
      "bbox_min": [
        -3860.00048828125,
        -3089.800048828125,
        1013.2975463867188
      ],
      "bbox_max": [
        -3837.00048828125,
        -3084.7685546875,
        1020.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6717481017112732,
        -0.48749372363090515,
        -0.5577673316001892
      ],
      "plane_d": 1641.2919921875,
      "bbox_min": [
        -3860.00048828125,
        -3089.800048828125,
        1013.2975463867188
      ],
      "bbox_max": [
        -3837.00048828125,
        -3084.7685546875,
        1020.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5790749192237854,
        -0.5868234634399414,
        -0.5659598708152771
      ],
      "plane_d": -3471.613525390625,
      "bbox_min": [
        -3860.00048828125,
        -3089.800048828125,
        1013.2975463867188
      ],
      "bbox_max": [
        -3859.405029296875,
        -3084.7685546875,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6717481017112732,
        -0.48749372363090515,
        -0.5577673316001892
      ],
      "plane_d": -3531.1689453125,
      "bbox_min": [
        -3860.00048828125,
        -3085.430908203125,
        1013.2975463867188
      ],
      "bbox_max": [
        -3859.405029296875,
        -3084.7685546875,
        1014.5936889648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": 2978.01171875,
      "bbox_min": [
        -3840.00048828125,
        -3089.800048828125,
        1019.123779296875
      ],
      "bbox_max": [
        -3838.50048828125,
        -3089.2841796875,
        1020.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7608899474143982,
        -0.6488809585571289
      ],
      "plane_d": -1691.3948974609375,
      "bbox_min": [
        -3859.405029296875,
        -3089.800048828125,
        1010.623779296875
      ],
      "bbox_max": [
        -3840.595947265625,
        -3084.7685546875,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38045504689216614,
        -0.8225350379943848,
        -0.42271751165390015
      ],
      "plane_d": -647.817626953125,
      "bbox_min": [
        -3859.405029296875,
        -3089.800048828125,
        1013.2975463867188
      ],
      "bbox_max": [
        -3840.595947265625,
        -3084.7685546875,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38045504689216614,
        -0.8225350379943848,
        -0.42271748185157776
      ],
      "plane_d": -3577.32177734375,
      "bbox_min": [
        -3859.405029296875,
        -3089.800048828125,
        1013.2975463867188
      ],
      "bbox_max": [
        -3853.00048828125,
        -3084.7685546875,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5023442506790161,
        -0.8183870911598206,
        -0.2790929079055786
      ],
      "plane_d": -4180.48046875,
      "bbox_min": [
        -3859.405029296875,
        -3089.800048828125,
        1013.2975463867188
      ],
      "bbox_max": [
        -3853.00048828125,
        -3084.7685546875,
        1018.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5023442506790161,
        -0.8183870911598206,
        -0.2790929079055786
      ],
      "plane_d": -312.42919921875,
      "bbox_min": [
        -3847.00048828125,
        -3089.800048828125,
        1013.2975463867188
      ],
      "bbox_max": [
        -3840.595947265625,
        -3084.7685546875,
        1018.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": 2978.01171875,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1016.5238037109375
      ],
      "bbox_max": [
        -3838.50048828125,
        -3089.798583984375,
        1020.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1019.123779296875,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1016.5238037109375
      ],
      "bbox_max": [
        -3840.00048828125,
        -3089.798583984375,
        1020.123779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3856.400390625,
      "bbox_min": [
        -3856.400390625,
        -3099.7685546875,
        1019.123779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3089.798583984375,
        1020.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8741621971130371,
        0.0,
        0.48563382029533386
      ],
      "plane_d": -3856.560546875,
      "bbox_min": [
        -3855.00048828125,
        -3099.7685546875,
        1019.123779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3089.800048828125,
        1020.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8741621971130371,
        0.48563382029533386
      ],
      "plane_d": 2214.2939453125,
      "bbox_min": [
        -3855.00048828125,
        -3099.7685546875,
        1019.123779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3099.212890625,
        1020.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1018.123779296875,
      "bbox_min": [
        -3855.00048828125,
        -3099.7685546875,
        1016.5238037109375
      ],
      "bbox_max": [
        -3845.00048828125,
        -3089.800048828125,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1016.5238037109375,
      "bbox_min": [
        -3853.889404296875,
        -3098.657470703125,
        1016.5238037109375
      ],
      "bbox_max": [
        -3846.111572265625,
        -3089.800048828125,
        1018.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.874147891998291,
        0.0,
        -0.4856599271297455
      ],
      "plane_d": -2874.407470703125,
      "bbox_min": [
        -3853.889404296875,
        -3098.657470703125,
        1016.5238037109375
      ],
      "bbox_max": [
        -3846.111572265625,
        -3089.800048828125,
        1018.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8741479516029358,
        0.0,
        -0.48565995693206787
      ],
      "plane_d": 3856.532470703125,
      "bbox_min": [
        -3853.889404296875,
        -3098.657470703125,
        1016.5238037109375
      ],
      "bbox_max": [
        -3846.111572265625,
        -3089.800048828125,
        1018.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8741478323936462,
        -0.4856598973274231
      ],
      "plane_d": -2214.222900390625,
      "bbox_min": [
        -3853.889404296875,
        -3098.657470703125,
        1016.5238037109375
      ],
      "bbox_max": [
        -3846.111572265625,
        -3097.7685546875,
        1018.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6689738035202026,
        0.0,
        -0.7432860732078552
      ],
      "plane_d": 3329.705078125,
      "bbox_min": [
        -3855.00048828125,
        -3099.7685546875,
        1018.123779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3089.800048828125,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6689737439155579,
        0.0,
        -0.7432860136032104
      ],
      "plane_d": -1821.3935546875,
      "bbox_min": [
        -3855.00048828125,
        -3099.7685546875,
        1018.123779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3089.800048828125,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.6689737439155579,
        -0.7432860136032104
      ],
      "plane_d": -1316.163330078125,
      "bbox_min": [
        -3855.00048828125,
        -3099.7685546875,
        1018.123779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3089.800048828125,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8741623759269714,
        0.0,
        0.485633909702301
      ],
      "plane_d": 2874.48974609375,
      "bbox_min": [
        -3854.44482421875,
        -3099.212890625,
        1018.123779296875
      ],
      "bbox_max": [
        -3845.55615234375,
        -3089.800048828125,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8741621971130371,
        0.0,
        0.48563382029533386
      ],
      "plane_d": -3856.560546875,
      "bbox_min": [
        -3854.44482421875,
        -3099.212890625,
        1018.123779296875
      ],
      "bbox_max": [
        -3845.55615234375,
        -3089.800048828125,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8741621971130371,
        0.48563382029533386
      ],
      "plane_d": 2214.2939453125,
      "bbox_min": [
        -3854.44482421875,
        -3099.212890625,
        1018.123779296875
      ],
      "bbox_max": [
        -3845.55615234375,
        -3098.657470703125,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3086.768310546875,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3084.7685546875,
        1034.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3855.00048828125,
      "bbox_min": [
        -3855.00048828125,
        -3086.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3084.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3845.00048828125,
      "bbox_min": [
        -3855.00048828125,
        -3086.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3084.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1032.623779296875,
      "bbox_min": [
        -3855.00048828125,
        -3086.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -3845.00048828125,
        -3084.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": 2978.01171875,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3086.7685546875,
        1034.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3840.00048828125,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3086.7685546875,
        1034.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3089.7685546875,
      "bbox_min": [
        -3840.00048828125,
        -3099.7685546875,
        1022.123779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3089.7685546875,
        1032.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3099.7685546875,
      "bbox_min": [
        -3840.00048828125,
        -3099.7685546875,
        1022.123779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3089.7685546875,
        1032.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1032.623779296875,
      "bbox_min": [
        -3840.00048828125,
        -3099.7685546875,
        1022.123779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3089.7685546875,
        1032.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1022.123779296875,
      "bbox_min": [
        -3840.00048828125,
        -3099.7685546875,
        1022.123779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3089.7685546875,
        1022.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3713906705379486,
        -0.0,
        -0.9284766912460327
      ],
      "plane_d": -467.373291015625,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3086.7685546875,
        1034.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 1472.65234375,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3086.7685546875,
        1023.5550537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3713906705379486,
        0.0,
        0.9284766912460327
      ],
      "plane_d": 484.54998779296875,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3086.7685546875,
        1023.5550537109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3099.7685546875,
      "bbox_min": [
        -3860.00048828125,
        -3099.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3855.00048828125,
        -3089.7685546875,
        1022.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1021.123779296875,
      "bbox_min": [
        -3860.00048828125,
        -3099.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3855.00048828125,
        -3089.7685546875,
        1022.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1020.623779296875,
      "bbox_min": [
        -3860.00048828125,
        -3099.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3855.00048828125,
        -3089.7685546875,
        1021.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3856.400390625,
      "bbox_min": [
        -3860.00048828125,
        -3099.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3855.00048828125,
        -3089.7685546875,
        1020.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998760223388672,
        0.015745118260383606
      ],
      "plane_d": -3105.47900390625,
      "bbox_min": [
        -3860.00048828125,
        -3089.800048828125,
        1020.123779296875
      ],
      "bbox_max": [
        -3856.400390625,
        -3089.7919921875,
        1020.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998760223388672,
        0.015745118260383606
      ],
      "plane_d": -3105.47900390625,
      "bbox_min": [
        -3856.400390625,
        -3089.800048828125,
        1020.123779296875
      ],
      "bbox_max": [
        -3855.00048828125,
        -3089.7919921875,
        1020.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3857.6005859375,
      "bbox_min": [
        -3860.00048828125,
        -3099.7685546875,
        1020.623779296875
      ],
      "bbox_max": [
        -3856.25048828125,
        -3089.7685546875,
        1021.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998760223388672,
        0.015745118260383606
      ],
      "plane_d": -3105.47900390625,
      "bbox_min": [
        -3860.00048828125,
        -3089.7919921875,
        1020.623779296875
      ],
      "bbox_max": [
        -3857.6005859375,
        -3089.7841796875,
        1021.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998760223388672,
        0.015745118260383606
      ],
      "plane_d": -3105.47900390625,
      "bbox_min": [
        -3857.6005859375,
        -3089.7919921875,
        1020.623779296875
      ],
      "bbox_max": [
        -3856.25048828125,
        -3089.7841796875,
        1021.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1021.623779296875,
      "bbox_min": [
        -3860.00048828125,
        -3099.7685546875,
        1021.123779296875
      ],
      "bbox_max": [
        -3857.50048828125,
        -3089.7685546875,
        1022.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3858.800537109375,
      "bbox_min": [
        -3860.00048828125,
        -3099.7685546875,
        1021.123779296875
      ],
      "bbox_max": [
        -3857.50048828125,
        -3089.7685546875,
        1021.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998760223388672,
        0.015745118260383606
      ],
      "plane_d": -3105.47900390625,
      "bbox_min": [
        -3860.00048828125,
        -3089.7841796875,
        1021.123779296875
      ],
      "bbox_max": [
        -3858.800537109375,
        -3089.7763671875,
        1021.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998760223388672,
        0.015745118260383606
      ],
      "plane_d": -3105.47900390625,
      "bbox_min": [
        -3858.800537109375,
        -3089.7841796875,
        1021.123779296875
      ],
      "bbox_max": [
        -3857.50048828125,
        -3089.7763671875,
        1021.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998760223388672,
        0.015745118260383606
      ],
      "plane_d": -3105.47900390625,
      "bbox_min": [
        -3860.00048828125,
        -3089.7763671875,
        1021.623779296875
      ],
      "bbox_max": [
        -3858.75048828125,
        -3089.7685546875,
        1022.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3713906705379486,
        0.0,
        0.9284766912460327
      ],
      "plane_d": -2375.158447265625,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3086.7685546875,
        1023.5550537109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3099.7685546875,
      "bbox_min": [
        -3845.00048828125,
        -3099.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3089.7685546875,
        1022.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1021.123779296875,
      "bbox_min": [
        -3845.00048828125,
        -3099.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3089.7685546875,
        1022.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1020.623779296875,
      "bbox_min": [
        -3845.00048828125,
        -3099.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3089.7685546875,
        1021.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3843.6005859375,
      "bbox_min": [
        -3845.00048828125,
        -3099.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3089.7685546875,
        1020.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998761415481567,
        0.015745120123028755
      ],
      "plane_d": -3105.479248046875,
      "bbox_min": [
        -3843.6005859375,
        -3089.800048828125,
        1020.123779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3089.7919921875,
        1020.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998761415481567,
        0.015745120123028755
      ],
      "plane_d": -3105.479248046875,
      "bbox_min": [
        -3845.00048828125,
        -3089.800048828125,
        1020.123779296875
      ],
      "bbox_max": [
        -3843.6005859375,
        -3089.7919921875,
        1020.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3842.400390625,
      "bbox_min": [
        -3843.75048828125,
        -3099.7685546875,
        1020.623779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3089.7685546875,
        1021.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998761415481567,
        0.015745120123028755
      ],
      "plane_d": -3105.479248046875,
      "bbox_min": [
        -3842.400390625,
        -3089.7919921875,
        1020.623779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3089.7841796875,
        1021.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998761415481567,
        0.015745120123028755
      ],
      "plane_d": -3105.479248046875,
      "bbox_min": [
        -3843.75048828125,
        -3089.7919921875,
        1020.623779296875
      ],
      "bbox_max": [
        -3842.400390625,
        -3089.7841796875,
        1021.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1021.623779296875,
      "bbox_min": [
        -3842.50048828125,
        -3099.7685546875,
        1021.123779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3089.7685546875,
        1022.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3841.200439453125,
      "bbox_min": [
        -3842.50048828125,
        -3099.7685546875,
        1021.123779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3089.7685546875,
        1021.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998761415481567,
        0.015745120123028755
      ],
      "plane_d": -3105.479248046875,
      "bbox_min": [
        -3841.200439453125,
        -3089.7841796875,
        1021.123779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3089.7763671875,
        1021.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998761415481567,
        0.015745120123028755
      ],
      "plane_d": -3105.479248046875,
      "bbox_min": [
        -3842.50048828125,
        -3089.7841796875,
        1021.123779296875
      ],
      "bbox_max": [
        -3841.200439453125,
        -3089.7763671875,
        1021.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9998761415481567,
        0.015745120123028755
      ],
      "plane_d": -3105.479248046875,
      "bbox_min": [
        -3841.25048828125,
        -3089.7763671875,
        1021.623779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3089.7685546875,
        1022.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2626116871833801,
        0.7071099281311035,
        0.6565291881561279
      ],
      "plane_d": 514.5155029296875,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3102.7685546875,
        1023.5550537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2626146674156189,
        0.7071019411087036,
        0.6565366387367249
      ],
      "plane_d": 2536.6044921875,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3854.4228515625,
        -3102.7685546875,
        1023.5550537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5790748596191406,
        -0.5868234634399414,
        -0.5659598708152771
      ],
      "plane_d": 987.2638549804688,
      "bbox_min": [
        -3838.50048828125,
        -3089.2841796875,
        1020.123779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3087.62451171875,
        1021.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6717481017112732,
        -0.48749372363090515,
        -0.5577673316001892
      ],
      "plane_d": 1641.2919921875,
      "bbox_min": [
        -3837.4599609375,
        -3088.7685546875,
        1020.123779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3087.62451171875,
        1021.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8746604323387146,
        -0.4847361445426941,
        0.0
      ],
      "plane_d": 1858.834716796875,
      "bbox_min": [
        -3837.00048828125,
        -3088.7685546875,
        1017.6277465820312
      ],
      "bbox_max": [
        -3834.78369140625,
        -3084.7685546875,
        1033.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6717481017112732,
        -0.48749372363090515,
        -0.5577673316001892
      ],
      "plane_d": 1641.2919921875,
      "bbox_min": [
        -3837.00048828125,
        -3088.7685546875,
        1017.6277465820312
      ],
      "bbox_max": [
        -3834.78369140625,
        -3084.7685546875,
        1021.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8746603727340698,
        -0.4847361147403717,
        0.0
      ],
      "plane_d": -4876.05126953125,
      "bbox_min": [
        -3865.21728515625,
        -3088.7685546875,
        1017.6277465820312
      ],
      "bbox_max": [
        -3863.00048828125,
        -3084.7685546875,
        1033.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6717481017112732,
        -0.48749372363090515,
        -0.5577673316001892
      ],
      "plane_d": -3531.1689453125,
      "bbox_min": [
        -3865.21728515625,
        -3088.7685546875,
        1017.6277465820312
      ],
      "bbox_max": [
        -3863.00048828125,
        -3084.7685546875,
        1021.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16160258650779724,
        -0.3835492432117462,
        0.9092714190483093
      ],
      "plane_d": -1504.4700927734375,
      "bbox_min": [
        -3845.00048828125,
        -3102.7685546875,
        1033.623779296875
      ],
      "bbox_max": [
        -3837.00048828125,
        -3084.7685546875,
        1034.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3840.00048828125,
      "bbox_min": [
        -3844.50048828125,
        -3105.7685546875,
        1019.123779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3102.7685546875,
        1034.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -521.3017578125,
      "bbox_min": [
        -3844.50048828125,
        -3105.7685546875,
        1019.123779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3102.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1019.123779296875,
      "bbox_min": [
        -3843.00048828125,
        -3105.7685546875,
        1019.123779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3102.7685546875,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1019.123779296875,
      "bbox_min": [
        -3844.50048828125,
        -3105.7685546875,
        1019.123779296875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3102.7685546875,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2626146674156189,
        0.7071019411087036,
        -0.6565366387367249
      ],
      "plane_d": 1863.488525390625,
      "bbox_min": [
        -3844.50048828125,
        -3105.7685546875,
        1030.5926513671875
      ],
      "bbox_max": [
        -3840.00048828125,
        -3102.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16160258650779724,
        -0.383549302816391,
        0.9092714190483093
      ],
      "plane_d": -2748.810546875,
      "bbox_min": [
        -3863.00048828125,
        -3102.7685546875,
        1033.623779296875
      ],
      "bbox_max": [
        -3855.00048828125,
        -3084.7685546875,
        1034.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3860.00048828125,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1019.123779296875
      ],
      "bbox_max": [
        -3855.500732421875,
        -3102.7685546875,
        1034.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 4923.42138671875,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1019.123779296875
      ],
      "bbox_max": [
        -3855.500732421875,
        -3102.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1019.123779296875,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1019.123779296875
      ],
      "bbox_max": [
        -3857.0,
        -3102.7685546875,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1019.123779296875,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1019.123779296875
      ],
      "bbox_max": [
        -3855.500732421875,
        -3102.7685546875,
        1019.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2626116871833801,
        0.7071099281311035,
        -0.6565291881561279
      ],
      "plane_d": 3885.62744140625,
      "bbox_min": [
        -3860.00048828125,
        -3105.7685546875,
        1030.5926513671875
      ],
      "bbox_max": [
        -3855.5009765625,
        -3102.7685546875,
        1032.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6246950626373291,
        0.7808687686920166
      ],
      "plane_d": -2738.068603515625,
      "bbox_min": [
        -3861.454833984375,
        -3089.7685546875,
        1034.623779296875
      ],
      "bbox_max": [
        -3838.546142578125,
        -3084.7685546875,
        1038.2772216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24497897922992706,
        -0.4443757236003876,
        0.8616933226585388
      ],
      "plane_d": -1322.602294921875,
      "bbox_min": [
        -3861.454833984375,
        -3089.7685546875,
        1034.623779296875
      ],
      "bbox_max": [
        -3838.546142578125,
        -3084.7685546875,
        1038.2772216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16160258650779724,
        -0.383549302816391,
        0.9092714190483093
      ],
      "plane_d": -2748.810546875,
      "bbox_min": [
        -3861.454833984375,
        -3089.7685546875,
        1034.623779296875
      ],
      "bbox_max": [
        -3838.829833984375,
        -3084.7685546875,
        1037.7373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7327498197555542,
        0.30480292439460754,
        0.6084184050559998
      ],
      "plane_d": 3124.1513671875,
      "bbox_min": [
        -3840.595947265625,
        -3086.36669921875,
        1034.623779296875
      ],
      "bbox_max": [
        -3838.829833984375,
        -3084.7685546875,
        1035.9500732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24497897922992706,
        -0.4443757236003876,
        0.8616933226585388
      ],
      "plane_d": -3208.940673828125,
      "bbox_min": [
        -3859.146240234375,
        -3089.7685546875,
        1034.623779296875
      ],
      "bbox_max": [
        -3851.108642578125,
        -3085.062255859375,
        1037.7373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16160258650779724,
        -0.3835492432117462,
        0.9092714190483093
      ],
      "plane_d": -1504.4700927734375,
      "bbox_min": [
        -3845.00048828125,
        -3089.7685546875,
        1034.623779296875
      ],
      "bbox_max": [
        -3838.546142578125,
        -3084.7685546875,
        1035.9500732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7327498197555542,
        0.30480292439460754,
        0.6084184050559998
      ],
      "plane_d": 3124.1513671875,
      "bbox_min": [
        -3840.595947265625,
        -3087.049072265625,
        1034.623779296875
      ],
      "bbox_max": [
        -3838.546142578125,
        -3084.7685546875,
        1035.9500732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22604458034038544,
        0.0,
        -0.9741169214248657
      ],
      "plane_d": 195.85345458984375,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1059.8101806640625
      ],
      "bbox_max": [
        -3782.5,
        -3094.7685546875,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.22604458034038544,
        0.0,
        -0.9741169214248657
      ],
      "plane_d": 1923.580078125,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1059.8101806640625
      ],
      "bbox_max": [
        -3782.5,
        -3094.7685546875,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.654643714427948,
        0.0,
        0.7559375762939453
      ],
      "plane_d": -3330.1748046875,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1059.8101806640625
      ],
      "bbox_max": [
        -3782.5,
        -3094.7685546875,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25056904554367065,
        -0.6845492124557495,
        -0.6845492124557495
      ],
      "plane_d": -2339.9619140625,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1059.8101806640625
      ],
      "bbox_max": [
        -3782.5,
        -3094.7685546875,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25056955218315125,
        -0.684543788433075,
        -0.684554398059845
      ],
      "plane_d": -424.76287841796875,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1059.8101806640625
      ],
      "bbox_max": [
        -3782.5,
        -3094.7685546875,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25056278705596924,
        -0.9351131319999695,
        -0.2505628168582916
      ],
      "plane_d": -3584.3662109375,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1059.8101806640625
      ],
      "bbox_max": [
        -3782.5,
        -3094.7685546875,
        1084.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25056275725364685,
        -0.9351130723953247,
        -0.25056275725364685
      ],
      "plane_d": -1669.2392578125,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1059.8101806640625
      ],
      "bbox_max": [
        -3782.5,
        -3094.7685546875,
        1084.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3799.999755859375,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1059.8101806640625
      ],
      "bbox_max": [
        -3782.5,
        -3094.7685546875,
        1084.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.007501009851694107,
        0.0,
        -0.9999719262123108
      ],
      "plane_d": 1100.947509765625,
      "bbox_min": [
        -3800.00048828125,
        -3127.300048828125,
        1059.8101806640625
      ],
      "bbox_max": [
        -3782.5,
        -3107.2685546875,
        1077.049072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071162462234497,
        0.7070974111557007
      ],
      "plane_d": 1440.041015625,
      "bbox_min": [
        -3800.0,
        -3127.300048828125,
        1072.4737548828125
      ],
      "bbox_max": [
        -3782.5,
        -3108.943359375,
        1077.049072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071162462234497,
        0.7070974111557007
      ],
      "plane_d": -2972.037109375,
      "bbox_min": [
        -3800.0,
        -3127.300048828125,
        1075.767578125
      ],
      "bbox_max": [
        -3782.5,
        -3126.0185546875,
        1077.049072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03997047245502472,
        -0.9992008805274963,
        0.0
      ],
      "plane_d": -3258.371826171875,
      "bbox_min": [
        -3800.00048828125,
        -3109.66845703125,
        1059.8101806640625
      ],
      "bbox_max": [
        -3782.500244140625,
        -3107.2685546875,
        1072.6051025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9659211039543152,
        0.25883668661117554
      ],
      "plane_d": 2725.3984375,
      "bbox_min": [
        -3800.0,
        -3109.10693359375,
        1059.810302734375
      ],
      "bbox_max": [
        -3782.500244140625,
        -3107.2685546875,
        1072.6051025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9659211039543152,
        -0.25883668661117554
      ],
      "plane_d": 3277.35400390625,
      "bbox_min": [
        -3800.0,
        -3109.10693359375,
        1059.810302734375
      ],
      "bbox_max": [
        -3782.500244140625,
        -3107.2685546875,
        1072.6051025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071162462234497,
        -0.7070974111557007
      ],
      "plane_d": 2947.888916015625,
      "bbox_min": [
        -3800.0,
        -3109.10693359375,
        1059.810302734375
      ],
      "bbox_max": [
        -3782.500244140625,
        -3108.943359375,
        1072.6051025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071162462234497,
        0.7070974111557007
      ],
      "plane_d": 1440.041015625,
      "bbox_min": [
        -3800.0,
        -3109.07470703125,
        1072.4737548828125
      ],
      "bbox_max": [
        -3782.500244140625,
        -3108.943359375,
        1072.6051025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6546636819839478,
        0.0,
        -0.7559202909469604
      ],
      "plane_d": -1673.5587158203125,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1059.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3094.7685546875,
        1084.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6947561502456665,
        -0.6947376728057861,
        -0.18615436553955078
      ],
      "plane_d": -4600.32763671875,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1059.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3094.7685546875,
        1084.9737548828125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6947435736656189,
        -0.6947460174560547,
        -0.18617023527622223
      ],
      "plane_d": 709.8455810546875,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1059.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3094.7685546875,
        1084.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6947321891784668,
        -0.5086063742637634,
        -0.5085928440093994
      ],
      "plane_d": 1634.289306640625,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1059.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3094.7685546875,
        1084.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6947534680366516,
        -0.5085812211036682,
        -0.5085890889167786
      ],
      "plane_d": -3675.7646484375,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1059.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3094.7685546875,
        1084.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9553250670433044,
        0.0,
        -0.29555708169937134
      ],
      "plane_d": 3989.931396484375,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1059.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3094.7685546875,
        1079.268798828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6947627663612366,
        0.6947280764579773,
        -0.18616542220115662
      ],
      "plane_d": 4997.29931640625,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1059.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3094.7685546875,
        1079.268798828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2505628168582916,
        -0.9351130723953247,
        0.25056275725364685
      ],
      "plane_d": -2203.551025390625,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1060.1160888671875
      ],
      "bbox_max": [
        -3800.0,
        -3094.7685546875,
        1079.268798828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6947352886199951,
        -0.6947538256645203,
        0.18617232143878937
      ],
      "plane_d": 312.788818359375,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1060.1160888671875
      ],
      "bbox_max": [
        -3800.0,
        -3098.117919921875,
        1079.268798828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1066.2237548828125,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1060.1160888671875
      ],
      "bbox_max": [
        -3800.0,
        -3107.2685546875,
        1079.268798828125
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.5299989581108093,
        -0.0,
        0.8479983806610107
      ],
      "plane_d": 1123.090087890625,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1060.1160888671875
      ],
      "bbox_max": [
        -3815.2275390625,
        -3107.2685546875,
        1066.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.963616132736206,
        -0.2581813633441925,
        0.06918454170227051
      ],
      "plane_d": 2827.4619140625,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1060.1160888671875
      ],
      "bbox_max": [
        -3815.2275390625,
        -3107.2685546875,
        1066.2237548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.963616132736206,
        -0.1890050768852234,
        0.18900004029273987
      ],
      "plane_d": 2915.52587890625,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1060.1160888671875
      ],
      "bbox_max": [
        -3815.2275390625,
        -3109.647705078125,
        1066.2237548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3112.7685546875,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1060.1160888671875
      ],
      "bbox_max": [
        -3815.2275390625,
        -3112.7685546875,
        1066.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5269442200660706,
        -0.0,
        -0.84989994764328
      ],
      "plane_d": -1110.2705078125,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1060.1160888671875
      ],
      "bbox_max": [
        -3815.2275390625,
        -3112.7685546875,
        1066.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3123.768310546875,
      "bbox_min": [
        -3826.693359375,
        -3126.7685546875,
        1060.1160888671875
      ],
      "bbox_max": [
        -3815.2275390625,
        -3112.7685546875,
        1066.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3115.7685546875,
      "bbox_min": [
        -3825.0,
        -3115.7685546875,
        1060.1160888671875
      ],
      "bbox_max": [
        -3815.2275390625,
        -3112.7685546875,
        1066.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3825.0,
      "bbox_min": [
        -3825.0,
        -3115.7685546875,
        1065.173828125
      ],
      "bbox_max": [
        -3825.0,
        -3112.7685546875,
        1066.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3825.0,
      "bbox_min": [
        -3826.693359375,
        -3126.7685546875,
        1065.173828125
      ],
      "bbox_max": [
        -3825.0,
        -3123.7685546875,
        1066.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3126.7685546875,
      "bbox_min": [
        -3826.693359375,
        -3126.7685546875,
        1065.173828125
      ],
      "bbox_max": [
        -3825.0,
        -3126.7685546875,
        1066.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.963616132736206,
        -0.2581813633441925,
        -0.06918454170227051
      ],
      "plane_d": -4438.39453125,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1060.38525390625
      ],
      "bbox_max": [
        -3825.0,
        -3112.7685546875,
        1066.2237548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.963616132736206,
        -0.1890050768852234,
        -0.18900004029273987
      ],
      "plane_d": -4094.830078125,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1060.38525390625
      ],
      "bbox_max": [
        -3825.0,
        -3112.7685546875,
        1066.2237548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -4922.7138671875,
      "bbox_min": [
        -3838.0,
        -3126.7685546875,
        1065.173828125
      ],
      "bbox_max": [
        -3835.0,
        -3112.7685546875,
        1066.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -510.69482421875,
      "bbox_min": [
        -3838.0,
        -3115.7685546875,
        1065.173828125
      ],
      "bbox_max": [
        -3835.0,
        -3112.7685546875,
        1066.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9553250670433044,
        0.0,
        -0.29555708169937134
      ],
      "plane_d": -3359.671630859375,
      "bbox_min": [
        -3846.650390625,
        -3120.374755859375,
        1065.173828125
      ],
      "bbox_max": [
        -3846.325439453125,
        -3119.162353515625,
        1066.2237548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9553250670433044,
        0.0,
        -0.29555708169937134
      ],
      "plane_d": -3359.671630859375,
      "bbox_min": [
        -3846.325439453125,
        -3123.135009765625,
        1060.3929443359375
      ],
      "bbox_max": [
        -3844.846435546875,
        -3116.402099609375,
        1065.173828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9636160731315613,
        -0.2581813633441925,
        -0.06918453425168991
      ],
      "plane_d": 2974.994140625,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1066.2237548828125
      ],
      "bbox_max": [
        -3800.0,
        -3107.2685546875,
        1079.268798828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9636161923408508,
        -0.1890050619840622,
        -0.18900002539157867
      ],
      "plane_d": 3318.558837890625,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1066.2237548828125
      ],
      "bbox_max": [
        -3800.0,
        -3108.943359375,
        1079.268798828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.963616132736206,
        0.1890050768852234,
        -0.18900004029273987
      ],
      "plane_d": 4497.86279296875,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1066.2237548828125
      ],
      "bbox_max": [
        -3800.0,
        -3112.7685546875,
        1079.268798828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.963616132736206,
        0.2581813633441925,
        -0.06918454170227051
      ],
      "plane_d": 4585.9267578125,
      "bbox_min": [
        -3846.650390625,
        -3127.300048828125,
        1066.2237548828125
      ],
      "bbox_max": [
        -3800.0,
        -3112.7685546875,
        1079.268798828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7070314288139343,
        -0.7070314288139343,
        0.014606152661144733
      ],
      "plane_d": -4937.7626953125,
      "bbox_min": [
        -3843.30126953125,
        -3127.300048828125,
        1066.2237548828125
      ],
      "bbox_max": [
        -3800.0,
        -3112.7685546875,
        1079.268798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070314288139343,
        0.7070314288139343,
        0.014606167562305927
      ],
      "plane_d": -526.2138671875,
      "bbox_min": [
        -3838.0,
        -3127.300048828125,
        1066.2237548828125
      ],
      "bbox_max": [
        -3800.0,
        -3112.7685546875,
        1079.268798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0821465328335762,
        0.9944385886192322,
        -0.06590632349252701
      ],
      "plane_d": 2861.388671875,
      "bbox_min": [
        -3838.0,
        -3127.300048828125,
        1066.2237548828125
      ],
      "bbox_max": [
        -3800.0,
        -3112.7685546875,
        1079.268798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9387627243995667,
        0.0,
        0.3445642590522766
      ],
      "plane_d": -3970.35400390625,
      "bbox_min": [
        -3838.0,
        -3127.300048828125,
        1066.2237548828125
      ],
      "bbox_max": [
        -3800.0,
        -3123.2685546875,
        1079.268798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35266005992889404,
        -0.8919506669044495,
        0.2829398214817047
      ],
      "plane_d": -1738.1492919921875,
      "bbox_min": [
        -3838.0,
        -3127.300048828125,
        1066.2237548828125
      ],
      "bbox_max": [
        -3800.0,
        -3123.2685546875,
        1079.268798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2294965046066864e-08,
        0.984200119972229,
        -0.17705920338630676
      ],
      "plane_d": 3263.197998046875,
      "bbox_min": [
        -3838.0,
        -3126.7685546875,
        1066.2237548828125
      ],
      "bbox_max": [
        -3834.177001953125,
        -3123.2685546875,
        1071.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.958844780921936,
        0.0,
        -0.28393059968948364
      ],
      "plane_d": 3979.9033203125,
      "bbox_min": [
        -3836.10009765625,
        -3126.7685546875,
        1066.2237548828125
      ],
      "bbox_max": [
        -3834.177001953125,
        -3123.2685546875,
        1071.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7799922823905945,
        -0.0,
        0.6257892847061157
      ],
      "plane_d": 2321.65771484375,
      "bbox_min": [
        -3836.10009765625,
        -3125.5615234375,
        1069.0030517578125
      ],
      "bbox_max": [
        -3834.177001953125,
        -3123.2685546875,
        1071.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.694758951663971,
        0.5085774064064026,
        -0.5085852742195129
      ],
      "plane_d": -502.490478515625,
      "bbox_min": [
        -3802.56298828125,
        -3127.300048828125,
        1075.767578125
      ],
      "bbox_max": [
        -3800.0,
        -3126.0185546875,
        1079.268798828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0821465477347374,
        -0.9944387078285217,
        -0.0659063309431076
      ],
      "plane_d": -3343.4482421875,
      "bbox_min": [
        -3838.0,
        -3123.0185546875,
        1066.2237548828125
      ],
      "bbox_max": [
        -3834.177001953125,
        -3112.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9387627243995667,
        0.0,
        0.3445642590522766
      ],
      "plane_d": -3970.35400390625,
      "bbox_min": [
        -3838.0,
        -3116.2685546875,
        1066.2237548828125
      ],
      "bbox_max": [
        -3834.177001953125,
        -3112.7685546875,
        1071.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35266003012657166,
        0.8919506669044495,
        0.2829398512840271
      ],
      "plane_d": 3827.2099609375,
      "bbox_min": [
        -3838.0,
        -3116.2685546875,
        1066.2237548828125
      ],
      "bbox_max": [
        -3834.177001953125,
        -3112.7685546875,
        1071.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9842002391815186,
        -0.17705920338630676
      ],
      "plane_d": -2877.75537109375,
      "bbox_min": [
        -3838.0,
        -3116.2685546875,
        1066.2237548828125
      ],
      "bbox_max": [
        -3834.177001953125,
        -3112.7685546875,
        1071.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9588448405265808,
        0.0,
        -0.28393059968948364
      ],
      "plane_d": 3979.903564453125,
      "bbox_min": [
        -3836.10009765625,
        -3116.2685546875,
        1066.2237548828125
      ],
      "bbox_max": [
        -3834.177001953125,
        -3112.7685546875,
        1071.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7799922823905945,
        -0.0,
        0.6257892847061157
      ],
      "plane_d": 2321.65771484375,
      "bbox_min": [
        -3836.10009765625,
        -3116.2685546875,
        1069.0030517578125
      ],
      "bbox_max": [
        -3834.177001953125,
        -3113.9755859375,
        1071.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -3837.5,
        -3123.0185546875,
        1066.2237548828125
      ],
      "bbox_max": [
        -3835.5,
        -3116.5185546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.941743791103363,
        0.0,
        0.33633118867874146
      ],
      "plane_d": -3972.546142578125,
      "bbox_min": [
        -3837.5,
        -3123.0185546875,
        1066.2237548828125
      ],
      "bbox_max": [
        -3835.5,
        -3116.5185546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.941743791103363,
        -0.0,
        0.33633118867874146
      ],
      "plane_d": 3253.4541015625,
      "bbox_min": [
        -3837.5,
        -3123.0185546875,
        1066.2237548828125
      ],
      "bbox_max": [
        -3835.5,
        -3116.5185546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9307425618171692,
        0.3656749427318573
      ],
      "plane_d": -3296.61767578125,
      "bbox_min": [
        -3837.5,
        -3123.0185546875,
        1066.2237548828125
      ],
      "bbox_max": [
        -3835.5,
        -3116.5185546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9307425618171692,
        0.3656749427318573
      ],
      "plane_d": 2510.78515625,
      "bbox_min": [
        -3837.5,
        -3117.068603515625,
        1066.2237548828125
      ],
      "bbox_max": [
        -3835.5,
        -3116.5185546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3836.50048828125,
      "bbox_min": [
        -3836.50048828125,
        -3122.468505859375,
        1067.623779296875
      ],
      "bbox_max": [
        -3836.50048828125,
        -3117.068603515625,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6947342753410339,
        -0.5085943341255188,
        0.5086022019386292
      ],
      "plane_d": -4807.73828125,
      "bbox_min": [
        -3843.30126953125,
        -3127.300048828125,
        1075.767578125
      ],
      "bbox_max": [
        -3840.738037109375,
        -3126.0185546875,
        1079.268798828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.947304904460907,
        0.3203330934047699
      ],
      "plane_d": -3286.84375,
      "bbox_min": [
        -3922.50048828125,
        -3129.800048828125,
        982.623779296875
      ],
      "bbox_max": [
        -3780.0,
        -3117.352294921875,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3127.2998046875,
      "bbox_min": [
        -3922.50048828125,
        -3129.7685546875,
        982.623779296875
      ],
      "bbox_max": [
        -3780.0,
        -3117.352294921875,
        1012.5003662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592269897461,
        -0.0,
        0.32399341464042664
      ],
      "plane_d": 3250.425537109375,
      "bbox_min": [
        -3782.5,
        -3129.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3127.300048828125,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3898577094078064,
        0.0,
        0.9208751916885376
      ],
      "plane_d": 603.5532836914062,
      "bbox_min": [
        -3922.50048828125,
        -3127.300048828125,
        1004.2789306640625
      ],
      "bbox_max": [
        -3920.324951171875,
        -3124.484619140625,
        1005.4025268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3922.50048828125,
      "bbox_min": [
        -3922.50048828125,
        -3127.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3922.50048828125,
        -3124.800048828125,
        1005.4025268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5157708525657654,
        -4.578932021104265e-06,
        0.8567266464233398
      ],
      "plane_d": -2812.09912109375,
      "bbox_min": [
        -3922.50048828125,
        -3127.300048828125,
        982.623779296875
      ],
      "bbox_max": [
        -3780.0,
        -3117.352294921875,
        1012.5003662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592269897461,
        -0.0,
        0.32399341464042664
      ],
      "plane_d": 3250.425537109375,
      "bbox_min": [
        -3780.42724609375,
        -3127.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3124.7998046875,
        1006.4476928710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4313707649707794,
        -0.07492615282535553,
        0.8990580439567566
      ],
      "plane_d": -2765.5888671875,
      "bbox_min": [
        -3922.50048828125,
        -3127.300048828125,
        982.623779296875
      ],
      "bbox_max": [
        -3780.42724609375,
        -3117.352294921875,
        1012.5003662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -8.877840627974365e-06,
        0.0
      ],
      "plane_d": -3782.52783203125,
      "bbox_min": [
        -3922.50048828125,
        -3127.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.42724609375,
        -3124.800048828125,
        1012.5003662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592269897461,
        -0.0,
        0.32399341464042664
      ],
      "plane_d": 3250.425537109375,
      "bbox_min": [
        -3782.5,
        -3127.300048828125,
        1006.4476928710938
      ],
      "bbox_max": [
        -3780.42724609375,
        -3125.22705078125,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3922.50048828125,
      "bbox_min": [
        -3922.50048828125,
        -3127.300048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3922.50048828125,
        -3124.869384765625,
        1012.5003662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4038.96142578125,
      "bbox_min": [
        -3922.50048828125,
        -3129.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.0,
        -3127.300048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        0.323993444442749
      ],
      "plane_d": 3382.87451171875,
      "bbox_min": [
        -3922.50048828125,
        -3129.7841796875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.00048828125,
        -3127.300048828125,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1005.2000122070312,
      "bbox_min": [
        -3925.00048828125,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3129.7685546875,
        1119.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.737154483795166,
        -0.6757242679595947
      ],
      "plane_d": -1618.042724609375,
      "bbox_min": [
        -3925.00048828125,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3129.7685546875,
        1119.786865234375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3184.800048828125,
      "bbox_min": [
        -3925.00048828125,
        -3184.800048828125,
        1022.0
      ],
      "bbox_max": [
        -3780.0,
        -3129.8046875,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7065503001213074,
        -0.7076628804206848
      ],
      "plane_d": 3028.499755859375,
      "bbox_min": [
        -3925.00048828125,
        -3184.800048828125,
        1022.0
      ],
      "bbox_max": [
        -3780.0,
        -3129.8046875,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7375504374504089,
        0.6752921342849731
      ],
      "plane_d": 1617.87939453125,
      "bbox_min": [
        -3925.00048828125,
        -3184.800048828125,
        1022.0
      ],
      "bbox_max": [
        -3780.0,
        -3129.8046875,
        1119.786865234375
      ],
      "face_count": 20
    },
    {
      "plane_normal": [
        0.0,
        -0.7367177605628967,
        -0.6762003898620605
      ],
      "plane_d": -1616.152099609375,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3129.8046875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1063.0,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3129.8046875,
        1079.786865234375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1035.0,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3129.8046875,
        1059.786865234375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.076904296875,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3145.076904296875,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3145.076904296875,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1039.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3145.076904296875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1036.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3145.076904296875,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1056.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1056.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3163.4990234375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3166.2734375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3861.50048828125,
      "bbox_min": [
        -3861.50048828125,
        -3166.454833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3145.076904296875,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1039.786865234375,
      "bbox_min": [
        -3861.50048828125,
        -3166.454833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3145.076904296875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1036.786865234375,
      "bbox_min": [
        -3861.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3145.076904296875,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1056.786865234375,
      "bbox_min": [
        -3861.50048828125,
        -3166.454833984375,
        1056.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3163.4990234375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3861.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3166.2734375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3821.50048828125,
      "bbox_min": [
        -3821.50048828125,
        -3166.454833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.076904296875,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3821.50048828125,
        -3166.454833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.076904296875,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1039.786865234375,
      "bbox_min": [
        -3821.50048828125,
        -3166.454833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.076904296875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1036.786865234375,
      "bbox_min": [
        -3821.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.076904296875,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1056.786865234375,
      "bbox_min": [
        -3821.50048828125,
        -3166.454833984375,
        1056.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3163.4990234375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3821.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3166.2734375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1022.0,
      "bbox_min": [
        -3893.500244140625,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3129.8046875,
        1035.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3826.0,
      "bbox_min": [
        -3893.500244140625,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3129.8046875,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3786.0,
      "bbox_min": [
        -3812.500244140625,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3129.8046875,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3812.500244140625,
      "bbox_min": [
        -3812.500244140625,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3812.500244140625,
        -3129.8046875,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3867.0,
      "bbox_min": [
        -3893.500244140625,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3852.500244140625,
        -3129.8046875,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3852.500244140625,
      "bbox_min": [
        -3852.500244140625,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3852.500244140625,
        -3129.8046875,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3893.500244140625,
      "bbox_min": [
        -3893.500244140625,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3893.5,
        -3129.8046875,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1076.0,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1063.0
      ],
      "bbox_max": [
        -3786.0,
        -3166.854248046875,
        1079.786865234375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1076.492919921875
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1076.492919921875
      ],
      "bbox_max": [
        -3858.50048828125,
        -3181.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1076.492919921875
      ],
      "bbox_max": [
        -3898.50048828125,
        -3181.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3181.7685546875,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1076.492919921875
      ],
      "bbox_max": [
        -3898.50048828125,
        -3181.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3184.7685546875,
      "bbox_min": [
        -3901.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      "bbox_max": [
        -3898.50048828125,
        -3184.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3861.50048828125,
      "bbox_min": [
        -3861.50048828125,
        -3184.7685546875,
        1076.492919921875
      ],
      "bbox_max": [
        -3858.50048828125,
        -3181.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3181.7685546875,
      "bbox_min": [
        -3861.50048828125,
        -3184.7685546875,
        1076.492919921875
      ],
      "bbox_max": [
        -3858.50048828125,
        -3181.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3184.7685546875,
      "bbox_min": [
        -3861.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      "bbox_max": [
        -3858.50048828125,
        -3184.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3821.50048828125,
      "bbox_min": [
        -3821.50048828125,
        -3184.7685546875,
        1076.492919921875
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3821.50048828125,
        -3184.7685546875,
        1076.492919921875
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3181.7685546875,
      "bbox_min": [
        -3821.50048828125,
        -3184.7685546875,
        1076.492919921875
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3184.7685546875,
      "bbox_min": [
        -3821.50048828125,
        -3184.7685546875,
        1079.7655029296875
      ],
      "bbox_max": [
        -3818.50048828125,
        -3184.7685546875,
        1079.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3825.999755859375,
      "bbox_min": [
        -3893.500244140625,
        -3181.316650390625,
        1063.0
      ],
      "bbox_max": [
        -3786.0,
        -3166.854248046875,
        1076.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3785.999755859375,
      "bbox_min": [
        -3812.500244140625,
        -3181.316650390625,
        1063.0
      ],
      "bbox_max": [
        -3786.0,
        -3166.854248046875,
        1076.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3812.500244140625,
      "bbox_min": [
        -3812.500244140625,
        -3181.316650390625,
        1063.0
      ],
      "bbox_max": [
        -3812.500244140625,
        -3166.854248046875,
        1076.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3866.999755859375,
      "bbox_min": [
        -3893.500244140625,
        -3181.316650390625,
        1063.0
      ],
      "bbox_max": [
        -3852.500244140625,
        -3166.854248046875,
        1076.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3852.500244140625,
      "bbox_min": [
        -3852.500244140625,
        -3181.316650390625,
        1063.0
      ],
      "bbox_max": [
        -3852.500244140625,
        -3166.854248046875,
        1076.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        9.590487024979666e-05,
        8.781073847785592e-05
      ],
      "plane_d": 3893.710693359375,
      "bbox_min": [
        -3893.500244140625,
        -3181.316650390625,
        1063.0
      ],
      "bbox_max": [
        -3893.5,
        -3166.854248046875,
        1076.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1022.0,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3131.767822265625,
        1059.786865234375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.738097071647644,
        -0.6746945977210999
      ],
      "plane_d": -1622.046875,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3131.767822265625,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3852.500244140625,
      "bbox_min": [
        -3893.500244140625,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3131.767822265625,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3893.500244140625,
      "bbox_min": [
        -3893.500244140625,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3867.0,
        -3131.767822265625,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3867.0,
      "bbox_min": [
        -3867.0,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3867.0,
        -3131.767822265625,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3812.500244140625,
      "bbox_min": [
        -3826.0,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3131.767822265625,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3826.0,
      "bbox_min": [
        -3826.0,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3826.0,
        -3131.767822265625,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3786.0,
      "bbox_min": [
        -3786.0,
        -3143.699951171875,
        1022.0
      ],
      "bbox_max": [
        -3786.0,
        -3131.767822265625,
        1035.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.33984375,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3166.454833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3145.33984375,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1036.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1056.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3861.50048828125,
      "bbox_min": [
        -3861.50048828125,
        -3166.454833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3145.33984375,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1036.786865234375,
      "bbox_min": [
        -3861.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1056.786865234375,
      "bbox_min": [
        -3861.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3821.50048828125,
      "bbox_min": [
        -3821.50048828125,
        -3166.454833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.33984375,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1039.786865234375,
      "bbox_min": [
        -3821.50048828125,
        -3163.704833984375,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.33984375,
        1056.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1036.786865234375,
      "bbox_min": [
        -3821.50048828125,
        -3145.37158203125,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.33984375,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1056.786865234375,
      "bbox_min": [
        -3821.50048828125,
        -3163.704833984375,
        1056.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3163.69677734375,
        1056.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1119.786865234375,
      "bbox_min": [
        -3925.00048828125,
        -3184.800048828125,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3129.853271484375,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070981860160828,
        -0.0,
        -0.7071154713630676
      ],
      "plane_d": -1895.15478515625,
      "bbox_min": [
        -3925.00048828125,
        -3184.800048828125,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3129.853271484375,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 3553.061279296875,
      "bbox_min": [
        -3925.00048828125,
        -3184.800048828125,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3129.853271484375,
        1119.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25056278705596924,
        0.6845502853393555,
        -0.6845502853393555
      ],
      "plane_d": 1931.3365478515625,
      "bbox_min": [
        -3843.935791015625,
        -3144.7685546875,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3129.853271484375,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25056231021881104,
        0.6845451593399048,
        -0.68455570936203
      ],
      "plane_d": 3846.451416015625,
      "bbox_min": [
        -3843.935791015625,
        -3144.7685546875,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3129.853271484375,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25056231021881104,
        -0.6845451593399048,
        -0.68455570936203
      ],
      "plane_d": -471.5491943359375,
      "bbox_min": [
        -3843.935791015625,
        -3144.7685546875,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3129.853271484375,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25056278705596924,
        -0.6845502853393555,
        -0.6845502853393555
      ],
      "plane_d": -2386.69580078125,
      "bbox_min": [
        -3843.935791015625,
        -3144.7685546875,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3129.853271484375,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2505628168582916,
        0.9351131319999695,
        -0.2505628168582916
      ],
      "plane_d": 2250.306884765625,
      "bbox_min": [
        -3843.935791015625,
        -3144.7685546875,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3129.853271484375,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25056278705596924,
        0.9351131319999695,
        0.2505628168582916
      ],
      "plane_d": 1715.9949951171875,
      "bbox_min": [
        -3843.935791015625,
        -3144.7685546875,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3129.853271484375,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25056278705596924,
        -0.9351131319999695,
        0.2505628168582916
      ],
      "plane_d": -4165.43359375,
      "bbox_min": [
        -3843.935791015625,
        -3144.7685546875,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3129.853271484375,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2505628168582916,
        -0.9351131319999695,
        -0.2505628168582916
      ],
      "plane_d": -3631.121826171875,
      "bbox_min": [
        -3843.935791015625,
        -3144.7685546875,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3129.853271484375,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6947418451309204,
        -0.6947510838508606,
        0.1861579716205597
      ],
      "plane_d": -5044.7353515625,
      "bbox_min": [
        -3843.935791015625,
        -3141.419189453125,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3129.853271484375,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6947435736656189,
        0.6947460174560547,
        0.18617023527622223
      ],
      "plane_d": 4647.74072265625,
      "bbox_min": [
        -3843.935791015625,
        -3141.419189453125,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3129.853271484375,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6947418451309204,
        0.5085998773574829,
        -0.5085863471031189
      ],
      "plane_d": 4807.767578125,
      "bbox_min": [
        -3843.935791015625,
        -3141.419189453125,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3129.853271484375,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6947397589683533,
        -0.5085904598236084,
        -0.5085983276367188
      ],
      "plane_d": -3723.183349609375,
      "bbox_min": [
        -3843.935791015625,
        -3141.419189453125,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3129.853271484375,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.7071162462234497,
        0.7070974111557007
      ],
      "plane_d": -2972.037109375,
      "bbox_min": [
        -3843.935791015625,
        -3141.419189453125,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3129.853271484375,
        1087.8743896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071162462234497,
        -0.7070974111557007
      ],
      "plane_d": -1464.18896484375,
      "bbox_min": [
        -3843.935791015625,
        -3140.4521484375,
        1044.5731201171875
      ],
      "bbox_max": [
        -3780.0,
        -3129.853271484375,
        1073.1524658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9659211039543152,
        -0.25883668661117554
      ],
      "plane_d": -2749.54638671875,
      "bbox_min": [
        -3843.935791015625,
        -3136.843505859375,
        1059.26513671875
      ],
      "bbox_max": [
        -3780.0,
        -3129.88525390625,
        1073.1524658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9659211039543152,
        0.25883668661117554
      ],
      "plane_d": -3301.502197265625,
      "bbox_min": [
        -3843.935791015625,
        -3133.2353515625,
        1059.26513671875
      ],
      "bbox_max": [
        -3780.0,
        -3129.88525390625,
        1073.1524658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03997047618031502,
        0.9992009401321411,
        0.0
      ],
      "plane_d": 2976.17919921875,
      "bbox_min": [
        -3843.935791015625,
        -3132.2685546875,
        1059.26513671875
      ],
      "bbox_max": [
        -3782.944091796875,
        -3129.88525390625,
        1073.1524658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3800.0,
      "bbox_min": [
        -3800.635009765625,
        -3132.2685546875,
        1059.9483642578125
      ],
      "bbox_max": [
        -3800.0,
        -3130.568359375,
        1072.4991455078125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1059.9737548828125,
      "bbox_min": [
        -3800.635009765625,
        -3130.59375,
        1059.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3130.568359375,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.009344073943793774,
        -0.0,
        0.9999563097953796
      ],
      "plane_d": -1024.4200439453125,
      "bbox_min": [
        -3843.935791015625,
        -3132.2685546875,
        1059.26513671875
      ],
      "bbox_max": [
        -3782.944091796875,
        -3129.88525390625,
        1073.1524658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7588074803352356,
        -0.6513150930404663,
        -0.0
      ],
      "plane_d": -4926.26513671875,
      "bbox_min": [
        -3843.519775390625,
        -3130.7021484375,
        1059.26513671875
      ],
      "bbox_max": [
        -3800.0,
        -3129.88525390625,
        1060.3814697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1059.9737548828125,
      "bbox_min": [
        -3805.60693359375,
        -3130.59375,
        1059.26513671875
      ],
      "bbox_max": [
        -3800.0,
        -3129.88525390625,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3799.999755859375,
      "bbox_min": [
        -3800.0,
        -3130.568359375,
        1059.26513671875
      ],
      "bbox_max": [
        -3800.0,
        -3129.88525390625,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9636161923408508,
        0.1890050619840622,
        0.18900002539157867
      ],
      "plane_d": 4094.830322265625,
      "bbox_min": [
        -3843.519775390625,
        -3130.7021484375,
        1059.26513671875
      ],
      "bbox_max": [
        -3843.30126953125,
        -3129.88525390625,
        1060.3814697265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.963616132736206,
        -0.2581813633441925,
        -0.06918454170227051
      ],
      "plane_d": -4438.39453125,
      "bbox_min": [
        -3843.519775390625,
        -3130.7021484375,
        1059.9737548828125
      ],
      "bbox_max": [
        -3843.30126953125,
        -3129.8876953125,
        1060.3814697265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.007501009851694107,
        0.0,
        -0.9999719262123108
      ],
      "plane_d": 1100.947509765625,
      "bbox_min": [
        -3843.935791015625,
        -3132.2685546875,
        1060.37841796875
      ],
      "bbox_max": [
        -3783.630859375,
        -3129.8876953125,
        1073.1524658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.963616132736206,
        0.1890050768852234,
        -0.18900004029273987
      ],
      "plane_d": 4497.86279296875,
      "bbox_min": [
        -3843.498779296875,
        -3130.6806640625,
        1072.1475830078125
      ],
      "bbox_max": [
        -3800.0,
        -3129.9130859375,
        1073.1524658203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3799.999755859375,
      "bbox_min": [
        -3800.0,
        -3130.568359375,
        1072.4737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3129.91357421875,
        1073.1524658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9636160731315613,
        -0.2581813633441925,
        0.06918453425168991
      ],
      "plane_d": -4585.92626953125,
      "bbox_min": [
        -3843.935791015625,
        -3132.2685546875,
        1060.37841796875
      ],
      "bbox_max": [
        -3843.30126953125,
        -3129.8876953125,
        1072.1490478515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.963616132736206,
        -0.2581813633441925,
        -0.06918454170227051
      ],
      "plane_d": -4438.39453125,
      "bbox_min": [
        -3843.935791015625,
        -3132.2685546875,
        1060.37841796875
      ],
      "bbox_max": [
        -3843.30126953125,
        -3129.8876953125,
        1072.147705078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6947561502456665,
        0.6947376728057861,
        -0.18615436553955078
      ],
      "plane_d": -265.486328125,
      "bbox_min": [
        -3801.93359375,
        -3133.2353515625,
        1066.2237548828125
      ],
      "bbox_max": [
        -3800.0,
        -3130.59375,
        1072.4737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6947609186172485,
        0.6947331428527832,
        0.18615315854549408
      ],
      "plane_d": -662.481689453125,
      "bbox_min": [
        -3804.574951171875,
        -3136.843505859375,
        1059.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3130.59375,
        1069.83203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6947561502456665,
        0.6947376728057861,
        -0.18615436553955078
      ],
      "plane_d": -265.486328125,
      "bbox_min": [
        -3804.574951171875,
        -3136.843505859375,
        1066.2237548828125
      ],
      "bbox_max": [
        -3800.0,
        -3132.2685546875,
        1069.83203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.22604458034038544,
        0.0,
        -0.9741169214248657
      ],
      "plane_d": 1881.399658203125,
      "bbox_min": [
        -3835.61328125,
        -3140.4521484375,
        1044.5731201171875
      ],
      "bbox_max": [
        -3800.0,
        -3129.853271484375,
        1066.2237548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.22604458034038544,
        -0.0,
        0.9741169214248657
      ],
      "plane_d": -153.67303466796875,
      "bbox_min": [
        -3835.61328125,
        -3140.4521484375,
        1044.5731201171875
      ],
      "bbox_max": [
        -3800.0,
        -3129.853271484375,
        1066.2237548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6947534680366516,
        0.5085812211036682,
        0.5085890889167786
      ],
      "plane_d": -1586.992919921875,
      "bbox_min": [
        -3835.61328125,
        -3140.4521484375,
        1047.4737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3129.859619140625,
        1066.2237548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3130.59375,
      "bbox_min": [
        -3800.731689453125,
        -3130.59375,
        1058.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3129.884521484375,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1058.9737548828125,
      "bbox_min": [
        -3800.731689453125,
        -3130.59375,
        1058.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3129.884521484375,
        1058.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6947609186172485,
        0.6947331428527832,
        0.18615315854549408
      ],
      "plane_d": -662.481689453125,
      "bbox_min": [
        -3835.61328125,
        -3140.4521484375,
        1047.4737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3129.859619140625,
        1066.2237548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1058.9737548828125,
      "bbox_min": [
        -3835.61328125,
        -3130.59375,
        1047.4737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3129.859619140625,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3130.59375,
      "bbox_min": [
        -3805.608642578125,
        -3130.59375,
        1058.9737548828125
      ],
      "bbox_max": [
        -3800.0,
        -3129.884521484375,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7588074803352356,
        -0.6513150930404663,
        -0.0
      ],
      "plane_d": -4926.26513671875,
      "bbox_min": [
        -3805.608642578125,
        -3130.59375,
        1058.9737548828125
      ],
      "bbox_max": [
        -3805.0,
        -3129.884521484375,
        1059.9737548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6546636819839478,
        0.0,
        0.7559202909469604
      ],
      "plane_d": -3285.51904296875,
      "bbox_min": [
        -3835.61328125,
        -3130.59375,
        1047.4737548828125
      ],
      "bbox_max": [
        -3807.6875,
        -3129.859619140625,
        1048.7406005859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.654643714427948,
        -0.0,
        -0.7559375762939453
      ],
      "plane_d": -1718.177734375,
      "bbox_min": [
        -3835.61328125,
        -3130.59375,
        1047.4737548828125
      ],
      "bbox_max": [
        -3834.150390625,
        -3129.859619140625,
        1048.7406005859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.694758951663971,
        0.5085774064064026,
        -0.5085852742195129
      ],
      "plane_d": -502.490478515625,
      "bbox_min": [
        -3835.4619140625,
        -3141.419189453125,
        1062.614990234375
      ],
      "bbox_max": [
        -3800.0,
        -3129.9150390625,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6947561502456665,
        0.6947376728057861,
        -0.18615436553955078
      ],
      "plane_d": -265.486328125,
      "bbox_min": [
        -3835.4619140625,
        -3141.419189453125,
        1062.614990234375
      ],
      "bbox_max": [
        -3800.0,
        -3129.93798828125,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.22604458034038544,
        0.0,
        -0.9741169214248657
      ],
      "plane_d": 1923.580078125,
      "bbox_min": [
        -3835.4619140625,
        -3141.419189453125,
        1062.614990234375
      ],
      "bbox_max": [
        -3804.574951171875,
        -3129.93798828125,
        1087.8743896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6947609186172485,
        0.6947331428527832,
        0.18615315854549408
      ],
      "plane_d": -662.481689453125,
      "bbox_min": [
        -3835.4619140625,
        -3141.419189453125,
        1062.614990234375
      ],
      "bbox_max": [
        -3804.574951171875,
        -3129.93798828125,
        1084.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6546636819839478,
        0.0,
        -0.7559202909469604
      ],
      "plane_d": -1673.5587158203125,
      "bbox_min": [
        -3835.4619140625,
        -3130.59375,
        1083.837890625
      ],
      "bbox_max": [
        -3807.8388671875,
        -3129.93798828125,
        1084.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.654643714427948,
        0.0,
        -0.7559375762939453
      ],
      "plane_d": 3330.1748046875,
      "bbox_min": [
        -3835.4619140625,
        -3130.59375,
        1083.837890625
      ],
      "bbox_max": [
        -3834.150390625,
        -3129.93798828125,
        1084.9737548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3184.77001953125,
      "bbox_min": [
        -3925.0,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3129.7685546875,
        1079.800048828125
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3181.77001953125,
      "bbox_min": [
        -3925.0,
        -3184.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.00048828125,
        -3129.7685546875,
        1079.767333984375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1036.786865234375,
      "bbox_min": [
        -3922.50048828125,
        -3181.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.00048828125,
        -3129.7685546875,
        1076.49462890625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1007.623779296875,
      "bbox_min": [
        -3891.5,
        -3164.10009765625,
        1005.2037963867188
      ],
      "bbox_max": [
        -3790.0,
        -3144.0,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 1452.9541015625,
      "bbox_min": [
        -3887.50048828125,
        -3161.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3792.50048828125,
        -3146.7685546875,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 4361.4736328125,
      "bbox_min": [
        -3807.50048828125,
        -3161.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3792.50048828125,
        -3146.7685546875,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": -2310.5078125,
      "bbox_min": [
        -3807.50048828125,
        -3161.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3792.50048828125,
        -3148.96533203125,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        -0.3826998770236969,
        -0.0
      ],
      "plane_d": -4724.7841796875,
      "bbox_min": [
        -3807.50048828125,
        -3161.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3792.50048828125,
        -3148.96533203125,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826998770236969,
        -0.9238727688789368,
        -0.0
      ],
      "plane_d": -4375.33154296875,
      "bbox_min": [
        -3805.3037109375,
        -3161.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3792.50048828125,
        -3148.96533203125,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826998770236969,
        -0.9238727688789368,
        0.0
      ],
      "plane_d": -1466.81201171875,
      "bbox_min": [
        -3800.00048828125,
        -3161.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3792.50048828125,
        -3148.96533203125,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": 4710.92578125,
      "bbox_min": [
        -3794.697265625,
        -3159.57177734375,
        1005.2037963867188
      ],
      "bbox_max": [
        -3792.50048828125,
        -3148.96533203125,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238727688789368,
        -0.3826998770236969,
        0.0
      ],
      "plane_d": 2296.649658203125,
      "bbox_min": [
        -3794.697265625,
        -3159.57177734375,
        1005.2037963867188
      ],
      "bbox_max": [
        -3792.50048828125,
        -3154.2685546875,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        0.3826998770236969,
        0.0
      ],
      "plane_d": -2384.417724609375,
      "bbox_min": [
        -3887.50048828125,
        -3161.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3872.50048828125,
        -3146.7685546875,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826998770236969,
        0.9238727688789368,
        0.0
      ],
      "plane_d": 1422.338134765625,
      "bbox_min": [
        -3887.50048828125,
        -3161.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3872.50048828125,
        -3146.7685546875,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826998770236969,
        0.9238727688789368,
        -0.0
      ],
      "plane_d": 4392.08984375,
      "bbox_min": [
        -3887.50048828125,
        -3161.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3872.50048828125,
        -3146.7685546875,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238727688789368,
        0.3826998770236969,
        -0.0
      ],
      "plane_d": 4784.8359375,
      "bbox_min": [
        -3887.50048828125,
        -3161.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3872.50048828125,
        -3148.96533203125,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238727688789368,
        -0.3826998770236969,
        0.0
      ],
      "plane_d": 2370.5595703125,
      "bbox_min": [
        -3887.50048828125,
        -3161.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3872.50048828125,
        -3154.2685546875,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826998770236969,
        -0.9238727688789368,
        0.0
      ],
      "plane_d": -1436.196044921875,
      "bbox_min": [
        -3887.50048828125,
        -3161.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3874.697265625,
        -3154.2685546875,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826998770236969,
        -0.9238727688789368,
        0.0
      ],
      "plane_d": -4405.947265625,
      "bbox_min": [
        -3887.50048828125,
        -3161.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3880.00048828125,
        -3154.2685546875,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238727688789368,
        -0.3826998770236969,
        0.0
      ],
      "plane_d": -4798.6943359375,
      "bbox_min": [
        -3887.50048828125,
        -3159.57177734375,
        1005.2037963867188
      ],
      "bbox_max": [
        -3885.3037109375,
        -3154.2685546875,
        1007.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3154.2685546875,
      "bbox_min": [
        -3889.86376953125,
        -3164.10009765625,
        1007.623779296875
      ],
      "bbox_max": [
        -3790.13720703125,
        -3144.4052734375,
        1033.275634765625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3880.0,
      "bbox_min": [
        -3889.86376953125,
        -3154.2685546875,
        1007.623779296875
      ],
      "bbox_max": [
        -3790.13720703125,
        -3144.4052734375,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3800.00048828125,
      "bbox_min": [
        -3880.00048828125,
        -3154.2685546875,
        1007.623779296875
      ],
      "bbox_max": [
        -3790.13720703125,
        -3144.4052734375,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4082581400871277,
        0.408239483833313,
        -0.8164960741996765
      ],
      "plane_d": 3669.833251953125,
      "bbox_min": [
        -3800.00048828125,
        -3154.2685546875,
        1007.623779296875
      ],
      "bbox_max": [
        -3790.13720703125,
        -3144.4052734375,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.40826764702796936,
        0.4082273244857788,
        -0.8164974451065063
      ],
      "plane_d": 3674.714111328125,
      "bbox_min": [
        -3800.00048828125,
        -3154.2685546875,
        1023.4426879882812
      ],
      "bbox_max": [
        -3792.10986328125,
        -3146.3779296875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40822869539260864,
        -0.4082396328449249,
        0.816510796546936
      ],
      "plane_d": -3678.547607421875,
      "bbox_min": [
        -3800.00048828125,
        -3154.2685546875,
        1028.25439453125
      ],
      "bbox_max": [
        -3793.68798828125,
        -3147.9560546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6091538071632385,
        0.6092593669891357,
        0.50767582654953
      ],
      "plane_d": 3724.147705078125,
      "bbox_min": [
        -3800.00048828125,
        -3154.2685546875,
        1007.623779296875
      ],
      "bbox_max": [
        -3798.59130859375,
        -3152.859619140625,
        1009.3146362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4082394242286682,
        0.4082581102848053,
        -0.8164960145950317
      ],
      "plane_d": 567.20068359375,
      "bbox_min": [
        -3880.00048828125,
        -3154.2685546875,
        1007.623779296875
      ],
      "bbox_max": [
        -3800.00048828125,
        -3144.4052734375,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40825092792510986,
        0.40825092792510986,
        -0.8164939880371094
      ],
      "plane_d": 572.01416015625,
      "bbox_min": [
        -3807.89111328125,
        -3154.2685546875,
        1023.4426879882812
      ],
      "bbox_max": [
        -3800.00048828125,
        -3146.3779296875,
        1033.275634765625
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.40822869539260864,
        0.4082396328449249,
        -0.816510796546936
      ],
      "plane_d": 576.009033203125,
      "bbox_min": [
        -3806.31298828125,
        -3154.2685546875,
        1028.25439453125
      ],
      "bbox_max": [
        -3800.00048828125,
        -3147.9560546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4082581400871277,
        0.408239483833313,
        -0.8164960741996765
      ],
      "plane_d": 3702.493896484375,
      "bbox_min": [
        -3880.00048828125,
        -3154.2685546875,
        1007.623779296875
      ],
      "bbox_max": [
        -3800.00048828125,
        -3144.4052734375,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.40826764702796936,
        0.4082273244857788,
        -0.8164974451065063
      ],
      "plane_d": 3707.37548828125,
      "bbox_min": [
        -3880.00048828125,
        -3154.2685546875,
        1023.4426879882812
      ],
      "bbox_max": [
        -3872.10986328125,
        -3146.3779296875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40822869539260864,
        -0.4082396328449249,
        0.816510796546936
      ],
      "plane_d": -3711.205810546875,
      "bbox_min": [
        -3880.00048828125,
        -3154.2685546875,
        1028.25439453125
      ],
      "bbox_max": [
        -3873.68798828125,
        -3147.9560546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6091538071632385,
        0.6092593669891357,
        0.50767582654953
      ],
      "plane_d": 3772.880126953125,
      "bbox_min": [
        -3880.00048828125,
        -3154.2685546875,
        1007.623779296875
      ],
      "bbox_max": [
        -3800.00048828125,
        -3152.859619140625,
        1009.3146362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6091537475585938,
        0.6092593669891357,
        0.50767582654953
      ],
      "plane_d": -905.421630859375,
      "bbox_min": [
        -3801.40966796875,
        -3154.2685546875,
        1007.623779296875
      ],
      "bbox_max": [
        -3800.00048828125,
        -3152.859619140625,
        1009.3146362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4082394242286682,
        0.4082581102848053,
        -0.8164960145950317
      ],
      "plane_d": 534.5416259765625,
      "bbox_min": [
        -3889.86376953125,
        -3154.2685546875,
        1007.623779296875
      ],
      "bbox_max": [
        -3880.00048828125,
        -3144.4052734375,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40825092792510986,
        0.40825092792510986,
        -0.8164939880371094
      ],
      "plane_d": 539.3541259765625,
      "bbox_min": [
        -3887.89111328125,
        -3154.2685546875,
        1023.4426879882812
      ],
      "bbox_max": [
        -3880.00048828125,
        -3146.3779296875,
        1033.275634765625
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.40822869539260864,
        0.4082396328449249,
        -0.816510796546936
      ],
      "plane_d": 543.350830078125,
      "bbox_min": [
        -3886.31298828125,
        -3154.2685546875,
        1028.25439453125
      ],
      "bbox_max": [
        -3880.00048828125,
        -3147.9560546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6091537475585938,
        0.6092593669891357,
        0.50767582654953
      ],
      "plane_d": -954.15380859375,
      "bbox_min": [
        -3881.40966796875,
        -3154.2685546875,
        1007.623779296875
      ],
      "bbox_max": [
        -3880.00048828125,
        -3152.859619140625,
        1009.3146362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3880.0,
      "bbox_min": [
        -3889.86376953125,
        -3164.10009765625,
        1007.623779296875
      ],
      "bbox_max": [
        -3790.13720703125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3800.00048828125,
      "bbox_min": [
        -3880.00048828125,
        -3164.10009765625,
        1007.623779296875
      ],
      "bbox_max": [
        -3790.13720703125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4082394242286682,
        -0.4082581102848053,
        -0.8164960145950317
      ],
      "plane_d": 1094.309326171875,
      "bbox_min": [
        -3800.00048828125,
        -3164.10009765625,
        1007.623779296875
      ],
      "bbox_max": [
        -3790.13720703125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4082252085208893,
        -0.4082781672477722,
        -0.8164931535720825
      ],
      "plane_d": 1099.071044921875,
      "bbox_min": [
        -3800.00048828125,
        -3162.158935546875,
        1023.4426879882812
      ],
      "bbox_max": [
        -3792.10986328125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.40822869539260864,
        -0.4082396328449249,
        -0.816510796546936
      ],
      "plane_d": 1103.1527099609375,
      "bbox_min": [
        -3800.00048828125,
        -3160.5810546875,
        1028.25439453125
      ],
      "bbox_max": [
        -3793.68798828125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6091537475585938,
        -0.6092593669891357,
        0.50767582654953
      ],
      "plane_d": -119.387939453125,
      "bbox_min": [
        -3800.00048828125,
        -3155.677490234375,
        1007.623779296875
      ],
      "bbox_max": [
        -3798.59130859375,
        -3154.2685546875,
        1009.3146362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4082394242286682,
        -0.4082581102848053,
        -0.8164960145950317
      ],
      "plane_d": 1126.96826171875,
      "bbox_min": [
        -3880.00048828125,
        -3164.10009765625,
        1007.623779296875
      ],
      "bbox_max": [
        -3800.00048828125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4082252085208893,
        -0.4082781672477722,
        -0.8164931535720825
      ],
      "plane_d": 1131.72900390625,
      "bbox_min": [
        -3880.00048828125,
        -3162.158935546875,
        1023.4426879882812
      ],
      "bbox_max": [
        -3872.10986328125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.40822869539260864,
        -0.4082396328449249,
        -0.816510796546936
      ],
      "plane_d": 1135.8109130859375,
      "bbox_min": [
        -3880.00048828125,
        -3160.5810546875,
        1028.25439453125
      ],
      "bbox_max": [
        -3873.68798828125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40825244784355164,
        -0.4082679748535156,
        -0.8164846897125244
      ],
      "plane_d": -2008.4029541015625,
      "bbox_min": [
        -3880.00048828125,
        -3164.10009765625,
        1007.623779296875
      ],
      "bbox_max": [
        -3800.00048828125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40826407074928284,
        -0.40824514627456665,
        -0.8164902925491333
      ],
      "plane_d": -2003.487548828125,
      "bbox_min": [
        -3807.89111328125,
        -3162.158935546875,
        1023.4426879882812
      ],
      "bbox_max": [
        -3800.00048828125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4082396328449249,
        -0.40822869539260864,
        -0.816510796546936
      ],
      "plane_d": -1999.3929443359375,
      "bbox_min": [
        -3806.31298828125,
        -3160.5810546875,
        1028.25439453125
      ],
      "bbox_max": [
        -3800.00048828125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6091537475585938,
        -0.6092593669891357,
        0.50767582654953
      ],
      "plane_d": -70.655517578125,
      "bbox_min": [
        -3880.00048828125,
        -3155.677490234375,
        1007.623779296875
      ],
      "bbox_max": [
        -3800.00048828125,
        -3154.2685546875,
        1009.3146362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6091538071632385,
        -0.6092593669891357,
        0.5076757669448853
      ],
      "plane_d": -4748.95703125,
      "bbox_min": [
        -3801.40966796875,
        -3155.677490234375,
        1007.623779296875
      ],
      "bbox_max": [
        -3800.00048828125,
        -3154.2685546875,
        1009.3146362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40825244784355164,
        -0.4082679748535156,
        -0.8164846897125244
      ],
      "plane_d": -2041.0631103515625,
      "bbox_min": [
        -3889.86376953125,
        -3164.10009765625,
        1007.623779296875
      ],
      "bbox_max": [
        -3880.00048828125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40826407074928284,
        -0.40824514627456665,
        -0.8164902925491333
      ],
      "plane_d": -2036.148681640625,
      "bbox_min": [
        -3887.89111328125,
        -3162.158935546875,
        1023.4426879882812
      ],
      "bbox_max": [
        -3880.00048828125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4082396328449249,
        -0.40822869539260864,
        -0.816510796546936
      ],
      "plane_d": -2032.0521240234375,
      "bbox_min": [
        -3886.31298828125,
        -3160.5810546875,
        1028.25439453125
      ],
      "bbox_max": [
        -3880.00048828125,
        -3154.2685546875,
        1033.275634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6091538071632385,
        -0.6092593669891357,
        0.5076757669448853
      ],
      "plane_d": -4797.689453125,
      "bbox_min": [
        -3881.40966796875,
        -3155.677490234375,
        1007.623779296875
      ],
      "bbox_max": [
        -3880.00048828125,
        -3154.2685546875,
        1009.3146362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        0.323993444442749
      ],
      "plane_d": 3382.87451171875,
      "bbox_min": [
        -3922.50048828125,
        -3164.10009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.0,
        -3129.7685546875,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4038.96142578125,
      "bbox_min": [
        -3922.50048828125,
        -3164.10009765625,
        1012.5
      ],
      "bbox_max": [
        -3920.0,
        -3129.7841796875,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3164.10009765625,
        1019.7999877929688
      ],
      "bbox_max": [
        -3920.0,
        -3129.800048828125,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3922.50048828125,
        -3181.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3794.139404296875,
        -3164.10009765625,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4038.96142578125,
      "bbox_min": [
        -3922.50048828125,
        -3181.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.000244140625,
        -3164.10009765625,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        0.323993444442749
      ],
      "plane_d": 3382.87451171875,
      "bbox_min": [
        -3922.50048828125,
        -3181.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.00048828125,
        -3164.10009765625,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40825244784355164,
        0.4082679748535156,
        0.8164846897125244
      ],
      "plane_d": -1126.9761962890625,
      "bbox_min": [
        -3885.861572265625,
        -3164.1318359375,
        1022.3794555664062
      ],
      "bbox_max": [
        -3794.139404296875,
        -3164.10009765625,
        1025.3099365234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40825244784355164,
        -0.4082679748535156,
        -0.8164846897125244
      ],
      "plane_d": -2008.4029541015625,
      "bbox_min": [
        -3805.861572265625,
        -3164.1318359375,
        1022.3794555664062
      ],
      "bbox_max": [
        -3794.139404296875,
        -3164.10009765625,
        1025.3099365234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40825244784355164,
        0.4082679748535156,
        0.8164846897125244
      ],
      "plane_d": -1094.3160400390625,
      "bbox_min": [
        -3800.00048828125,
        -3164.1318359375,
        1022.3794555664062
      ],
      "bbox_max": [
        -3794.139404296875,
        -3164.10009765625,
        1025.3099365234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40825244784355164,
        -0.4082679748535156,
        -0.8164846897125244
      ],
      "plane_d": -2041.0631103515625,
      "bbox_min": [
        -3885.861572265625,
        -3164.1318359375,
        1022.3794555664062
      ],
      "bbox_max": [
        -3880.00048828125,
        -3164.10009765625,
        1025.3099365234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1039.786865234375,
      "bbox_min": [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3780.00048828125,
        -3145.371337890625,
        1076.49462890625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3164.7685546875,
      "bbox_min": [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3780.00048828125,
        -3145.371337890625,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3167.7685546875,
      "bbox_min": [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3780.00048828125,
        -3164.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3861.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3164.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3821.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3164.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3818.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3164.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3164.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3164.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3898.50048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3164.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3167.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3920.000244140625,
        -3164.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3861.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3821.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3818.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3898.50048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3167.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3920.000244140625,
        -3167.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3861.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3164.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.371337890625,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3821.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3164.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.37158203125,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3818.50048828125,
        -3164.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3145.37158203125,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3164.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3145.37158203125,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3164.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3145.371337890625,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3898.50048828125,
        -3164.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3145.37158203125,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3164.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3920.000244140625,
        -3145.371337890625,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3181.77001953125,
        1039.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3148.121337890625,
        1076.49462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1056.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3181.77001953125,
        1056.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3163.704833984375,
        1059.786865234375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3181.77001953125,
        1056.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3163.704833984375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3181.77001953125,
        1056.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3163.704833984375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3181.77001953125,
        1056.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3163.704833984375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3181.77001953125,
        1059.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3861.50048828125,
      "bbox_min": [
        -3861.50048828125,
        -3181.7685546875,
        1056.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3163.704833984375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3861.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3821.50048828125,
      "bbox_min": [
        -3821.50048828125,
        -3181.7685546875,
        1056.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3163.704833984375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3821.50048828125,
        -3181.7685546875,
        1056.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3163.704833984375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3821.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3166.454833984375,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1039.786865234375,
      "bbox_min": [
        -3925.0,
        -3184.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.00048828125,
        -3181.7685546875,
        1079.767333984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1036.786865234375,
      "bbox_min": [
        -3925.0,
        -3184.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.00048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3901.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1036.786865234375
      ],
      "bbox_max": [
        -3920.00048828125,
        -3181.77001953125,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3821.50048828125,
      "bbox_min": [
        -3861.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3818.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3861.50048828125,
      "bbox_min": [
        -3861.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3184.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3181.7685546875,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3925.0,
        -3184.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3898.50048828125,
        -3184.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3861.50048828125,
      "bbox_min": [
        -3898.50048828125,
        -3184.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3861.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3898.50048828125,
        -3184.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3898.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3821.50048828125,
      "bbox_min": [
        -3821.50048828125,
        -3184.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3818.50048828125,
        -3184.7685546875,
        1005.2037963867188
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3925.0,
        -3184.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.00048828125,
        -3181.77001953125,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9448028206825256,
        0.32763931155204773
      ],
      "plane_d": -3338.35107421875,
      "bbox_min": [
        -3925.0,
        -3184.77001953125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.00048828125,
        -3181.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4038.96142578125,
      "bbox_min": [
        -3922.50048828125,
        -3182.2685546875,
        1012.5
      ],
      "bbox_max": [
        -3922.00830078125,
        -3181.77001953125,
        1013.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9448028206825256,
        -0.32763931155204773
      ],
      "plane_d": -2674.881591796875,
      "bbox_min": [
        -3925.0,
        -3184.77001953125,
        1012.5
      ],
      "bbox_max": [
        -3920.00048828125,
        -3181.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4038.96142578125,
      "bbox_min": [
        -3922.50048828125,
        -3184.77001953125,
        1012.5
      ],
      "bbox_max": [
        -3920.00048828125,
        -3181.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1056.786865234375,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      "bbox_max": [
        -3780.00048828125,
        -3181.7685546875,
        1079.767333984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1056.786865234375
      ],
      "bbox_max": [
        -3780.00048828125,
        -3181.7685546875,
        1079.767333984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1056.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1056.786865234375
      ],
      "bbox_max": [
        -3901.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1056.786865234375
      ],
      "bbox_max": [
        -3920.00048828125,
        -3181.77001953125,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3821.50048828125,
      "bbox_min": [
        -3861.50048828125,
        -3184.7685546875,
        1056.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3818.50048828125,
        -3184.7685546875,
        1056.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3861.50048828125,
      "bbox_min": [
        -3861.50048828125,
        -3184.7685546875,
        1056.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3184.7685546875,
        1056.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3181.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3861.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1079.767333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3821.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3184.7685546875,
        1059.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1079.7655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3818.50048828125,
        -3184.7685546875,
        1059.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1079.7655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3184.7685546875,
        1059.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3181.7685546875,
        1079.7655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3181.7685546875,
        1079.767333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3898.50048828125,
        -3184.7685546875,
        1059.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3181.7685546875,
        1079.7655029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      "bbox_max": [
        -3920.00048828125,
        -3181.77001953125,
        1079.767333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3861.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1056.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3821.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3184.7685546875,
        1039.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1056.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3818.50048828125,
      "bbox_min": [
        -3818.50048828125,
        -3184.7685546875,
        1039.786865234375
      ],
      "bbox_max": [
        -3818.50048828125,
        -3181.7685546875,
        1056.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3858.50048828125,
      "bbox_min": [
        -3858.50048828125,
        -3184.7685546875,
        1039.786865234375
      ],
      "bbox_max": [
        -3858.50048828125,
        -3181.7685546875,
        1056.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3181.7685546875,
        1056.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3898.50048828125,
      "bbox_min": [
        -3898.50048828125,
        -3184.7685546875,
        1039.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3181.7685546875,
        1056.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3920.00048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      "bbox_max": [
        -3920.00048828125,
        -3181.77001953125,
        1056.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3898.5,
      "bbox_min": [
        -3925.0,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3184.77001953125,
        1079.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3797.0,
      "bbox_min": [
        -3898.5,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3184.800048828125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1079.800048828125,
      "bbox_min": [
        -3797.00048828125,
        -3224.7685546875,
        1038.123779296875
      ],
      "bbox_max": [
        -3780.0,
        -3184.800048828125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1041.286865234375,
      "bbox_min": [
        -3797.00048828125,
        -3224.7685546875,
        1038.123779296875
      ],
      "bbox_max": [
        -3780.0,
        -3200.7685546875,
        1059.800048828125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3201.7685546875,
      "bbox_min": [
        -3797.00048828125,
        -3216.7685546875,
        1038.123779296875
      ],
      "bbox_max": [
        -3780.0,
        -3200.7685546875,
        1041.286865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3200.7685546875,
      "bbox_min": [
        -3797.00048828125,
        -3201.7685546875,
        1038.123779296875
      ],
      "bbox_max": [
        -3780.0,
        -3200.7685546875,
        1041.286865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1038.123779296875,
      "bbox_min": [
        -3797.00048828125,
        -3201.7685546875,
        1038.123779296875
      ],
      "bbox_max": [
        -3780.0,
        -3200.7685546875,
        1038.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1038.123779296875,
      "bbox_min": [
        -3797.00048828125,
        -3216.7685546875,
        1038.123779296875
      ],
      "bbox_max": [
        -3796.00048828125,
        -3209.7685546875,
        1041.286865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3209.7685546875,
      "bbox_min": [
        -3797.00048828125,
        -3216.7685546875,
        1038.123779296875
      ],
      "bbox_max": [
        -3796.00048828125,
        -3209.7685546875,
        1041.286865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3216.7685546875,
      "bbox_min": [
        -3797.00048828125,
        -3216.7685546875,
        1038.123779296875
      ],
      "bbox_max": [
        -3796.00048828125,
        -3216.7685546875,
        1041.286865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.00018833574722521007,
        0.0,
        1.0
      ],
      "plane_d": -1060.511962890625,
      "bbox_min": [
        -3797.0,
        -3224.7685546875,
        1056.5999755859375
      ],
      "bbox_max": [
        -3780.0,
        -3215.7685546875,
        1059.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3215.7685546875,
      "bbox_min": [
        -3797.0,
        -3216.7685546875,
        1056.5999755859375
      ],
      "bbox_max": [
        -3780.0,
        -3215.7685546875,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3216.7685546875,
      "bbox_min": [
        -3797.0,
        -3216.7685546875,
        1056.5999755859375
      ],
      "bbox_max": [
        -3780.0,
        -3215.7685546875,
        1059.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0003400506393518299,
        -0.0,
        -1.0
      ],
      "plane_d": 1055.3145751953125,
      "bbox_min": [
        -3797.0,
        -3216.7685546875,
        1056.5999755859375
      ],
      "bbox_max": [
        -3780.0,
        -3215.7685546875,
        1056.605712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3850.0,
      "bbox_min": [
        -3898.5,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3797.0,
        -3184.800048828125,
        1079.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1079.800048828125,
      "bbox_min": [
        -3850.00048828125,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3797.0,
        -3184.800048828125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3210.7685546875,
      "bbox_min": [
        -3850.00048828125,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3797.0,
        -3200.7685546875,
        1059.796875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3744042217731476,
        -0.0,
        0.9272656440734863
      ],
      "plane_d": 489.81585693359375,
      "bbox_min": [
        -3850.00048828125,
        -3210.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3797.00048828125,
        -3200.7685546875,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3200.768310546875,
      "bbox_min": [
        -3850.00048828125,
        -3210.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3797.77587890625,
        -3200.7685546875,
        1026.286865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3209.768310546875,
      "bbox_min": [
        -3850.00048828125,
        -3210.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3797.77587890625,
        -3200.7685546875,
        1026.286865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37470540404319763,
        0.0,
        -0.9271439909934998
      ],
      "plane_d": -494.03289794921875,
      "bbox_min": [
        -3850.00048828125,
        -3210.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3805.6513671875,
        -3209.7685546875,
        1023.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3815.0,
      "bbox_min": [
        -3815.0,
        -3210.7685546875,
        1008.9783325195312
      ],
      "bbox_max": [
        -3815.0,
        -3209.7685546875,
        1012.1500244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3815.0,
      "bbox_min": [
        -3815.0,
        -3210.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3815.0,
        -3209.7685546875,
        1008.9783325195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3201.7685546875,
      "bbox_min": [
        -3850.00048828125,
        -3209.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3797.77587890625,
        -3200.7685546875,
        1026.286865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37470540404319763,
        0.0,
        -0.9271439909934998
      ],
      "plane_d": -494.03289794921875,
      "bbox_min": [
        -3850.00048828125,
        -3201.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3805.6513671875,
        -3200.7685546875,
        1023.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3815.0,
      "bbox_min": [
        -3815.0,
        -3201.7685546875,
        1008.9783325195312
      ],
      "bbox_max": [
        -3815.0,
        -3200.7685546875,
        1012.1500244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3815.0,
      "bbox_min": [
        -3815.0,
        -3201.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3815.0,
        -3200.7685546875,
        1008.9783325195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3815.0,
      "bbox_min": [
        -3815.0,
        -3209.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3815.0,
        -3201.7685546875,
        1012.1500244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32955682277679443,
        0.0,
        0.9441357254981995
      ],
      "plane_d": 268.2113037109375,
      "bbox_min": [
        -3850.00048828125,
        -3210.7685546875,
        1038.123779296875
      ],
      "bbox_max": [
        -3797.00048828125,
        -3200.7685546875,
        1059.786865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3201.7685546875,
      "bbox_min": [
        -3850.00048828125,
        -3210.7685546875,
        1038.123779296875
      ],
      "bbox_max": [
        -3797.00048828125,
        -3200.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3200.7685546875,
      "bbox_min": [
        -3850.00048828125,
        -3201.7685546875,
        1038.123779296875
      ],
      "bbox_max": [
        -3797.00048828125,
        -3200.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32955682277679443,
        0.0,
        -0.9441357254981995
      ],
      "plane_d": -271.19769287109375,
      "bbox_min": [
        -3850.00048828125,
        -3201.7685546875,
        1038.123779296875
      ],
      "bbox_max": [
        -3797.00048828125,
        -3200.7685546875,
        1056.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3209.7685546875,
      "bbox_min": [
        -3850.00048828125,
        -3210.7685546875,
        1038.123779296875
      ],
      "bbox_max": [
        -3797.00048828125,
        -3209.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32955682277679443,
        0.0,
        -0.9441357254981995
      ],
      "plane_d": -271.19769287109375,
      "bbox_min": [
        -3850.00048828125,
        -3210.7685546875,
        1038.123779296875
      ],
      "bbox_max": [
        -3797.00048828125,
        -3209.7685546875,
        1056.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27232247591018677,
        0.0,
        0.9622060656547546
      ],
      "plane_d": -2035.941162109375,
      "bbox_min": [
        -3850.00048828125,
        -3224.7685546875,
        1023.123779296875
      ],
      "bbox_max": [
        -3797.0,
        -3215.7685546875,
        1059.796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3215.768310546875,
      "bbox_min": [
        -3850.00048828125,
        -3216.7685546875,
        1023.123779296875
      ],
      "bbox_max": [
        -3797.00048828125,
        -3215.7685546875,
        1041.286865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3216.768310546875,
      "bbox_min": [
        -3850.00048828125,
        -3216.7685546875,
        1023.123779296875
      ],
      "bbox_max": [
        -3797.00048828125,
        -3215.7685546875,
        1041.286865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27232247591018677,
        0.0,
        -0.9622060656547546
      ],
      "plane_d": 2032.8974609375,
      "bbox_min": [
        -3850.00048828125,
        -3216.7685546875,
        1023.123779296875
      ],
      "bbox_max": [
        -3797.00048828125,
        -3215.7685546875,
        1038.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.00018833574722521007,
        0.0,
        1.0
      ],
      "plane_d": -1060.511962890625,
      "bbox_min": [
        -3850.00048828125,
        -3224.7685546875,
        1056.605712890625
      ],
      "bbox_max": [
        -3797.0,
        -3215.7685546875,
        1059.796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3215.7685546875,
      "bbox_min": [
        -3850.00048828125,
        -3216.7685546875,
        1056.605712890625
      ],
      "bbox_max": [
        -3797.0,
        -3215.7685546875,
        1059.796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3216.7685546875,
      "bbox_min": [
        -3850.00048828125,
        -3216.7685546875,
        1056.605712890625
      ],
      "bbox_max": [
        -3797.0,
        -3215.7685546875,
        1059.796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0003400506393518299,
        -0.0,
        -1.0
      ],
      "plane_d": 1055.3145751953125,
      "bbox_min": [
        -3850.00048828125,
        -3216.7685546875,
        1056.605712890625
      ],
      "bbox_max": [
        -3797.0,
        -3215.7685546875,
        1056.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1079.800048828125,
      "bbox_min": [
        -3898.5,
        -3224.7685546875,
        1023.123779296875
      ],
      "bbox_max": [
        -3850.0,
        -3184.800048828125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1026.286865234375,
      "bbox_min": [
        -3867.00048828125,
        -3224.7685546875,
        1023.123779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3200.7685546875,
        1059.786865234375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3867.00048828125,
      "bbox_min": [
        -3867.00048828125,
        -3224.7685546875,
        1023.123779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3200.7685546875,
        1026.286865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1023.123779296875,
      "bbox_min": [
        -3867.00048828125,
        -3224.7685546875,
        1023.123779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3200.7685546875,
        1026.286865234375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3866.00048828125,
      "bbox_min": [
        -3867.00048828125,
        -3224.7685546875,
        1023.123779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3200.7685546875,
        1026.286865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3200.7685546875,
      "bbox_min": [
        -3867.00048828125,
        -3200.7685546875,
        1023.123779296875
      ],
      "bbox_max": [
        -3866.00048828125,
        -3200.7685546875,
        1026.286865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3201.7685546875,
      "bbox_min": [
        -3866.00048828125,
        -3216.7685546875,
        1023.123779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3200.7685546875,
        1026.286865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3200.7685546875,
      "bbox_min": [
        -3866.00048828125,
        -3200.7685546875,
        1023.123779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3200.7685546875,
        1026.286865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3851.00048828125,
      "bbox_min": [
        -3851.00048828125,
        -3216.7685546875,
        1023.123779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3209.7685546875,
        1026.286865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3209.7685546875,
      "bbox_min": [
        -3851.00048828125,
        -3216.7685546875,
        1023.123779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3209.7685546875,
        1026.286865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3216.7685546875,
      "bbox_min": [
        -3851.00048828125,
        -3216.7685546875,
        1023.123779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3216.7685546875,
        1026.286865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3867.00048828125,
        -3224.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3200.7685546875,
        1059.786865234375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3867.00048828125,
      "bbox_min": [
        -3867.00048828125,
        -3224.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3200.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1056.623779296875,
      "bbox_min": [
        -3867.00048828125,
        -3224.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3200.7685546875,
        1059.786865234375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3866.00048828125,
      "bbox_min": [
        -3867.00048828125,
        -3224.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3200.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3200.7685546875,
      "bbox_min": [
        -3867.00048828125,
        -3200.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -3866.00048828125,
        -3200.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3201.7685546875,
      "bbox_min": [
        -3866.00048828125,
        -3216.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3200.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3200.7685546875,
      "bbox_min": [
        -3866.00048828125,
        -3200.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3200.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3851.00048828125,
      "bbox_min": [
        -3851.00048828125,
        -3216.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3209.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3209.7685546875,
      "bbox_min": [
        -3851.00048828125,
        -3216.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3209.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3216.7685546875,
      "bbox_min": [
        -3851.00048828125,
        -3216.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -3850.00048828125,
        -3216.7685546875,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3920.0,
      "bbox_min": [
        -3925.0,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3898.5,
        -3184.77001953125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1019.7999877929688,
      "bbox_min": [
        -3925.0,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.00048828125,
        -3184.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9448028206825256,
        0.32763931155204773
      ],
      "plane_d": -3338.35107421875,
      "bbox_min": [
        -3925.0,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.00048828125,
        -3184.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        0.323993444442749
      ],
      "plane_d": 3382.87451171875,
      "bbox_min": [
        -3920.030029296875,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3920.00048828125,
        -3184.77001953125,
        1005.28662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9448028206825256,
        -0.32763931155204773
      ],
      "plane_d": -2674.881591796875,
      "bbox_min": [
        -3925.0,
        -3184.800048828125,
        1019.71337890625
      ],
      "bbox_max": [
        -3920.00048828125,
        -3184.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4038.96142578125,
      "bbox_min": [
        -3920.030029296875,
        -3184.800048828125,
        1019.71337890625
      ],
      "bbox_max": [
        -3920.00048828125,
        -3184.77001953125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1079.800048828125,
      "bbox_min": [
        -3920.00048828125,
        -3224.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.5,
        -3184.77001953125,
        1079.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1056.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3224.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3224.7685546875,
        1056.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3224.7685546875,
        1059.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3184.77001953125,
        1059.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1039.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3224.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.50048828125,
      "bbox_min": [
        -3901.50048828125,
        -3224.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3184.77001953125,
        1039.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1036.786865234375,
      "bbox_min": [
        -3901.50048828125,
        -3224.7685546875,
        1036.786865234375
      ],
      "bbox_max": [
        -3898.50048828125,
        -3184.77001953125,
        1036.786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1029.800048828125,
      "bbox_min": [
        -4000.0,
        -3125.0,
        1015.2000122070312
      ],
      "bbox_max": [
        -3927.50048828125,
        -3072.300048828125,
        1029.800048828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1015.2000122070312,
      "bbox_min": [
        -4000.0,
        -3125.0,
        1015.2000122070312
      ],
      "bbox_max": [
        -3927.50048828125,
        -3072.300048828125,
        1029.800048828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9460592865943909,
        0.0,
        0.323993444442749
      ],
      "plane_d": -4046.931640625,
      "bbox_min": [
        -4000.0,
        -3125.0,
        1015.2000122070312
      ],
      "bbox_max": [
        -3927.50048828125,
        -3072.300048828125,
        1029.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9460796117782593,
        0.0,
        -0.323934406042099
      ],
      "plane_d": -3384.505126953125,
      "bbox_min": [
        -4000.0,
        -3125.0,
        1015.2000122070312
      ],
      "bbox_max": [
        -3927.50048828125,
        -3072.300048828125,
        1029.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3115.0,
      "bbox_min": [
        -4000.0,
        -3125.0,
        1015.2000122070312
      ],
      "bbox_max": [
        -3950.0,
        -3072.300048828125,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460407495498657,
        0.0,
        -0.32404768466949463
      ],
      "plane_d": 4070.565185546875,
      "bbox_min": [
        -3952.50048828125,
        -3125.0,
        1015.2000122070312
      ],
      "bbox_max": [
        -3950.0,
        -3115.0,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460594058036804,
        0.0,
        0.3239934742450714
      ],
      "plane_d": 3408.01708984375,
      "bbox_min": [
        -3952.50048828125,
        -3125.0,
        1015.2000122070312
      ],
      "bbox_max": [
        -3950.00048828125,
        -3115.0,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3960.0,
      "bbox_min": [
        -3960.0,
        -3115.0,
        1015.2000122070312
      ],
      "bbox_max": [
        -3950.0,
        -3072.300048828125,
        1029.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3100.0,
      "bbox_min": [
        -3960.0,
        -3115.0,
        1015.2000122070312
      ],
      "bbox_max": [
        -3950.0,
        -3072.300048828125,
        1029.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9460407495498657,
        0.0,
        -0.32404768466949463
      ],
      "plane_d": 4070.565185546875,
      "bbox_min": [
        -3952.50048828125,
        -3115.0,
        1015.2000122070312
      ],
      "bbox_max": [
        -3950.0,
        -3100.0,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460594058036804,
        0.0,
        0.3239934742450714
      ],
      "plane_d": 3408.01708984375,
      "bbox_min": [
        -3952.50048828125,
        -3115.0,
        1015.2000122070312
      ],
      "bbox_max": [
        -3950.00048828125,
        -3100.0,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3080.0,
      "bbox_min": [
        -3960.0,
        -3080.0,
        1015.2000122070312
      ],
      "bbox_max": [
        -3950.0,
        -3072.300048828125,
        1029.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9460407495498657,
        0.0,
        -0.32404768466949463
      ],
      "plane_d": 4070.5654296875,
      "bbox_min": [
        -3952.50048828125,
        -3080.0,
        1015.2000122070312
      ],
      "bbox_max": [
        -3950.0,
        -3072.300048828125,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460592865943909,
        0.0,
        0.323993444442749
      ],
      "plane_d": 3408.0166015625,
      "bbox_min": [
        -3952.50048828125,
        -3080.0,
        1015.2000122070312
      ],
      "bbox_max": [
        -3950.00048828125,
        -3072.300048828125,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.16493473947048187,
        -0.9863044619560242
      ],
      "plane_d": 1531.117431640625,
      "bbox_min": [
        -3972.50048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3925.0,
        -3125.0,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.16493375599384308,
        0.9863047003746033
      ],
      "plane_d": -1516.714599609375,
      "bbox_min": [
        -3972.50048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3925.0,
        -3125.0,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8871033191680908,
        -0.3474929630756378,
        0.303803026676178
      ],
      "plane_d": 2109.72216796875,
      "bbox_min": [
        -3972.50048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3925.0,
        -3125.0,
        1029.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8871209621429443,
        0.3474970757961273,
        -0.30374717712402344
      ],
      "plane_d": -2087.658203125,
      "bbox_min": [
        -3972.50048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3925.0,
        -3125.0,
        1029.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9448028206825256,
        0.32763931155204773
      ],
      "plane_d": -3338.35107421875,
      "bbox_min": [
        -3950.00048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3925.0,
        -3182.2685546875,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.9448028206825256,
        -0.32763931155204773
      ],
      "plane_d": -2674.881591796875,
      "bbox_min": [
        -3950.00048828125,
        -3184.800048828125,
        1012.5
      ],
      "bbox_max": [
        -3925.0,
        -3182.2685546875,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9151027798652649,
        -0.2536449432373047,
        -0.31345048546791077
      ],
      "plane_d": 3144.806884765625,
      "bbox_min": [
        -3972.50048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3927.50048828125,
        -3125.0,
        1029.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9158093929290771,
        0.3532073199748993,
        -0.19114844501018524
      ],
      "plane_d": -2297.61962890625,
      "bbox_min": [
        -3950.00048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3927.50048828125,
        -3125.0,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9448028206825256,
        -0.32763931155204773
      ],
      "plane_d": -2674.88134765625,
      "bbox_min": [
        -3950.00048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3945.001708984375,
        -3182.2685546875,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9448028206825256,
        0.32763931155204773
      ],
      "plane_d": -3338.35107421875,
      "bbox_min": [
        -3947.50048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3945.001708984375,
        -3182.2685546875,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9347898364067078,
        0.27505484223365784,
        0.2247503399848938
      ],
      "plane_d": -3042.3447265625,
      "bbox_min": [
        -3950.00048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3927.50048828125,
        -3125.0,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9124703407287598,
        0.2640978693962097,
        0.3124903738498688
      ],
      "plane_d": -3077.943115234375,
      "bbox_min": [
        -3950.00048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3927.50048828125,
        -3125.0,
        1022.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9448028206825256,
        0.32763931155204773
      ],
      "plane_d": -3338.35107421875,
      "bbox_min": [
        -3950.00048828125,
        -3184.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3946.953125,
        -3182.2685546875,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1019.7999877929688,
      "bbox_min": [
        -3972.50048828125,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3925.0,
        -3184.800048828125,
        1019.7999877929688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1005.2000122070312,
      "bbox_min": [
        -3972.50048828125,
        -3224.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3925.0,
        -3184.800048828125,
        1019.7999877929688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.9460592865943909,
        0.323993444442749
      ],
      "plane_d": 2706.22265625,
      "bbox_min": [
        -3972.50048828125,
        -3224.76806640625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3940.00048828125,
        -3184.800048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9460592865943909,
        -0.323993444442749
      ],
      "plane_d": 3362.3095703125,
      "bbox_min": [
        -3972.50048828125,
        -3209.768310546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3940.00048828125,
        -3184.800048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3940.000244140625,
      "bbox_min": [
        -3940.00048828125,
        -3209.768310546875,
        1012.5
      ],
      "bbox_max": [
        -3940.00048828125,
        -3204.7685546875,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460593461990356,
        0.0,
        -0.323993444442749
      ],
      "plane_d": 4086.264404296875,
      "bbox_min": [
        -3972.50048828125,
        -3207.2685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3970.00048828125,
        -3184.800048828125,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9460594058036804,
        0.0,
        0.3239934742450714
      ],
      "plane_d": 3430.177978515625,
      "bbox_min": [
        -3972.50048828125,
        -3207.2685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3970.00048828125,
        -3184.800048828125,
        1012.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1005.2000122070312,
      "bbox_min": [
        -3980.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3224.76806640625,
        1072.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3940.000244140625,
      "bbox_min": [
        -3980.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3224.76806640625,
        1072.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.9575546383857727,
        -0.28825193643569946
      ],
      "plane_d": -2832.092529296875,
      "bbox_min": [
        -3980.00048828125,
        -3264.60009765625,
        1005.264892578125
      ],
      "bbox_max": [
        -3940.00048828125,
        -3262.422119140625,
        1019.735107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9575546383857727,
        0.28825193643569946
      ],
      "plane_d": -3415.802734375,
      "bbox_min": [
        -3980.00048828125,
        -3264.60009765625,
        1005.264892578125
      ],
      "bbox_max": [
        -3940.00048828125,
        -3262.422119140625,
        1019.735107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3980.000244140625,
      "bbox_min": [
        -3980.00048828125,
        -3264.60009765625,
        1005.264892578125
      ],
      "bbox_max": [
        -3980.00048828125,
        -3262.422119140625,
        1019.735107421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1016.623779296875,
      "bbox_min": [
        -3940.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3780.0,
        -3224.7685546875,
        1072.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1019.7999877929688,
      "bbox_min": [
        -3940.00048828125,
        -3264.60009765625,
        1016.623779296875
      ],
      "bbox_max": [
        -3780.0,
        -3224.7685546875,
        1072.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3226.7685546875,
      "bbox_min": [
        -3792.0,
        -3237.7685546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3780.0,
        -3226.7685546875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3237.7685546875,
      "bbox_min": [
        -3792.0,
        -3237.7685546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3780.0,
        -3226.7685546875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3792.0,
      "bbox_min": [
        -3792.0,
        -3237.7685546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3780.0,
        -3226.7685546875,
        1072.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1072.5999755859375,
      "bbox_min": [
        -3792.0,
        -3237.7685546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3780.0,
        -3226.7685546875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.800048828125,
      "bbox_min": [
        -3792.0,
        -3237.7685546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3780.0,
        -3226.7685546875,
        1064.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3233.36865234375,
      "bbox_min": [
        -3792.0,
        -3233.36865234375,
        1059.800048828125
      ],
      "bbox_max": [
        -3790.199951171875,
        -3230.46875,
        1064.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3230.46875,
      "bbox_min": [
        -3792.0,
        -3233.36865234375,
        1059.800048828125
      ],
      "bbox_max": [
        -3790.199951171875,
        -3230.46875,
        1064.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7739765048027039,
        0.0,
        0.6332144141197205
      ],
      "plane_d": 2260.92529296875,
      "bbox_min": [
        -3792.0,
        -3233.36865234375,
        1059.800048828125
      ],
      "bbox_max": [
        -3790.199951171875,
        -3230.46875,
        1064.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3790.199951171875,
      "bbox_min": [
        -3790.199951171875,
        -3233.36865234375,
        1059.800048828125
      ],
      "bbox_max": [
        -3790.199951171875,
        -3230.46875,
        1062.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3790.199951171875,
      "bbox_min": [
        -3790.199951171875,
        -3233.36865234375,
        1062.199951171875
      ],
      "bbox_max": [
        -3790.199951171875,
        -3230.46875,
        1064.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9460594058036804,
        0.0,
        -0.3239934742450714
      ],
      "plane_d": -3378.144775390625,
      "bbox_min": [
        -3920.00048828125,
        -3264.60009765625,
        1016.623779296875
      ],
      "bbox_max": [
        -3898.89990234375,
        -3224.7685546875,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.9577639102935791,
        -0.2875555753707886
      ],
      "plane_d": -2833.485595703125,
      "bbox_min": [
        -3919.978271484375,
        -3264.60009765625,
        1016.623779296875
      ],
      "bbox_max": [
        -3898.89990234375,
        -3263.666015625,
        1019.7349243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3880.00048828125,
      "bbox_min": [
        -3920.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3224.7685546875,
        1016.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3225.60009765625,
      "bbox_min": [
        -3920.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3224.7685546875,
        1016.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3893.00048828125,
      "bbox_min": [
        -3920.00048828125,
        -3225.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3887.00048828125,
        -3224.7685546875,
        1016.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9460594058036804,
        0.0,
        0.3239934742450714
      ],
      "plane_d": -4034.231689453125,
      "bbox_min": [
        -3920.00048828125,
        -3225.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3917.50048828125,
        -3224.7685546875,
        1016.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9460594058036804,
        0.0,
        -0.3239934742450714
      ],
      "plane_d": -3378.144775390625,
      "bbox_min": [
        -3918.912841796875,
        -3225.60009765625,
        1012.5
      ],
      "bbox_max": [
        -3917.50048828125,
        -3224.7685546875,
        1016.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3887.00048828125,
      "bbox_min": [
        -3893.00048828125,
        -3225.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3887.00048828125,
        -3224.7685546875,
        1015.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1015.2237548828125,
      "bbox_min": [
        -3893.00048828125,
        -3225.60009765625,
        1015.2237548828125
      ],
      "bbox_max": [
        -3887.00048828125,
        -3224.7685546875,
        1015.2237548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3244.7685546875,
      "bbox_min": [
        -3920.00048828125,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3896.89990234375,
        -3225.60009765625,
        1016.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3905.00048828125,
      "bbox_min": [
        -3920.00048828125,
        -3244.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3905.00048828125,
        -3225.60009765625,
        1016.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9460594058036804,
        0.0,
        0.3239934742450714
      ],
      "plane_d": -4034.231689453125,
      "bbox_min": [
        -3920.00048828125,
        -3244.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3917.50048828125,
        -3225.60009765625,
        1016.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9460594058036804,
        0.0,
        -0.3239934742450714
      ],
      "plane_d": -3378.144775390625,
      "bbox_min": [
        -3918.912841796875,
        -3244.7685546875,
        1012.5
      ],
      "bbox_max": [
        -3917.50048828125,
        -3225.60009765625,
        1016.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3917.0,
      "bbox_min": [
        -3917.0,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3896.89990234375,
        -3244.800048828125,
        1016.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3261.699951171875,
      "bbox_min": [
        -3917.0,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3896.89990234375,
        -3244.800048828125,
        1016.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3896.89990234375,
      "bbox_min": [
        -3917.0,
        -3264.60009765625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3896.89990234375,
        -3261.699951171875,
        1016.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3263.699951171875,
      "bbox_min": [
        -3917.0,
        -3263.699951171875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3898.89990234375,
        -3261.699951171875,
        1016.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1009.2000122070312,
      "bbox_min": [
        -3912.599853515625,
        -3263.699951171875,
        1009.2000122070312
      ],
      "bbox_max": [
        -3901.199951171875,
        -3261.699951171875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1015.0,
      "bbox_min": [
        -3912.599853515625,
        -3263.699951171875,
        1009.2000122070312
      ],
      "bbox_max": [
        -3901.199951171875,
        -3261.699951171875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3912.599853515625,
      "bbox_min": [
        -3912.599853515625,
        -3263.699951171875,
        1009.2000122070312
      ],
      "bbox_max": [
        -3901.199951171875,
        -3261.699951171875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3901.199951171875,
      "bbox_min": [
        -3901.199951171875,
        -3263.699951171875,
        1009.2000122070312
      ],
      "bbox_max": [
        -3901.199951171875,
        -3261.699951171875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3915.0,
      "bbox_min": [
        -3917.0,
        -3261.699951171875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3915.0,
        -3244.800048828125,
        1016.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1009.2000122070312,
      "bbox_min": [
        -3917.0,
        -3258.800048828125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3915.0,
        -3247.400146484375,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1015.0,
      "bbox_min": [
        -3917.0,
        -3258.800048828125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3915.0,
        -3247.400146484375,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3258.800048828125,
      "bbox_min": [
        -3917.0,
        -3258.800048828125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3915.0,
        -3247.400146484375,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3247.400146484375,
      "bbox_min": [
        -3917.0,
        -3247.400146484375,
        1009.2000122070312
      ],
      "bbox_max": [
        -3915.0,
        -3247.400146484375,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -995.001220703125,
      "bbox_min": [
        -4358.3671875,
        -3500.581787109375,
        984.9754028320312
      ],
      "bbox_max": [
        -3769.39990234375,
        -3264.60009765625,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4925941526889801,
        -0.45145776867866516,
        0.7440006732940674
      ],
      "plane_d": -172.863037109375,
      "bbox_min": [
        -4351.88623046875,
        -3500.581787109375,
        984.9754028320312
      ],
      "bbox_max": [
        -4022.39990234375,
        -3304.199951171875,
        995.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4877246618270874,
        -0.44781744480133057,
        0.7493892312049866
      ],
      "plane_d": -186.581787109375,
      "bbox_min": [
        -4341.1318359375,
        -3500.581787109375,
        984.9754028320312
      ],
      "bbox_max": [
        -4022.39990234375,
        -3304.199951171875,
        995.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -984.975341796875,
      "bbox_min": [
        -4341.1318359375,
        -3500.581787109375,
        984.9754028320312
      ],
      "bbox_max": [
        -4022.39990234375,
        -3304.199951171875,
        995.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.055681146681308746,
        0.0,
        0.9984485507011414
      ],
      "plane_d": -1217.4293212890625,
      "bbox_min": [
        -4202.17822265625,
        -3369.927734375,
        984.9754028320312
      ],
      "bbox_max": [
        -4022.39990234375,
        -3304.199951171875,
        995.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1204254999756813,
        0.6604939699172974,
        0.7411109805107117
      ],
      "plane_d": 983.1212158203125,
      "bbox_min": [
        -4202.17822265625,
        -3369.927734375,
        984.9754028320312
      ],
      "bbox_max": [
        -4022.39990234375,
        -3338.300048828125,
        995.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.36007264256477356,
        -0.9329242706298828
      ],
      "plane_d": 2160.143798828125,
      "bbox_min": [
        -4358.3671875,
        -3498.475830078125,
        995.0011596679688
      ],
      "bbox_max": [
        -3769.39990234375,
        -3264.60009765625,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6795781850814819,
        -0.622826874256134,
        -0.3876340687274933
      ],
      "plane_d": 1180.9044189453125,
      "bbox_min": [
        -4358.3671875,
        -3498.475830078125,
        995.0011596679688
      ],
      "bbox_max": [
        -4022.39990234375,
        -3321.199951171875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6782577633857727,
        -0.6209645867347717,
        -0.39289847016334534
      ],
      "plane_d": 1186.9688720703125,
      "bbox_min": [
        -4358.3671875,
        -3488.681640625,
        1010.9088134765625
      ],
      "bbox_max": [
        -4213.92333984375,
        -3340.685791015625,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.678257405757904,
        -0.6209643483161926,
        0.3928998112678528
      ],
      "plane_d": 392.5263671875,
      "bbox_min": [
        -4358.3671875,
        -3488.681640625,
        1010.9088134765625
      ],
      "bbox_max": [
        -4213.92333984375,
        -3340.685791015625,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17613600194454193,
        -0.90701824426651,
        -0.38248395919799805
      ],
      "plane_d": -1895.344482421875,
      "bbox_min": [
        -4214.13916015625,
        -3341.033203125,
        1026.07861328125
      ],
      "bbox_max": [
        -4213.92333984375,
        -3340.685791015625,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28048279881477356,
        -0.257059782743454,
        -0.924796998500824
      ],
      "plane_d": 1272.85205078125,
      "bbox_min": [
        -4358.3671875,
        -3498.475830078125,
        995.0011596679688
      ],
      "bbox_max": [
        -4022.39990234375,
        -3321.199951171875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27621617913246155,
        -0.25383302569389343,
        -0.9269700050354004
      ],
      "plane_d": 1267.88525390625,
      "bbox_min": [
        -4358.3671875,
        -3498.475830078125,
        995.0011596679688
      ],
      "bbox_max": [
        -4022.39990234375,
        -3321.199951171875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07099748402833939,
        0.3778272569179535,
        -0.9231500029563904
      ],
      "plane_d": 1923.427490234375,
      "bbox_min": [
        -4358.3671875,
        -3491.567138671875,
        995.0011596679688
      ],
      "bbox_max": [
        -4022.39990234375,
        -3321.199951171875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06549719721078873,
        0.3592994809150696,
        -0.9309210777282715
      ],
      "plane_d": 1892.04931640625,
      "bbox_min": [
        -4358.3671875,
        -3491.567138671875,
        995.0011596679688
      ],
      "bbox_max": [
        -4022.39990234375,
        -3321.199951171875,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.678257405757904,
        -0.6209643483161926,
        0.3928998112678528
      ],
      "plane_d": 392.5263671875,
      "bbox_min": [
        -4358.3671875,
        -3491.567138671875,
        995.0011596679688
      ],
      "bbox_max": [
        -4306.07080078125,
        -3431.590087890625,
        1010.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6795778274536133,
        -0.6228265166282654,
        0.38763535022735596
      ],
      "plane_d": 397.107421875,
      "bbox_min": [
        -4358.3671875,
        -3491.567138671875,
        995.0011596679688
      ],
      "bbox_max": [
        -4316.0537109375,
        -3445.42919921875,
        1010.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16617104411125183,
        0.911422848701477,
        -0.37642475962638855
      ],
      "plane_d": 2760.78466796875,
      "bbox_min": [
        -4340.5546875,
        -3479.203125,
        995.0011596679688
      ],
      "bbox_max": [
        -4022.39990234375,
        -3338.300048828125,
        1027.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.678257405757904,
        -0.6209643483161926,
        0.3928998112678528
      ],
      "plane_d": 392.5263671875,
      "bbox_min": [
        -4316.0537109375,
        -3445.42919921875,
        1006.0745239257812
      ],
      "bbox_max": [
        -4304.140625,
        -3429.48291015625,
        1010.9518432617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16617104411125183,
        0.911422848701477,
        -0.37642475962638855
      ],
      "plane_d": 2760.78466796875,
      "bbox_min": [
        -4336.22607421875,
        -3474.480224609375,
        995.0011596679688
      ],
      "bbox_max": [
        -4022.39990234375,
        -3321.199951171875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6795778274536133,
        -0.6228265166282654,
        0.38763535022735596
      ],
      "plane_d": 397.107421875,
      "bbox_min": [
        -4336.22607421875,
        -3474.480224609375,
        995.0011596679688
      ],
      "bbox_max": [
        -4266.6083984375,
        -3389.658447265625,
        1010.9500732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.678257405757904,
        -0.6209643483161926,
        0.3928998112678528
      ],
      "plane_d": 392.5263671875,
      "bbox_min": [
        -4313.90185546875,
        -3443.229736328125,
        1001.7840576171875
      ],
      "bbox_max": [
        -4266.6083984375,
        -3389.658447265625,
        1010.9500732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06760953366756439,
        -0.3610876500606537,
        -0.9300777912139893
      ],
      "plane_d": 34.036712646484375,
      "bbox_min": [
        -4267.6611328125,
        -3391.267333984375,
        1006.556640625
      ],
      "bbox_max": [
        -4022.39990234375,
        -3321.199951171875,
        1033.6243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.678257405757904,
        -0.6209643483161926,
        0.3928998112678528
      ],
      "plane_d": 392.5263671875,
      "bbox_min": [
        -4267.6611328125,
        -3391.267333984375,
        1006.556640625
      ],
      "bbox_max": [
        -4199.7412109375,
        -3338.3056640625,
        1026.997802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17613600194454193,
        -0.90701824426651,
        -0.38248395919799805
      ],
      "plane_d": -1895.344482421875,
      "bbox_min": [
        -4214.12890625,
        -3341.033203125,
        1026.079345703125
      ],
      "bbox_max": [
        -4207.80712890625,
        -3339.6298828125,
        1026.9976806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9161460995674133,
        0.4008445143699646
      ],
      "plane_d": 2659.52978515625,
      "bbox_min": [
        -4287.40185546875,
        -3421.20703125,
        995.0011596679688
      ],
      "bbox_max": [
        -3769.39990234375,
        -3264.60009765625,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1661759316921234,
        0.9114212393760681,
        0.37642672657966614
      ],
      "plane_d": 1999.62646484375,
      "bbox_min": [
        -4287.40185546875,
        -3421.20703125,
        995.0011596679688
      ],
      "bbox_max": [
        -4022.39990234375,
        -3338.300048828125,
        1022.3770751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1627221256494522,
        0.9039356708526611,
        0.3955020606517792
      ],
      "plane_d": 1969.5501708984375,
      "bbox_min": [
        -4287.40185546875,
        -3421.20703125,
        995.0011596679688
      ],
      "bbox_max": [
        -4022.39990234375,
        -3338.300048828125,
        1011.4553833007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6795778274536133,
        -0.6228265166282654,
        0.38763535022735596
      ],
      "plane_d": 397.107421875,
      "bbox_min": [
        -4287.40185546875,
        -3421.20703125,
        995.0011596679688
      ],
      "bbox_max": [
        -4249.34033203125,
        -3379.67724609375,
        1007.92724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.678257405757904,
        -0.6209643483161926,
        0.3928998112678528
      ],
      "plane_d": 392.5263671875,
      "bbox_min": [
        -4275.16455078125,
        -3403.6328125,
        999.4902954101562
      ],
      "bbox_max": [
        -4254.45458984375,
        -3382.463623046875,
        1007.92724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16272127628326416,
        0.9039468169212341,
        -0.39547672867774963
      ],
      "plane_d": 2769.270263671875,
      "bbox_min": [
        -4192.1611328125,
        -3375.859375,
        1010.9993896484375
      ],
      "bbox_max": [
        -4022.39990234375,
        -3345.300048828125,
        1011.4553833007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16272127628326416,
        0.9039468169212341,
        -0.39547672867774963
      ],
      "plane_d": 2769.270263671875,
      "bbox_min": [
        -4264.15087890625,
        -3387.71630859375,
        995.0011596679688
      ],
      "bbox_max": [
        -4024.613525390625,
        -3338.300048828125,
        1022.3770751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16617104411125183,
        0.911422848701477,
        -0.37642475962638855
      ],
      "plane_d": 2760.78466796875,
      "bbox_min": [
        -4192.56787109375,
        -3375.859375,
        1010.9993896484375
      ],
      "bbox_max": [
        -4075.737548828125,
        -3350.100830078125,
        1022.3770751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6795778274536133,
        -0.6228265166282654,
        0.38763535022735596
      ],
      "plane_d": 397.107421875,
      "bbox_min": [
        -4254.45458984375,
        -3382.463623046875,
        995.0011596679688
      ],
      "bbox_max": [
        -4213.92333984375,
        -3341.033203125,
        999.4902954101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6782577633857727,
        -0.6209645867347717,
        -0.39289847016334534
      ],
      "plane_d": 1186.9688720703125,
      "bbox_min": [
        -4258.64306640625,
        -3379.756591796875,
        995.0011596679688
      ],
      "bbox_max": [
        -4199.7119140625,
        -3338.300048828125,
        1022.3770751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1761336326599121,
        -0.9070183038711548,
        0.38248494267463684
      ],
      "plane_d": -2668.737548828125,
      "bbox_min": [
        -4214.712890625,
        -3341.033203125,
        995.0011596679688
      ],
      "bbox_max": [
        -4203.6474609375,
        -3338.67578125,
        998.3604736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9161573648452759,
        -0.4008188545703888
      ],
      "plane_d": 3470.049072265625,
      "bbox_min": [
        -4227.09716796875,
        -3350.278076171875,
        995.0011596679688
      ],
      "bbox_max": [
        -3769.39990234375,
        -3264.60009765625,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16272127628326416,
        0.9039468169212341,
        -0.39547672867774963
      ],
      "plane_d": 2769.270263671875,
      "bbox_min": [
        -4227.09716796875,
        -3350.278076171875,
        1010.9993896484375
      ],
      "bbox_max": [
        -4022.39990234375,
        -3338.300048828125,
        1027.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16617104411125183,
        0.911422848701477,
        -0.37642475962638855
      ],
      "plane_d": 2760.78466796875,
      "bbox_min": [
        -4077.6240234375,
        -3350.27783203125,
        1021.9727172851562
      ],
      "bbox_max": [
        -4022.39990234375,
        -3338.300048828125,
        1027.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6782577633857727,
        -0.6209645867347717,
        -0.39289847016334534
      ],
      "plane_d": 1186.9688720703125,
      "bbox_min": [
        -4227.09716796875,
        -3350.278076171875,
        1010.9993896484375
      ],
      "bbox_max": [
        -4199.7412109375,
        -3338.3056640625,
        1026.997802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17613600194454193,
        -0.90701824426651,
        -0.38248395919799805
      ],
      "plane_d": -1895.344482421875,
      "bbox_min": [
        -4214.71240234375,
        -3340.6875,
        1023.639404296875
      ],
      "bbox_max": [
        -4199.7412109375,
        -3338.3056640625,
        1026.997802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1731167435646057,
        -0.9001373648643494,
        -0.39972883462905884
      ],
      "plane_d": -1867.36767578125,
      "bbox_min": [
        -4207.80712890625,
        -3339.630126953125,
        1026.139404296875
      ],
      "bbox_max": [
        -4199.7412109375,
        -3338.3056640625,
        1026.997802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.36191579699516296,
        -0.9322108626365662
      ],
      "plane_d": -238.46160888671875,
      "bbox_min": [
        -4227.09716796875,
        -3345.2998046875,
        995.0011596679688
      ],
      "bbox_max": [
        -3769.39990234375,
        -3264.60009765625,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0033072875812649727,
        -0.9999945759773254
      ],
      "plane_d": 1015.0679321289062,
      "bbox_min": [
        -4002.39990234375,
        -3301.60595703125,
        1011.6259765625
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1025.992919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.47210460901260376,
        -0.8815426230430603
      ],
      "plane_d": -649.3966674804688,
      "bbox_min": [
        -4002.39990234375,
        -3301.60595703125,
        1011.6259765625
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1025.992919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1019.7999877929688,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1011.6766357421875
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.9575546383857727,
        -0.28825193643569946
      ],
      "plane_d": -2832.092529296875,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1011.6766357421875
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.94633549451828,
        0.0,
        -0.3231859505176544
      ],
      "plane_d": -3380.050537109375,
      "bbox_min": [
        -3940.00048828125,
        -3264.61962890625,
        1019.7349243164062
      ],
      "bbox_max": [
        -3919.978271484375,
        -3264.60009765625,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3940.000244140625,
      "bbox_min": [
        -3940.00048828125,
        -3264.61962890625,
        1019.735107421875
      ],
      "bbox_max": [
        -3940.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1016.6237182617188,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1011.6766357421875
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3980.000244140625,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1016.623779296875
      ],
      "bbox_max": [
        -3980.00048828125,
        -3264.60009765625,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3980.000244140625,
      "bbox_min": [
        -3980.00048828125,
        -3273.837646484375,
        1011.6766357421875
      ],
      "bbox_max": [
        -3896.89990234375,
        -3264.60009765625,
        1016.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3896.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3273.793212890625,
        1011.6766967773438
      ],
      "bbox_max": [
        -3896.89990234375,
        -3264.60009765625,
        1016.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3898.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3270.8056640625,
        1011.9979248046875
      ],
      "bbox_max": [
        -3896.89990234375,
        -3265.199951171875,
        1015.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1015.0,
      "bbox_min": [
        -3898.89990234375,
        -3270.8056640625,
        1011.9979248046875
      ],
      "bbox_max": [
        -3896.89990234375,
        -3265.199951171875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0001220703125,
        -1.0,
        -4.209329927107319e-05
      ],
      "plane_d": -3265.63330078125,
      "bbox_min": [
        -3898.89990234375,
        -3265.2001953125,
        1011.9979248046875
      ],
      "bbox_max": [
        -3896.89990234375,
        -3265.199951171875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -2.740734998951666e-05,
        2.2878630261402577e-06
      ],
      "plane_d": -3880.0927734375,
      "bbox_min": [
        -4002.39990234375,
        -3301.60595703125,
        1011.6259765625
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1025.992919921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 4002.39990234375,
      "bbox_min": [
        -4002.39990234375,
        -3301.60595703125,
        1011.6259765625
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1025.992919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9577640295028687,
        -0.2875555753707886
      ],
      "plane_d": -2847.9951171875,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1011.6259765625
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1016.6237182617188,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1011.6259765625
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3980.000244140625,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1016.623779296875
      ],
      "bbox_max": [
        -3980.00048828125,
        -3273.837646484375,
        1019.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3276.800048828125,
      "bbox_min": [
        -3898.89990234375,
        -3277.411865234375,
        1011.6260375976562
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1016.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3898.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3277.411865234375,
        1016.3624267578125
      ],
      "bbox_max": [
        -3898.89990234375,
        -3276.800048828125,
        1016.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3898.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3276.800048828125,
        1011.6260375976562
      ],
      "bbox_max": [
        -3896.89990234375,
        -3264.60009765625,
        1016.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3896.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3276.800048828125,
        1011.6260375976562
      ],
      "bbox_max": [
        -3896.89990234375,
        -3264.60009765625,
        1016.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1015.0,
      "bbox_min": [
        -3898.89990234375,
        -3273.290771484375,
        1011.85888671875
      ],
      "bbox_max": [
        -3896.89990234375,
        -3265.199951171875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0001220703125,
        -1.0,
        -4.209329927107319e-05
      ],
      "plane_d": -3265.63330078125,
      "bbox_min": [
        -3898.89990234375,
        -3265.2001953125,
        1011.85888671875
      ],
      "bbox_max": [
        -3896.89990234375,
        -3265.199951171875,
        1011.9981079101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1761336326599121,
        -0.9070183038711548,
        0.38248494267463684
      ],
      "plane_d": -2668.737548828125,
      "bbox_min": [
        -4227.09716796875,
        -3345.2998046875,
        995.0011596679688
      ],
      "bbox_max": [
        -3880.0,
        -3264.60009765625,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.010009762831032276,
        0.9999499917030334
      ],
      "plane_d": -1037.9794921875,
      "bbox_min": [
        -4002.39990234375,
        -3295.723876953125,
        1005.040283203125
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1021.0828857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1005.2000122070312,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1005.3519287109375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9575546383857727,
        0.28825193643569946
      ],
      "plane_d": -3415.802734375,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1005.3519287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3896.89990234375,
      "bbox_min": [
        -3940.00048828125,
        -3264.619873046875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1005.2658081054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3940.000244140625,
      "bbox_min": [
        -3940.00048828125,
        -3264.61962890625,
        1005.2000122070312
      ],
      "bbox_max": [
        -3940.00048828125,
        -3264.60009765625,
        1005.264892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3880.00048828125,
      "bbox_min": [
        -3880.00048828125,
        -3264.619873046875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1005.2658081054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3980.000244140625,
      "bbox_min": [
        -3980.00048828125,
        -3279.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1005.3519287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3896.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3275.557861328125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1005.3518676757812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3898.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3275.557861328125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3898.89990234375,
        -3265.2001953125,
        1005.3458862304688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3880.00048828125,
      "bbox_min": [
        -3880.00048828125,
        -3271.887939453125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1005.3518676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 4002.39990234375,
      "bbox_min": [
        -4002.39990234375,
        -3295.723876953125,
        1005.040283203125
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1021.0828857421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3898.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3275.5400390625,
        1005.242431640625
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1014.377685546875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3896.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3275.150146484375,
        1005.246337890625
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1013.1533203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0001220703125,
        -1.0,
        -4.209329927107319e-05
      ],
      "plane_d": -3265.63330078125,
      "bbox_min": [
        -3898.89990234375,
        -3265.2001953125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3896.89990234375,
        -3265.199951171875,
        1011.8589477539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3880.00048828125,
      "bbox_min": [
        -3880.00048828125,
        -3271.8544921875,
        1005.2793579101562
      ],
      "bbox_max": [
        -3880.00048828125,
        -3264.60009765625,
        1013.1533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17613600194454193,
        -0.90701824426651,
        -0.38248395919799805
      ],
      "plane_d": -1895.344482421875,
      "bbox_min": [
        -4227.09716796875,
        -3345.2998046875,
        995.0011596679688
      ],
      "bbox_max": [
        -3880.0,
        -3268.5341796875,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 4002.39990234375,
      "bbox_min": [
        -4002.39990234375,
        -3299.127685546875,
        1010.9994506835938
      ],
      "bbox_max": [
        -3880.00048828125,
        -3268.5341796875,
        1025.03076171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3898.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3274.799072265625,
        1011.0
      ],
      "bbox_max": [
        -3880.00048828125,
        -3268.5341796875,
        1015.519775390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3880.00048828125,
      "bbox_min": [
        -3898.89990234375,
        -3274.799072265625,
        1011.0003051757812
      ],
      "bbox_max": [
        -3880.00048828125,
        -3268.5341796875,
        1015.519775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3896.89990234375,
      "bbox_min": [
        -3896.89990234375,
        -3274.629638671875,
        1015.0
      ],
      "bbox_max": [
        -3896.89990234375,
        -3273.290771484375,
        1015.519775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1731167435646057,
        -0.9001373648643494,
        -0.39972883462905884
      ],
      "plane_d": -1867.36767578125,
      "bbox_min": [
        -4227.09716796875,
        -3345.2998046875,
        995.0011596679688
      ],
      "bbox_max": [
        -3880.0,
        -3269.442138671875,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 4002.39990234375,
      "bbox_min": [
        -4002.39990234375,
        -3299.55224609375,
        1010.6926879882812
      ],
      "bbox_max": [
        -3880.00048828125,
        -3269.442138671875,
        1025.195556640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3898.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3275.500244140625,
        1010.6926879882812
      ],
      "bbox_max": [
        -3880.00048828125,
        -3269.442138671875,
        1015.8577880859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1015.0,
      "bbox_min": [
        -3898.89990234375,
        -3275.119140625,
        1015.0
      ],
      "bbox_max": [
        -3896.89990234375,
        -3274.410400390625,
        1015.6773071289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3896.89990234375,
      "bbox_min": [
        -3896.89990234375,
        -3275.035400390625,
        1015.0
      ],
      "bbox_max": [
        -3896.89990234375,
        -3274.410400390625,
        1015.6773071289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17310982942581177,
        -0.9001272320747375,
        0.3997548222541809
      ],
      "plane_d": -2675.64013671875,
      "bbox_min": [
        -4227.09716796875,
        -3345.2998046875,
        995.0011596679688
      ],
      "bbox_max": [
        -3880.0,
        -3269.57177734375,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.010009762831032276,
        0.9999499917030334
      ],
      "plane_d": -1037.9794921875,
      "bbox_min": [
        -4002.39990234375,
        -3295.89599609375,
        1005.03857421875
      ],
      "bbox_max": [
        -3880.00048828125,
        -3269.57177734375,
        1011.0010986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1005.2000122070312,
      "bbox_min": [
        -3920.582763671875,
        -3279.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3271.8544921875,
        1005.2793579101562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3896.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3275.919677734375,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.00048828125,
        -3271.8544921875,
        1005.2793579101562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 4002.39990234375,
      "bbox_min": [
        -4002.39990234375,
        -3295.89599609375,
        1005.03857421875
      ],
      "bbox_max": [
        -3880.00048828125,
        -3269.57177734375,
        1011.0010986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3880.00048828125,
      "bbox_min": [
        -3898.89990234375,
        -3275.902587890625,
        1005.23876953125
      ],
      "bbox_max": [
        -3880.00048828125,
        -3269.57177734375,
        1011.0010986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3896.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3275.902587890625,
        1005.23876953125
      ],
      "bbox_max": [
        -3896.89990234375,
        -3273.224609375,
        1011.0010375976562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3898.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3275.902587890625,
        1005.23876953125
      ],
      "bbox_max": [
        -3896.89990234375,
        -3273.224609375,
        1011.0010375976562
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1009.2000122070312,
      "bbox_min": [
        -3898.89990234375,
        -3274.143310546875,
        1009.2000122070312
      ],
      "bbox_max": [
        -3896.89990234375,
        -3273.48291015625,
        1009.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07287567853927612,
        -0.378876656293869,
        -0.9225733280181885
      ],
      "plane_d": -11.266357421875,
      "bbox_min": [
        -4227.09716796875,
        -3345.2998046875,
        998.3604736328125
      ],
      "bbox_max": [
        -3880.0,
        -3269.708740234375,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0033072875812649727,
        -0.9999945759773254
      ],
      "plane_d": 1015.0679321289062,
      "bbox_min": [
        -4227.09716796875,
        -3345.2998046875,
        998.3604736328125
      ],
      "bbox_max": [
        -3880.0,
        -3269.708740234375,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06760953366756439,
        -0.3610876500606537,
        -0.9300777912139893
      ],
      "plane_d": 34.036712646484375,
      "bbox_min": [
        -4113.39306640625,
        -3329.743896484375,
        1027.0
      ],
      "bbox_max": [
        -4022.39990234375,
        -3304.199951171875,
        1033.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.010009762831032276,
        0.9999499917030334
      ],
      "plane_d": -1037.9794921875,
      "bbox_min": [
        -4227.09716796875,
        -3345.2998046875,
        998.3604736328125
      ],
      "bbox_max": [
        -3880.0,
        -3269.708740234375,
        1026.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1005.2000122070312,
      "bbox_min": [
        -4220.79931640625,
        -3342.487548828125,
        998.3604736328125
      ],
      "bbox_max": [
        -3880.0,
        -3272.25146484375,
        1005.2753295898438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.678257405757904,
        -0.6209643483161926,
        0.3928998112678528
      ],
      "plane_d": 392.5263671875,
      "bbox_min": [
        -4220.79931640625,
        -3342.487548828125,
        998.3604736328125
      ],
      "bbox_max": [
        -4214.712890625,
        -3337.414794921875,
        1004.6229858398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3880.00048828125,
      "bbox_min": [
        -3898.89990234375,
        -3279.7685546875,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.0,
        -3272.25146484375,
        1005.2753295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3276.800048828125,
      "bbox_min": [
        -3898.89990234375,
        -3278.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3880.0,
        -3275.515869140625,
        1005.24267578125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3898.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3278.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3898.89990234375,
        -3276.800048828125,
        1005.2297973632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3898.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3276.800048828125,
        1005.2000122070312
      ],
      "bbox_max": [
        -3898.89990234375,
        -3275.902587890625,
        1005.23876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -2.740734998951666e-05,
        2.2878630261402577e-06
      ],
      "plane_d": -3880.0927734375,
      "bbox_min": [
        -4227.09716796875,
        -3345.2998046875,
        1004.5722045898438
      ],
      "bbox_max": [
        -3880.0,
        -3269.708740234375,
        1026.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6782577633857727,
        -0.6209645867347717,
        -0.39289847016334534
      ],
      "plane_d": 1186.9688720703125,
      "bbox_min": [
        -4227.09716796875,
        -3345.2998046875,
        1004.5722045898438
      ],
      "bbox_max": [
        -3880.0,
        -3273.343505859375,
        1026.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1016.6237182617188,
      "bbox_min": [
        -4227.09716796875,
        -3345.2998046875,
        1004.5722045898438
      ],
      "bbox_max": [
        -3880.0,
        -3273.343505859375,
        1026.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9577640295028687,
        -0.2875555753707886
      ],
      "plane_d": -2847.9951171875,
      "bbox_min": [
        -4002.39990234375,
        -3303.743896484375,
        1016.623779296875
      ],
      "bbox_max": [
        -3880.00048828125,
        -3278.81494140625,
        1026.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 4002.39990234375,
      "bbox_min": [
        -4002.39990234375,
        -3303.743896484375,
        1016.623779296875
      ],
      "bbox_max": [
        -4002.39990234375,
        -3295.74560546875,
        1026.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.678257405757904,
        -0.6209643483161926,
        0.3928998112678528
      ],
      "plane_d": 392.5263671875,
      "bbox_min": [
        -4227.09716796875,
        -3345.2998046875,
        1004.5722045898438
      ],
      "bbox_max": [
        -3880.0,
        -3273.343505859375,
        1016.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 4002.39990234375,
      "bbox_min": [
        -4002.39990234375,
        -3299.749267578125,
        1005.0
      ],
      "bbox_max": [
        -4002.39990234375,
        -3293.248291015625,
        1016.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3896.89990234375,
      "bbox_min": [
        -3898.89990234375,
        -3278.800048828125,
        1005.2097778320312
      ],
      "bbox_max": [
        -3880.0,
        -3273.343505859375,
        1016.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3275.2001953125,
      "bbox_min": [
        -3898.89990234375,
        -3275.2001953125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3896.89990234375,
        -3273.7587890625,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1009.2000122070312,
      "bbox_min": [
        -3898.89990234375,
        -3275.2001953125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3896.89990234375,
        -3273.7587890625,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1015.0,
      "bbox_min": [
        -3898.89990234375,
        -3275.2001953125,
        1015.0
      ],
      "bbox_max": [
        -3896.89990234375,
        -3274.734619140625,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3276.800048828125,
      "bbox_min": [
        -3896.89990234375,
        -3278.800048828125,
        1005.2297973632812
      ],
      "bbox_max": [
        -3880.0,
        -3276.800048828125,
        1016.3623657226562
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1009.2000122070312,
      "bbox_min": [
        -3894.0,
        -3278.800048828125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3882.60009765625,
        -3276.800048828125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1015.0,
      "bbox_min": [
        -3894.0,
        -3278.800048828125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3882.60009765625,
        -3276.800048828125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3882.60009765625,
      "bbox_min": [
        -3894.0,
        -3278.800048828125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3882.60009765625,
        -3276.800048828125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3894.0,
      "bbox_min": [
        -3894.0,
        -3278.800048828125,
        1009.2000122070312
      ],
      "bbox_max": [
        -3894.0,
        -3276.800048828125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1059.800048828125,
      "bbox_min": [
        -3746.4248046875,
        -3335.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3533.5,
        -3144.0,
        1090.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.11154443770647049,
        0.9937595129013062,
        -0.0
      ],
      "plane_d": 3717.53271484375,
      "bbox_min": [
        -3746.4248046875,
        -3335.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3533.5,
        -3155.313720703125,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09053575247526169,
        0.9958932995796204,
        0.0
      ],
      "plane_d": 2993.927001953125,
      "bbox_min": [
        -3746.4248046875,
        -3335.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3533.5,
        -3155.313720703125,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -280.77197265625,
      "bbox_min": [
        -3746.4248046875,
        -3319.356201171875,
        1059.800048828125
      ],
      "bbox_max": [
        -3657.0,
        -3155.313720703125,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1072.5999755859375,
      "bbox_min": [
        -3746.4248046875,
        -3276.677490234375,
        1059.800048828125
      ],
      "bbox_max": [
        -3657.0,
        -3155.313720703125,
        1090.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40413516759872437,
        -0.9146992564201355,
        -0.0
      ],
      "plane_d": -4383.72900390625,
      "bbox_min": [
        -3737.0,
        -3276.677490234375,
        1072.5999755859375
      ],
      "bbox_max": [
        -3657.0,
        -3155.313720703125,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40413516759872437,
        -0.9146992564201355,
        0.0
      ],
      "plane_d": -4368.3720703125,
      "bbox_min": [
        -3667.606689453125,
        -3160.0,
        1072.5999755859375
      ],
      "bbox_max": [
        -3657.0,
        -3155.313720703125,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500004231929779,
        0.8660230040550232,
        -0.0
      ],
      "plane_d": 4675.123046875,
      "bbox_min": [
        -3737.0,
        -3276.677490234375,
        1072.5999755859375
      ],
      "bbox_max": [
        -3700.109619140625,
        -3240.800048828125,
        1082.095947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3708.000244140625,
      "bbox_min": [
        -3715.890869140625,
        -3276.677490234375,
        1072.5999755859375
      ],
      "bbox_max": [
        -3700.109619140625,
        -3267.3779296875,
        1082.095947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3275.2685546875,
      "bbox_min": [
        -3708.000244140625,
        -3275.2685546875,
        1072.5999755859375
      ],
      "bbox_max": [
        -3700.109619140625,
        -3267.3779296875,
        1082.095947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4082728624343872,
        0.40822625160217285,
        -0.8164952397346497
      ],
      "plane_d": 3729.32763671875,
      "bbox_min": [
        -3708.000244140625,
        -3275.2685546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3700.109619140625,
        -3267.3779296875,
        1082.095947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3275.2685546875,
      "bbox_min": [
        -3715.890869140625,
        -3275.2685546875,
        1072.5999755859375
      ],
      "bbox_max": [
        -3708.000244140625,
        -3267.3779296875,
        1082.095947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40825355052948,
        0.40825355052948,
        -0.8164912462234497
      ],
      "plane_d": 701.7322998046875,
      "bbox_min": [
        -3715.890869140625,
        -3275.2685546875,
        1075.81884765625
      ],
      "bbox_max": [
        -3708.000244140625,
        -3267.3779296875,
        1082.095947265625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3738.0,
      "bbox_min": [
        -3746.4248046875,
        -3276.677490234375,
        1059.800048828125
      ],
      "bbox_max": [
        -3657.0,
        -3155.313720703125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40413516759872437,
        -0.9146992564201355,
        -0.0
      ],
      "plane_d": -4383.72900390625,
      "bbox_min": [
        -3738.0,
        -3276.677490234375,
        1059.800048828125
      ],
      "bbox_max": [
        -3657.0,
        -3155.313720703125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40413516759872437,
        -0.9146992564201355,
        0.0
      ],
      "plane_d": -4368.3720703125,
      "bbox_min": [
        -3667.606689453125,
        -3160.0,
        1059.800048828125
      ],
      "bbox_max": [
        -3657.0,
        -3155.313720703125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500004231929779,
        0.8660230040550232,
        -0.0
      ],
      "plane_d": 4675.123046875,
      "bbox_min": [
        -3738.0,
        -3276.677490234375,
        1059.800048828125
      ],
      "bbox_max": [
        -3706.591064453125,
        -3240.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3240.800048828125,
      "bbox_min": [
        -3738.0,
        -3276.677490234375,
        1059.800048828125
      ],
      "bbox_max": [
        -3706.591064453125,
        -3240.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3275.2685546875,
      "bbox_min": [
        -3709.409423828125,
        -3276.677490234375,
        1059.800048828125
      ],
      "bbox_max": [
        -3706.591064453125,
        -3273.859619140625,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3708.000244140625,
      "bbox_min": [
        -3708.000244140625,
        -3276.677490234375,
        1059.800048828125
      ],
      "bbox_max": [
        -3708.000244140625,
        -3275.2685546875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3708.000244140625,
      "bbox_min": [
        -3708.000244140625,
        -3275.2685546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3708.000244140625,
        -3273.859619140625,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -4909.30126953125,
      "bbox_min": [
        -3746.4248046875,
        -3240.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3738.0,
        -3196.375244140625,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3240.800048828125,
      "bbox_min": [
        -3746.4248046875,
        -3240.800048828125,
        1059.800048828125
      ],
      "bbox_max": [
        -3738.0,
        -3240.800048828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09458895772695541,
        0.842706561088562,
        0.5299986600875854
      ],
      "plane_d": 2574.761474609375,
      "bbox_min": [
        -3745.995849609375,
        -3385.25439453125,
        1090.0
      ],
      "bbox_max": [
        -3517.991455078125,
        -3324.0,
        1170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07677337527275085,
        0.8445155024528503,
        0.5299994349479675
      ],
      "plane_d": 1961.1470947265625,
      "bbox_min": [
        -3616.530517578125,
        -3385.25439453125,
        1090.0
      ],
      "bbox_max": [
        -3517.991455078125,
        -3327.5,
        1170.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 5433,
      "centroid": [
        -3770.00048828125,
        -3119.7843017578125,
        1059.800048828125
      ],
      "bbox_min": [
        -3776.00048828125,
        -3139.7685546875,
        1059.800048828125
      ],
      "bbox_max": [
        -3764.00048828125,
        -3099.800048828125,
        1059.800048828125
      ],
      "dimensions_source": {
        "span_x": 12.0,
        "span_y": 39.968505859375,
        "height_z": 0.0,
        "door_width": 39.968505859375,
        "door_depth": 12.0,
        "leaf_depth": 12.0,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          -3776.00048828125,
          -3099.800048828125,
          1059.800048828125
        ],
        [
          -3776.00048828125,
          -3099.800048828125,
          1059.800048828125
        ],
        [
          -3764.00048828125,
          -3099.800048828125,
          1059.800048828125
        ],
        [
          -3764.00048828125,
          -3099.800048828125,
          1059.800048828125
        ],
        [
          -3776.00048828125,
          -3139.7685546875,
          1059.800048828125
        ],
        [
          -3776.00048828125,
          -3139.7685546875,
          1059.800048828125
        ],
        [
          -3764.00048828125,
          -3139.7685546875,
          1059.800048828125
        ],
        [
          -3764.00048828125,
          -3139.7685546875,
          1059.800048828125
        ]
      ],
      "plane_distance": -1059.8,
      "authentic_texture": "metalgrate1-t"
    },
    {
      "tag": "CSlidingDoor piece: tldr",
      "entity_class": "CSlidingDoor",
      "piece_name": "tldr",
      "offset": 7583,
      "centroid": [
        -3860.50048828125,
        -3094.7685546875,
        1027.373779296875
      ],
      "bbox_min": [
        -3861.00048828125,
        -3099.7685546875,
        1022.123779296875
      ],
      "bbox_max": [
        -3860.00048828125,
        -3089.7685546875,
        1032.623779296875
      ],
      "dimensions_source": {
        "span_x": 1.0,
        "span_y": 10.0,
        "height_z": 10.5,
        "door_width": 10.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          -1.0,
          -0.0
        ]
      },
      "vertices": [
        [
          -3861.00048828125,
          -3089.7685546875,
          1022.123779296875
        ],
        [
          -3861.00048828125,
          -3089.7685546875,
          1032.623779296875
        ],
        [
          -3861.00048828125,
          -3099.7685546875,
          1032.623779296875
        ],
        [
          -3861.00048828125,
          -3099.7685546875,
          1022.123779296875
        ],
        [
          -3860.00048828125,
          -3089.7685546875,
          1022.123779296875
        ],
        [
          -3860.00048828125,
          -3089.7685546875,
          1032.623779296875
        ],
        [
          -3860.00048828125,
          -3099.7685546875,
          1032.623779296875
        ],
        [
          -3860.00048828125,
          -3099.7685546875,
          1022.123779296875
        ]
      ],
      "plane_distance": -3099.7686,
      "authentic_texture": "slidedoor3"
    },
    {
      "tag": "CSlidingDoor piece: trdr",
      "entity_class": "CSlidingDoor",
      "piece_name": "trdr",
      "offset": 8848,
      "centroid": [
        -3839.50048828125,
        -3094.7685546875,
        1027.373779296875
      ],
      "bbox_min": [
        -3840.00048828125,
        -3099.7685546875,
        1022.123779296875
      ],
      "bbox_max": [
        -3839.00048828125,
        -3089.7685546875,
        1032.623779296875
      ],
      "dimensions_source": {
        "span_x": 1.0,
        "span_y": 10.0,
        "height_z": 10.5,
        "door_width": 10.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          -1.0,
          -0.0
        ]
      },
      "vertices": [
        [
          -3840.00048828125,
          -3089.7685546875,
          1022.123779296875
        ],
        [
          -3840.00048828125,
          -3089.7685546875,
          1032.623779296875
        ],
        [
          -3840.00048828125,
          -3099.7685546875,
          1032.623779296875
        ],
        [
          -3840.00048828125,
          -3099.7685546875,
          1022.123779296875
        ],
        [
          -3839.00048828125,
          -3089.7685546875,
          1022.123779296875
        ],
        [
          -3839.00048828125,
          -3089.7685546875,
          1032.623779296875
        ],
        [
          -3839.00048828125,
          -3099.7685546875,
          1032.623779296875
        ],
        [
          -3839.00048828125,
          -3099.7685546875,
          1022.123779296875
        ]
      ],
      "plane_distance": -3099.7686,
      "authentic_texture": "slidedoor3"
    },
    {
      "tag": "CSlidingDoor piece: watdrl",
      "entity_class": "CSlidingDoor",
      "piece_name": "watdrl",
      "offset": 11427,
      "centroid": [
        -3847.5,
        -3085.75,
        1026.3499755859375
      ],
      "bbox_min": [
        -3850.0,
        -3086.699951171875,
        1020.0999755859375
      ],
      "bbox_max": [
        -3845.0,
        -3084.800048828125,
        1032.5999755859375
      ],
      "dimensions_source": {
        "span_x": 5.0,
        "span_y": 1.89990234375,
        "height_z": 12.5,
        "door_width": 5.0,
        "door_depth": 1.89990234375,
        "leaf_depth": 1.85990234375,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3845.0,
          -3086.699951171875,
          1020.0999755859375
        ],
        [
          -3845.0,
          -3084.800048828125,
          1032.5999755859375
        ],
        [
          -3845.0,
          -3086.699951171875,
          1032.5999755859375
        ],
        [
          -3845.0,
          -3084.800048828125,
          1020.0999755859375
        ],
        [
          -3850.0,
          -3086.699951171875,
          1020.0999755859375
        ],
        [
          -3850.0,
          -3086.699951171875,
          1032.5999755859375
        ],
        [
          -3850.0,
          -3084.800048828125,
          1032.5999755859375
        ],
        [
          -3850.0,
          -3084.800048828125,
          1020.0999755859375
        ]
      ],
      "plane_distance": -3850.0,
      "authentic_texture": "slidedoor3"
    },
    {
      "tag": "CSlidingDoor piece: watdrr",
      "entity_class": "CSlidingDoor",
      "piece_name": "watdrr",
      "offset": 13133,
      "centroid": [
        -3852.5,
        -3085.75,
        1026.3499755859375
      ],
      "bbox_min": [
        -3855.0,
        -3086.699951171875,
        1020.0999755859375
      ],
      "bbox_max": [
        -3850.0,
        -3084.800048828125,
        1032.5999755859375
      ],
      "dimensions_source": {
        "span_x": 5.0,
        "span_y": 1.89990234375,
        "height_z": 12.5,
        "door_width": 5.0,
        "door_depth": 1.89990234375,
        "leaf_depth": 1.85990234375,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3855.0,
          -3086.699951171875,
          1020.0999755859375
        ],
        [
          -3855.0,
          -3084.800048828125,
          1032.5999755859375
        ],
        [
          -3855.0,
          -3086.699951171875,
          1032.5999755859375
        ],
        [
          -3855.0,
          -3084.800048828125,
          1020.0999755859375
        ],
        [
          -3850.0,
          -3086.699951171875,
          1020.0999755859375
        ],
        [
          -3850.0,
          -3086.699951171875,
          1032.5999755859375
        ],
        [
          -3850.0,
          -3084.800048828125,
          1032.5999755859375
        ],
        [
          -3850.0,
          -3084.800048828125,
          1020.0999755859375
        ]
      ],
      "plane_distance": 3850.0,
      "authentic_texture": "slidedoor3"
    },
    {
      "tag": "CSlidingDoor piece: in1srmdr",
      "entity_class": "CSlidingDoor",
      "piece_name": "in1srmdr",
      "offset": 14825,
      "centroid": [
        -3955.75,
        -3090.0,
        1022.5000305175781
      ],
      "bbox_min": [
        -3956.5,
        -3100.0,
        1015.2000122070312
      ],
      "bbox_max": [
        -3955.0,
        -3080.0,
        1029.800048828125
      ],
      "dimensions_source": {
        "span_x": 1.5,
        "span_y": 20.0,
        "height_z": 14.60003662109375,
        "door_width": 20.0,
        "door_depth": 1.5,
        "leaf_depth": 1.46,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3956.5,
          -3100.0,
          1029.800048828125
        ],
        [
          -3956.5,
          -3100.0,
          1015.2000122070312
        ],
        [
          -3956.5,
          -3080.0,
          1029.800048828125
        ],
        [
          -3956.5,
          -3080.0,
          1015.2000122070312
        ],
        [
          -3955.0,
          -3100.0,
          1029.800048828125
        ],
        [
          -3955.0,
          -3100.0,
          1015.2000122070312
        ],
        [
          -3955.0,
          -3080.0,
          1029.800048828125
        ],
        [
          -3955.0,
          -3080.0,
          1015.2000122070312
        ]
      ],
      "plane_distance": -3100.0,
      "authentic_texture": "slidedoor1"
    },
    {
      "tag": "CSlidingDoor piece: rech",
      "entity_class": "CSlidingDoor",
      "piece_name": "rech",
      "offset": 16008,
      "centroid": [
        -3730.5,
        -3088.699951171875,
        1016.0
      ],
      "bbox_min": [
        -3732.0,
        -3088.699951171875,
        1015.0
      ],
      "bbox_max": [
        -3729.0,
        -3088.699951171875,
        1017.0
      ],
      "dimensions_source": {
        "span_x": 3.0,
        "span_y": 0.0,
        "height_z": 2.0,
        "door_width": 3.0,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3732.0,
          -3088.699951171875,
          1015.0
        ],
        [
          -3729.0,
          -3088.699951171875,
          1017.0
        ],
        [
          -3729.0,
          -3088.699951171875,
          1015.0
        ],
        [
          -3732.0,
          -3088.699951171875,
          1017.0
        ]
      ],
      "plane_distance": 3088.7,
      "authentic_texture": "traindr"
    },
    {
      "tag": "CSlidingDoor piece: secmsgdr",
      "entity_class": "CSlidingDoor",
      "piece_name": "secmsgdr",
      "offset": 18978,
      "centroid": [
        -3789.5,
        -3231.909912109375,
        1059.880126953125
      ],
      "bbox_min": [
        -3792.0,
        -3233.35986328125,
        1059.880126953125
      ],
      "bbox_max": [
        -3787.0,
        -3230.4599609375,
        1059.880126953125
      ],
      "dimensions_source": {
        "span_x": 5.0,
        "span_y": 2.89990234375,
        "height_z": 0.0,
        "door_width": 5.0,
        "door_depth": 2.89990234375,
        "leaf_depth": 2.85990234375,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          -3792.0,
          -3233.35986328125,
          1059.880126953125
        ],
        [
          -3787.0,
          -3230.4599609375,
          1059.880126953125
        ],
        [
          -3792.0,
          -3230.4599609375,
          1059.880126953125
        ],
        [
          -3787.0,
          -3233.35986328125,
          1059.880126953125
        ]
      ],
      "plane_distance": -1059.8801
    }
  ],
  "tutorial_messages": []
}